import * as l from "react";
import _, { useState as Jt, useEffect as ui, createContext as Pm, useContext as _m, useCallback as Re, useRef as zn, useLayoutEffect as fi, useMemo as Xo } from "react";
import { jsx as c, Fragment as Se, jsxs as z } from "react/jsx-runtime";
import * as cn from "react-dom";
import pi from "react-dom";
import { ChevronDownIcon as ln, MoreHorizontal as Tm, ChevronRight as mi, ChevronLeftIcon as Am, ChevronRightIcon as io, ArrowRight as Dm, ArrowLeft as Im, CheckIcon as dn, XIcon as vi, SearchIcon as Om, CircleIcon as co, Minus as km, ChevronLeft as $m, GripVerticalIcon as Lm, ChevronUpIcon as Fm, PanelLeftIcon as Wm, X as zm } from "lucide-react";
import { twMerge as Bm } from "tailwind-merge";
import { cva as et } from "class-variance-authority";
import { addDays as Vm, addMonths as Hm, addWeeks as Gm, addYears as Km, differenceInCalendarDays as Um, differenceInCalendarMonths as Ym, eachMonthOfInterval as jm, endOfISOWeek as Xm, endOfMonth as qm, endOfWeek as Zm, endOfYear as Jm, format as Qm, getISOWeek as ev, getMonth as tv, getYear as nv, getWeek as ov, isAfter as rv, isBefore as av, isDate as sv, isSameDay as iv, isSameMonth as cv, isSameYear as lv, max as dv, min as uv, setMonth as fv, setYear as pv, startOfDay as mv, startOfISOWeek as vv, startOfMonth as hv, startOfWeek as gv, startOfYear as bv } from "date-fns";
import wv from "embla-carousel-react";
import { Command as Ct } from "cmdk";
import { FormProvider as yv, Controller as xv, useFormContext as Cv, useFormState as Sv } from "react-hook-form";
import { OTPInput as Ev, OTPInputContext as Mv } from "input-otp";
import * as Kr from "react-resizable-panels";
import { useTheme as Rv } from "next-themes";
import { Toaster as Nv } from "sonner";
const qo = 768;
function Pv() {
  const [e, t] = l.useState(
    void 0
  );
  return l.useEffect(() => {
    const n = window.matchMedia(`(max-width: ${qo - 1}px)`), o = () => {
      t(window.innerWidth < qo);
    };
    return n.addEventListener("change", o), t(window.innerWidth < qo), () => n.removeEventListener("change", o);
  }, []), !!e;
}
function f_() {
  const [e, t] = Jt(!1);
  return ui(() => {
    if (typeof window > "u") return;
    const n = () => t(window.innerHeight <= 800);
    return n(), window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), e;
}
function _v(e, t) {
  const n = l.createContext(t), o = (a) => {
    const { children: i, ...s } = a, d = l.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ c(n.Provider, { value: d, children: i });
  };
  o.displayName = e + "Provider";
  function r(a) {
    const i = l.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [o, r];
}
function Q(e, t = []) {
  let n = [];
  function o(a, i) {
    const s = l.createContext(i), d = n.length;
    n = [...n, i];
    const f = (p) => {
      const { scope: m, children: h, ...g } = p, v = m?.[e]?.[d] || s, b = l.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ c(v.Provider, { value: b, children: h });
    };
    f.displayName = a + "Provider";
    function u(p, m) {
      const h = m?.[e]?.[d] || s, g = l.useContext(h);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${p}\` must be used within \`${a}\``);
    }
    return [f, u];
  }
  const r = () => {
    const a = n.map((i) => l.createContext(i));
    return function(s) {
      const d = s?.[e] || a;
      return l.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: d } }),
        [s, d]
      );
    };
  };
  return r.scopeName = e, [o, Tv(r, ...t)];
}
function Tv(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = o.reduce((s, { useScope: d, scopeName: f }) => {
        const p = d(a)[`__scope${f}`];
        return { ...s, ...p };
      }, {});
      return l.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function xs(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function un(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const a = xs(r, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const a = o[r];
          typeof a == "function" ? a() : xs(e[r], null);
        }
      };
  };
}
function W(...e) {
  return l.useCallback(un(...e), e);
}
// @__NO_SIDE_EFFECTS__
function it(e) {
  const t = /* @__PURE__ */ Av(e), n = l.forwardRef((o, r) => {
    const { children: a, ...i } = o, s = l.Children.toArray(a), d = s.find(Dv);
    if (d) {
      const f = d.props.children, u = s.map((p) => p === d ? l.Children.count(f) > 1 ? l.Children.only(null) : l.isValidElement(f) ? f.props.children : null : p);
      return /* @__PURE__ */ c(t, { ...i, ref: r, children: l.isValidElement(f) ? l.cloneElement(f, void 0, u) : null });
    }
    return /* @__PURE__ */ c(t, { ...i, ref: r, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var dt = /* @__PURE__ */ it("Slot");
// @__NO_SIDE_EFFECTS__
function Av(e) {
  const t = l.forwardRef((n, o) => {
    const { children: r, ...a } = n;
    if (l.isValidElement(r)) {
      const i = Ov(r), s = Iv(a, r.props);
      return r.type !== l.Fragment && (s.ref = o ? un(o, i) : i), l.cloneElement(r, s);
    }
    return l.Children.count(r) > 1 ? l.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var hi = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function gi(e) {
  const t = ({ children: n }) => /* @__PURE__ */ c(Se, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = hi, t;
}
function Dv(e) {
  return l.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === hi;
}
function Iv(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...s) => {
      const d = a(...s);
      return r(...s), d;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Ov(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function tt(e) {
  const t = e + "CollectionProvider", [n, o] = Q(t), [r, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (v) => {
    const { scope: b, children: w } = v, y = _.useRef(null), x = _.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ c(r, { scope: b, itemMap: x, collectionRef: y, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", d = /* @__PURE__ */ it(s), f = _.forwardRef(
    (v, b) => {
      const { scope: w, children: y } = v, x = a(s, w), E = W(b, x.collectionRef);
      return /* @__PURE__ */ c(d, { ref: E, children: y });
    }
  );
  f.displayName = s;
  const u = e + "CollectionItemSlot", p = "data-radix-collection-item", m = /* @__PURE__ */ it(u), h = _.forwardRef(
    (v, b) => {
      const { scope: w, children: y, ...x } = v, E = _.useRef(null), S = W(b, E), R = a(u, w);
      return _.useEffect(() => (R.itemMap.set(E, { ref: E, ...x }), () => void R.itemMap.delete(E))), /* @__PURE__ */ c(m, { [p]: "", ref: S, children: y });
    }
  );
  h.displayName = u;
  function g(v) {
    const b = a(e + "CollectionConsumer", v);
    return _.useCallback(() => {
      const y = b.collectionRef.current;
      if (!y) return [];
      const x = Array.from(y.querySelectorAll(`[${p}]`));
      return Array.from(b.itemMap.values()).sort(
        (R, M) => x.indexOf(R.ref.current) - x.indexOf(M.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: f, ItemSlot: h },
    g,
    o
  ];
}
function N(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e?.(r), n === !1 || !r.defaultPrevented)
      return t?.(r);
  };
}
var oe = globalThis?.document ? l.useLayoutEffect : () => {
}, kv = l[" useInsertionEffect ".trim().toString()] || oe;
function ne({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: o
}) {
  const [r, a, i] = $v({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, d = s ? e : r;
  {
    const u = l.useRef(e !== void 0);
    l.useEffect(() => {
      const p = u.current;
      p !== s && console.warn(
        `${o} is changing from ${p ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, o]);
  }
  const f = l.useCallback(
    (u) => {
      if (s) {
        const p = Lv(u) ? u(e) : u;
        p !== e && i.current?.(p);
      } else
        a(u);
    },
    [s, e, a, i]
  );
  return [d, f];
}
function $v({
  defaultProp: e,
  onChange: t
}) {
  const [n, o] = l.useState(e), r = l.useRef(n), a = l.useRef(t);
  return kv(() => {
    a.current = t;
  }, [t]), l.useEffect(() => {
    r.current !== n && (a.current?.(n), r.current = n);
  }, [n, r]), [n, o, a];
}
function Lv(e) {
  return typeof e == "function";
}
var Fv = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], A = Fv.reduce((e, t) => {
  const n = /* @__PURE__ */ it(`Primitive.${t}`), o = l.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, d = i ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(d, { ...s, ref: a });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Qt(e, t) {
  e && cn.flushSync(() => e.dispatchEvent(t));
}
function Wv(e, t) {
  return l.useReducer((n, o) => t[n][o] ?? n, e);
}
var ee = (e) => {
  const { present: t, children: n } = e, o = zv(t), r = typeof n == "function" ? n({ present: o.isPresent }) : l.Children.only(n), a = W(o.ref, Bv(r));
  return typeof n == "function" || o.isPresent ? l.cloneElement(r, { ref: a }) : null;
};
ee.displayName = "Presence";
function zv(e) {
  const [t, n] = l.useState(), o = l.useRef(null), r = l.useRef(e), a = l.useRef("none"), i = e ? "mounted" : "unmounted", [s, d] = Wv(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return l.useEffect(() => {
    const f = An(o.current);
    a.current = s === "mounted" ? f : "none";
  }, [s]), oe(() => {
    const f = o.current, u = r.current;
    if (u !== e) {
      const m = a.current, h = An(f);
      e ? d("MOUNT") : h === "none" || f?.display === "none" ? d("UNMOUNT") : d(u && m !== h ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, d]), oe(() => {
    if (t) {
      let f;
      const u = t.ownerDocument.defaultView ?? window, p = (h) => {
        const v = An(o.current).includes(CSS.escape(h.animationName));
        if (h.target === t && v && (d("ANIMATION_END"), !r.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", f = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, m = (h) => {
        h.target === t && (a.current = An(o.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", p), t.addEventListener("animationend", p), () => {
        u.clearTimeout(f), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", p), t.removeEventListener("animationend", p);
      };
    } else
      d("ANIMATION_END");
  }, [t, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: l.useCallback((f) => {
      o.current = f ? getComputedStyle(f) : null, n(f);
    }, [])
  };
}
function An(e) {
  return e?.animationName || "none";
}
function Bv(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Vv = l[" useId ".trim().toString()] || (() => {
}), Hv = 0;
function le(e) {
  const [t, n] = l.useState(Vv());
  return oe(() => {
    n((o) => o ?? String(Hv++));
  }, [e]), t ? `radix-${t}` : "";
}
var lo = "Collapsible", [Gv, bi] = Q(lo), [Kv, Ur] = Gv(lo), wi = l.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: o,
      defaultOpen: r,
      disabled: a,
      onOpenChange: i,
      ...s
    } = e, [d, f] = ne({
      prop: o,
      defaultProp: r ?? !1,
      onChange: i,
      caller: lo
    });
    return /* @__PURE__ */ c(
      Kv,
      {
        scope: n,
        disabled: a,
        contentId: le(),
        open: d,
        onOpenToggle: l.useCallback(() => f((u) => !u), [f]),
        children: /* @__PURE__ */ c(
          A.div,
          {
            "data-state": qr(d),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
wi.displayName = lo;
var yi = "CollapsibleTrigger", Yr = l.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...o } = e, r = Ur(yi, n);
    return /* @__PURE__ */ c(
      A.button,
      {
        type: "button",
        "aria-controls": r.contentId,
        "aria-expanded": r.open || !1,
        "data-state": qr(r.open),
        "data-disabled": r.disabled ? "" : void 0,
        disabled: r.disabled,
        ...o,
        ref: t,
        onClick: N(e.onClick, r.onOpenToggle)
      }
    );
  }
);
Yr.displayName = yi;
var jr = "CollapsibleContent", Xr = l.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = Ur(jr, e.__scopeCollapsible);
    return /* @__PURE__ */ c(ee, { present: n || r.open, children: ({ present: a }) => /* @__PURE__ */ c(Uv, { ...o, ref: t, present: a }) });
  }
);
Xr.displayName = jr;
var Uv = l.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: o, children: r, ...a } = e, i = Ur(jr, n), [s, d] = l.useState(o), f = l.useRef(null), u = W(t, f), p = l.useRef(0), m = p.current, h = l.useRef(0), g = h.current, v = i.open || s, b = l.useRef(v), w = l.useRef(void 0);
  return l.useEffect(() => {
    const y = requestAnimationFrame(() => b.current = !1);
    return () => cancelAnimationFrame(y);
  }, []), oe(() => {
    const y = f.current;
    if (y) {
      w.current = w.current || {
        transitionDuration: y.style.transitionDuration,
        animationName: y.style.animationName
      }, y.style.transitionDuration = "0s", y.style.animationName = "none";
      const x = y.getBoundingClientRect();
      p.current = x.height, h.current = x.width, b.current || (y.style.transitionDuration = w.current.transitionDuration, y.style.animationName = w.current.animationName), d(o);
    }
  }, [i.open, o]), /* @__PURE__ */ c(
    A.div,
    {
      "data-state": qr(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !v,
      ...a,
      ref: u,
      style: {
        "--radix-collapsible-content-height": m ? `${m}px` : void 0,
        "--radix-collapsible-content-width": g ? `${g}px` : void 0,
        ...e.style
      },
      children: v && r
    }
  );
});
function qr(e) {
  return e ? "open" : "closed";
}
var xi = wi, Yv = Yr, jv = Xr, Xv = l.createContext(void 0);
function Oe(e) {
  const t = l.useContext(Xv);
  return e || t || "ltr";
}
var ke = "Accordion", qv = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Zr, Zv, Jv] = tt(ke), [uo, p_] = Q(ke, [
  Jv,
  bi
]), Jr = bi(), Ci = _.forwardRef(
  (e, t) => {
    const { type: n, ...o } = e, r = o, a = o;
    return /* @__PURE__ */ c(Zr.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ c(nh, { ...a, ref: t }) : /* @__PURE__ */ c(th, { ...r, ref: t }) });
  }
);
Ci.displayName = ke;
var [Si, Qv] = uo(ke), [Ei, eh] = uo(
  ke,
  { collapsible: !1 }
), th = _.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: o,
      onValueChange: r = () => {
      },
      collapsible: a = !1,
      ...i
    } = e, [s, d] = ne({
      prop: n,
      defaultProp: o ?? "",
      onChange: r,
      caller: ke
    });
    return /* @__PURE__ */ c(
      Si,
      {
        scope: e.__scopeAccordion,
        value: _.useMemo(() => s ? [s] : [], [s]),
        onItemOpen: d,
        onItemClose: _.useCallback(() => a && d(""), [a, d]),
        children: /* @__PURE__ */ c(Ei, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ c(Mi, { ...i, ref: t }) })
      }
    );
  }
), nh = _.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, s] = ne({
    prop: n,
    defaultProp: o ?? [],
    onChange: r,
    caller: ke
  }), d = _.useCallback(
    (u) => s((p = []) => [...p, u]),
    [s]
  ), f = _.useCallback(
    (u) => s((p = []) => p.filter((m) => m !== u)),
    [s]
  );
  return /* @__PURE__ */ c(
    Si,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: d,
      onItemClose: f,
      children: /* @__PURE__ */ c(Ei, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ c(Mi, { ...a, ref: t }) })
    }
  );
}), [oh, fo] = uo(ke), Mi = _.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: o, dir: r, orientation: a = "vertical", ...i } = e, s = _.useRef(null), d = W(s, t), f = Zv(n), p = Oe(r) === "ltr", m = N(e.onKeyDown, (h) => {
      if (!qv.includes(h.key)) return;
      const g = h.target, v = f().filter((P) => !P.ref.current?.disabled), b = v.findIndex((P) => P.ref.current === g), w = v.length;
      if (b === -1) return;
      h.preventDefault();
      let y = b;
      const x = 0, E = w - 1, S = () => {
        y = b + 1, y > E && (y = x);
      }, R = () => {
        y = b - 1, y < x && (y = E);
      };
      switch (h.key) {
        case "Home":
          y = x;
          break;
        case "End":
          y = E;
          break;
        case "ArrowRight":
          a === "horizontal" && (p ? S() : R());
          break;
        case "ArrowDown":
          a === "vertical" && S();
          break;
        case "ArrowLeft":
          a === "horizontal" && (p ? R() : S());
          break;
        case "ArrowUp":
          a === "vertical" && R();
          break;
      }
      const M = y % w;
      v[M].ref.current?.focus();
    });
    return /* @__PURE__ */ c(
      oh,
      {
        scope: n,
        disabled: o,
        direction: r,
        orientation: a,
        children: /* @__PURE__ */ c(Zr.Slot, { scope: n, children: /* @__PURE__ */ c(
          A.div,
          {
            ...i,
            "data-orientation": a,
            ref: d,
            onKeyDown: o ? void 0 : m
          }
        ) })
      }
    );
  }
), Kn = "AccordionItem", [rh, Qr] = uo(Kn), Ri = _.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: o, ...r } = e, a = fo(Kn, n), i = Qv(Kn, n), s = Jr(n), d = le(), f = o && i.value.includes(o) || !1, u = a.disabled || e.disabled;
    return /* @__PURE__ */ c(
      rh,
      {
        scope: n,
        open: f,
        disabled: u,
        triggerId: d,
        children: /* @__PURE__ */ c(
          xi,
          {
            "data-orientation": a.orientation,
            "data-state": Di(f),
            ...s,
            ...r,
            ref: t,
            disabled: u,
            open: f,
            onOpenChange: (p) => {
              p ? i.onItemOpen(o) : i.onItemClose(o);
            }
          }
        )
      }
    );
  }
);
Ri.displayName = Kn;
var Ni = "AccordionHeader", Pi = _.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = fo(ke, n), a = Qr(Ni, n);
    return /* @__PURE__ */ c(
      A.h3,
      {
        "data-orientation": r.orientation,
        "data-state": Di(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
Pi.displayName = Ni;
var vr = "AccordionTrigger", _i = _.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = fo(ke, n), a = Qr(vr, n), i = eh(vr, n), s = Jr(n);
    return /* @__PURE__ */ c(Zr.ItemSlot, { scope: n, children: /* @__PURE__ */ c(
      Yv,
      {
        "aria-disabled": a.open && !i.collapsible || void 0,
        "data-orientation": r.orientation,
        id: a.triggerId,
        ...s,
        ...o,
        ref: t
      }
    ) });
  }
);
_i.displayName = vr;
var Ti = "AccordionContent", Ai = _.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = fo(ke, n), a = Qr(Ti, n), i = Jr(n);
    return /* @__PURE__ */ c(
      jv,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": r.orientation,
        ...i,
        ...o,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
Ai.displayName = Ti;
function Di(e) {
  return e ? "open" : "closed";
}
var ah = Ci, sh = Ri, ih = Pi, ch = _i, lh = Ai;
function Ii(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = Ii(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function dh() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = Ii(e)) && (o && (o += " "), o += t);
  return o;
}
function C(...e) {
  return Bm(dh(e));
}
function m_({
  ...e
}) {
  return /* @__PURE__ */ c(ah, { "data-slot": "accordion", ...e });
}
function v_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    sh,
    {
      "data-slot": "accordion-item",
      className: C("border-b last:border-b-0", e),
      ...t
    }
  );
}
function h_({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ c(ih, { className: "flex", children: /* @__PURE__ */ z(
    ch,
    {
      "data-slot": "accordion-trigger",
      className: C(
        "focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ c(ln, { className: "text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200" })
      ]
    }
  ) });
}
function g_({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ c(
    lh,
    {
      "data-slot": "accordion-content",
      className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm",
      ...n,
      children: /* @__PURE__ */ c("div", { className: C("pt-0 pb-4", e), children: t })
    }
  );
}
const uh = et(
  "relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        destructive: "text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function b_({
  className: e,
  variant: t,
  ...n
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "alert",
      role: "alert",
      className: C(uh({ variant: t }), e),
      ...n
    }
  );
}
function w_({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "alert-title",
      className: C(
        "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        e
      ),
      ...t
    }
  );
}
function y_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "alert-description",
      className: C(
        "text-muted-foreground col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed",
        e
      ),
      ...t
    }
  );
}
function q(e) {
  const t = l.useRef(e);
  return l.useEffect(() => {
    t.current = e;
  }), l.useMemo(() => (...n) => t.current?.(...n), []);
}
function fh(e, t = globalThis?.document) {
  const n = q(e);
  l.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var ph = "DismissableLayer", hr = "dismissableLayer.update", mh = "dismissableLayer.pointerDownOutside", vh = "dismissableLayer.focusOutside", Cs, Oi = l.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), nt = l.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...d
    } = e, f = l.useContext(Oi), [u, p] = l.useState(null), m = u?.ownerDocument ?? globalThis?.document, [, h] = l.useState({}), g = W(t, (M) => p(M)), v = Array.from(f.layers), [b] = [...f.layersWithOutsidePointerEventsDisabled].slice(-1), w = v.indexOf(b), y = u ? v.indexOf(u) : -1, x = f.layersWithOutsidePointerEventsDisabled.size > 0, E = y >= w, S = gh((M) => {
      const P = M.target, T = [...f.branches].some((D) => D.contains(P));
      !E || T || (r?.(M), i?.(M), M.defaultPrevented || s?.());
    }, m), R = bh((M) => {
      const P = M.target;
      [...f.branches].some((D) => D.contains(P)) || (a?.(M), i?.(M), M.defaultPrevented || s?.());
    }, m);
    return fh((M) => {
      y === f.layers.size - 1 && (o?.(M), !M.defaultPrevented && s && (M.preventDefault(), s()));
    }, m), l.useEffect(() => {
      if (u)
        return n && (f.layersWithOutsidePointerEventsDisabled.size === 0 && (Cs = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), f.layersWithOutsidePointerEventsDisabled.add(u)), f.layers.add(u), Ss(), () => {
          n && f.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = Cs);
        };
    }, [u, m, n, f]), l.useEffect(() => () => {
      u && (f.layers.delete(u), f.layersWithOutsidePointerEventsDisabled.delete(u), Ss());
    }, [u, f]), l.useEffect(() => {
      const M = () => h({});
      return document.addEventListener(hr, M), () => document.removeEventListener(hr, M);
    }, []), /* @__PURE__ */ c(
      A.div,
      {
        ...d,
        ref: g,
        style: {
          pointerEvents: x ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: N(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: N(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: N(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
nt.displayName = ph;
var hh = "DismissableLayerBranch", ki = l.forwardRef((e, t) => {
  const n = l.useContext(Oi), o = l.useRef(null), r = W(t, o);
  return l.useEffect(() => {
    const a = o.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ c(A.div, { ...e, ref: r });
});
ki.displayName = hh;
function gh(e, t = globalThis?.document) {
  const n = q(e), o = l.useRef(!1), r = l.useRef(() => {
  });
  return l.useEffect(() => {
    const a = (s) => {
      if (s.target && !o.current) {
        let d = function() {
          $i(
            mh,
            n,
            f,
            { discrete: !0 }
          );
        };
        const f = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = d, t.addEventListener("click", r.current, { once: !0 })) : d();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", r.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function bh(e, t = globalThis?.document) {
  const n = q(e), o = l.useRef(!1);
  return l.useEffect(() => {
    const r = (a) => {
      a.target && !o.current && $i(vh, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Ss() {
  const e = new CustomEvent(hr);
  document.dispatchEvent(e);
}
function $i(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), o ? Qt(r, a) : r.dispatchEvent(a);
}
var wh = nt, yh = ki, Zo = "focusScope.autoFocusOnMount", Jo = "focusScope.autoFocusOnUnmount", Es = { bubbles: !1, cancelable: !0 }, xh = "FocusScope", fn = l.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: a,
    ...i
  } = e, [s, d] = l.useState(null), f = q(r), u = q(a), p = l.useRef(null), m = W(t, (v) => d(v)), h = l.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  l.useEffect(() => {
    if (o) {
      let v = function(x) {
        if (h.paused || !s) return;
        const E = x.target;
        s.contains(E) ? p.current = E : at(p.current, { select: !0 });
      }, b = function(x) {
        if (h.paused || !s) return;
        const E = x.relatedTarget;
        E !== null && (s.contains(E) || at(p.current, { select: !0 }));
      }, w = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && at(s);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", b);
      const y = new MutationObserver(w);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", b), y.disconnect();
      };
    }
  }, [o, s, h.paused]), l.useEffect(() => {
    if (s) {
      Rs.add(h);
      const v = document.activeElement;
      if (!s.contains(v)) {
        const w = new CustomEvent(Zo, Es);
        s.addEventListener(Zo, f), s.dispatchEvent(w), w.defaultPrevented || (Ch(Nh(Li(s)), { select: !0 }), document.activeElement === v && at(s));
      }
      return () => {
        s.removeEventListener(Zo, f), setTimeout(() => {
          const w = new CustomEvent(Jo, Es);
          s.addEventListener(Jo, u), s.dispatchEvent(w), w.defaultPrevented || at(v ?? document.body, { select: !0 }), s.removeEventListener(Jo, u), Rs.remove(h);
        }, 0);
      };
    }
  }, [s, f, u, h]);
  const g = l.useCallback(
    (v) => {
      if (!n && !o || h.paused) return;
      const b = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, w = document.activeElement;
      if (b && w) {
        const y = v.currentTarget, [x, E] = Sh(y);
        x && E ? !v.shiftKey && w === E ? (v.preventDefault(), n && at(x, { select: !0 })) : v.shiftKey && w === x && (v.preventDefault(), n && at(E, { select: !0 })) : w === y && v.preventDefault();
      }
    },
    [n, o, h.paused]
  );
  return /* @__PURE__ */ c(A.div, { tabIndex: -1, ...i, ref: m, onKeyDown: g });
});
fn.displayName = xh;
function Ch(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (at(o, { select: t }), document.activeElement !== n) return;
}
function Sh(e) {
  const t = Li(e), n = Ms(t, e), o = Ms(t.reverse(), e);
  return [n, o];
}
function Li(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Ms(e, t) {
  for (const n of e)
    if (!Eh(n, { upTo: t })) return n;
}
function Eh(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Mh(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function at(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Mh(e) && t && e.select();
  }
}
var Rs = Rh();
function Rh() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = Ns(e, t), e.unshift(t);
    },
    remove(t) {
      e = Ns(e, t), e[0]?.resume();
    }
  };
}
function Ns(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function Nh(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Ph = "Portal", ut = l.forwardRef((e, t) => {
  const { container: n, ...o } = e, [r, a] = l.useState(!1);
  oe(() => a(!0), []);
  const i = n || r && globalThis?.document?.body;
  return i ? pi.createPortal(/* @__PURE__ */ c(A.div, { ...o, ref: t }), i) : null;
});
ut.displayName = Ph;
var Qo = 0;
function po() {
  l.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Ps()), document.body.insertAdjacentElement("beforeend", e[1] ?? Ps()), Qo++, () => {
      Qo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Qo--;
    };
  }, []);
}
function Ps() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var We = function() {
  return We = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, We.apply(this, arguments);
};
function Fi(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function _h(e, t, n) {
  if (n || arguments.length === 2) for (var o = 0, r = t.length, a; o < r; o++)
    (a || !(o in t)) && (a || (a = Array.prototype.slice.call(t, 0, o)), a[o] = t[o]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Bn = "right-scroll-bar-position", Vn = "width-before-scroll-bar", Th = "with-scroll-bars-hidden", Ah = "--removed-body-scroll-bar-size";
function er(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Dh(e, t) {
  var n = Jt(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Ih = typeof window < "u" ? l.useLayoutEffect : l.useEffect, _s = /* @__PURE__ */ new WeakMap();
function Oh(e, t) {
  var n = Dh(null, function(o) {
    return e.forEach(function(r) {
      return er(r, o);
    });
  });
  return Ih(function() {
    var o = _s.get(n);
    if (o) {
      var r = new Set(o), a = new Set(e), i = n.current;
      r.forEach(function(s) {
        a.has(s) || er(s, null);
      }), a.forEach(function(s) {
        r.has(s) || er(s, i);
      });
    }
    _s.set(n, e);
  }, [e]), n;
}
function kh(e) {
  return e;
}
function $h(e, t) {
  t === void 0 && (t = kh);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, o);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (o = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      o = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), i = n;
      }
      var d = function() {
        var u = i;
        i = [], u.forEach(a);
      }, f = function() {
        return Promise.resolve().then(d);
      };
      f(), n = {
        push: function(u) {
          i.push(u), f();
        },
        filter: function(u) {
          return i = i.filter(u), n;
        }
      };
    }
  };
  return r;
}
function Lh(e) {
  e === void 0 && (e = {});
  var t = $h(null);
  return t.options = We({ async: !0, ssr: !1 }, e), t;
}
var Wi = function(e) {
  var t = e.sideCar, n = Fi(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return l.createElement(o, We({}, n));
};
Wi.isSideCarExport = !0;
function Fh(e, t) {
  return e.useMedium(t), Wi;
}
var zi = Lh(), tr = function() {
}, mo = l.forwardRef(function(e, t) {
  var n = l.useRef(null), o = l.useState({
    onScrollCapture: tr,
    onWheelCapture: tr,
    onTouchMoveCapture: tr
  }), r = o[0], a = o[1], i = e.forwardProps, s = e.children, d = e.className, f = e.removeScrollBar, u = e.enabled, p = e.shards, m = e.sideCar, h = e.noRelative, g = e.noIsolation, v = e.inert, b = e.allowPinchZoom, w = e.as, y = w === void 0 ? "div" : w, x = e.gapMode, E = Fi(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = m, R = Oh([n, t]), M = We(We({}, E), r);
  return l.createElement(
    l.Fragment,
    null,
    u && l.createElement(S, { sideCar: zi, removeScrollBar: f, shards: p, noRelative: h, noIsolation: g, inert: v, setCallbacks: a, allowPinchZoom: !!b, lockRef: n, gapMode: x }),
    i ? l.cloneElement(l.Children.only(s), We(We({}, M), { ref: R })) : l.createElement(y, We({}, M, { className: d, ref: R }), s)
  );
});
mo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
mo.classNames = {
  fullWidth: Vn,
  zeroRight: Bn
};
var Wh = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function zh() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Wh();
  return t && e.setAttribute("nonce", t), e;
}
function Bh(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Vh(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Hh = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = zh()) && (Bh(t, n), Vh(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Gh = function() {
  var e = Hh();
  return function(t, n) {
    l.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Bi = function() {
  var e = Gh(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, Kh = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, nr = function(e) {
  return parseInt(e || "", 10) || 0;
}, Uh = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [nr(n), nr(o), nr(r)];
}, Yh = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Kh;
  var t = Uh(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, jh = Bi(), Pt = "data-scroll-locked", Xh = function(e, t, n, o) {
  var r = e.left, a = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Th, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(Pt, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Bn, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(Vn, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(Bn, " .").concat(Bn, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(Vn, " .").concat(Vn, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Pt, `] {
    `).concat(Ah, ": ").concat(s, `px;
  }
`);
}, Ts = function() {
  var e = parseInt(document.body.getAttribute(Pt) || "0", 10);
  return isFinite(e) ? e : 0;
}, qh = function() {
  l.useEffect(function() {
    return document.body.setAttribute(Pt, (Ts() + 1).toString()), function() {
      var e = Ts() - 1;
      e <= 0 ? document.body.removeAttribute(Pt) : document.body.setAttribute(Pt, e.toString());
    };
  }, []);
}, Zh = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o;
  qh();
  var a = l.useMemo(function() {
    return Yh(r);
  }, [r]);
  return l.createElement(jh, { styles: Xh(a, !t, r, n ? "" : "!important") });
}, gr = !1;
if (typeof window < "u")
  try {
    var Dn = Object.defineProperty({}, "passive", {
      get: function() {
        return gr = !0, !0;
      }
    });
    window.addEventListener("test", Dn, Dn), window.removeEventListener("test", Dn, Dn);
  } catch {
    gr = !1;
  }
var Mt = gr ? { passive: !1 } : !1, Jh = function(e) {
  return e.tagName === "TEXTAREA";
}, Vi = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Jh(e) && n[t] === "visible")
  );
}, Qh = function(e) {
  return Vi(e, "overflowY");
}, eg = function(e) {
  return Vi(e, "overflowX");
}, As = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var r = Hi(e, o);
    if (r) {
      var a = Gi(e, o), i = a[1], s = a[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, tg = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, ng = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, Hi = function(e, t) {
  return e === "v" ? Qh(t) : eg(t);
}, Gi = function(e, t) {
  return e === "v" ? tg(t) : ng(t);
}, og = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, rg = function(e, t, n, o, r) {
  var a = og(e, window.getComputedStyle(t).direction), i = a * o, s = n.target, d = t.contains(s), f = !1, u = i > 0, p = 0, m = 0;
  do {
    if (!s)
      break;
    var h = Gi(e, s), g = h[0], v = h[1], b = h[2], w = v - b - a * g;
    (g || w) && Hi(e, s) && (p += w, m += g);
    var y = s.parentNode;
    s = y && y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? y.host : y;
  } while (
    // portaled content
    !d && s !== document.body || // self content
    d && (t.contains(s) || t === s)
  );
  return (u && Math.abs(p) < 1 || !u && Math.abs(m) < 1) && (f = !0), f;
}, In = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Ds = function(e) {
  return [e.deltaX, e.deltaY];
}, Is = function(e) {
  return e && "current" in e ? e.current : e;
}, ag = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, sg = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, ig = 0, Rt = [];
function cg(e) {
  var t = l.useRef([]), n = l.useRef([0, 0]), o = l.useRef(), r = l.useState(ig++)[0], a = l.useState(Bi)[0], i = l.useRef(e);
  l.useEffect(function() {
    i.current = e;
  }, [e]), l.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var v = _h([e.lockRef.current], (e.shards || []).map(Is), !0).filter(Boolean);
      return v.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), v.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = l.useCallback(function(v, b) {
    if ("touches" in v && v.touches.length === 2 || v.type === "wheel" && v.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = In(v), y = n.current, x = "deltaX" in v ? v.deltaX : y[0] - w[0], E = "deltaY" in v ? v.deltaY : y[1] - w[1], S, R = v.target, M = Math.abs(x) > Math.abs(E) ? "h" : "v";
    if ("touches" in v && M === "h" && R.type === "range")
      return !1;
    var P = As(M, R);
    if (!P)
      return !0;
    if (P ? S = M : (S = M === "v" ? "h" : "v", P = As(M, R)), !P)
      return !1;
    if (!o.current && "changedTouches" in v && (x || E) && (o.current = S), !S)
      return !0;
    var T = o.current || S;
    return rg(T, b, v, T === "h" ? x : E);
  }, []), d = l.useCallback(function(v) {
    var b = v;
    if (!(!Rt.length || Rt[Rt.length - 1] !== a)) {
      var w = "deltaY" in b ? Ds(b) : In(b), y = t.current.filter(function(S) {
        return S.name === b.type && (S.target === b.target || b.target === S.shadowParent) && ag(S.delta, w);
      })[0];
      if (y && y.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!y) {
        var x = (i.current.shards || []).map(Is).filter(Boolean).filter(function(S) {
          return S.contains(b.target);
        }), E = x.length > 0 ? s(b, x[0]) : !i.current.noIsolation;
        E && b.cancelable && b.preventDefault();
      }
    }
  }, []), f = l.useCallback(function(v, b, w, y) {
    var x = { name: v, delta: b, target: w, should: y, shadowParent: lg(w) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(E) {
        return E !== x;
      });
    }, 1);
  }, []), u = l.useCallback(function(v) {
    n.current = In(v), o.current = void 0;
  }, []), p = l.useCallback(function(v) {
    f(v.type, Ds(v), v.target, s(v, e.lockRef.current));
  }, []), m = l.useCallback(function(v) {
    f(v.type, In(v), v.target, s(v, e.lockRef.current));
  }, []);
  l.useEffect(function() {
    return Rt.push(a), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", d, Mt), document.addEventListener("touchmove", d, Mt), document.addEventListener("touchstart", u, Mt), function() {
      Rt = Rt.filter(function(v) {
        return v !== a;
      }), document.removeEventListener("wheel", d, Mt), document.removeEventListener("touchmove", d, Mt), document.removeEventListener("touchstart", u, Mt);
    };
  }, []);
  var h = e.removeScrollBar, g = e.inert;
  return l.createElement(
    l.Fragment,
    null,
    g ? l.createElement(a, { styles: sg(r) }) : null,
    h ? l.createElement(Zh, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function lg(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const dg = Fh(zi, cg);
var pn = l.forwardRef(function(e, t) {
  return l.createElement(mo, We({}, e, { ref: t, sideCar: dg }));
});
pn.classNames = mo.classNames;
var ug = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Nt = /* @__PURE__ */ new WeakMap(), On = /* @__PURE__ */ new WeakMap(), kn = {}, or = 0, Ki = function(e) {
  return e && (e.host || Ki(e.parentNode));
}, fg = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = Ki(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, pg = function(e, t, n, o) {
  var r = fg(t, Array.isArray(e) ? e : [e]);
  kn[n] || (kn[n] = /* @__PURE__ */ new WeakMap());
  var a = kn[n], i = [], s = /* @__PURE__ */ new Set(), d = new Set(r), f = function(p) {
    !p || s.has(p) || (s.add(p), f(p.parentNode));
  };
  r.forEach(f);
  var u = function(p) {
    !p || d.has(p) || Array.prototype.forEach.call(p.children, function(m) {
      if (s.has(m))
        u(m);
      else
        try {
          var h = m.getAttribute(o), g = h !== null && h !== "false", v = (Nt.get(m) || 0) + 1, b = (a.get(m) || 0) + 1;
          Nt.set(m, v), a.set(m, b), i.push(m), v === 1 && g && On.set(m, !0), b === 1 && m.setAttribute(n, "true"), g || m.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", m, w);
        }
    });
  };
  return u(t), s.clear(), or++, function() {
    i.forEach(function(p) {
      var m = Nt.get(p) - 1, h = a.get(p) - 1;
      Nt.set(p, m), a.set(p, h), m || (On.has(p) || p.removeAttribute(o), On.delete(p)), h || p.removeAttribute(n);
    }), or--, or || (Nt = /* @__PURE__ */ new WeakMap(), Nt = /* @__PURE__ */ new WeakMap(), On = /* @__PURE__ */ new WeakMap(), kn = {});
  };
}, vo = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), r = ug(e);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live], script"))), pg(o, r, n, "aria-hidden")) : function() {
    return null;
  };
}, ho = "Dialog", [Ui, Yi] = Q(ho), [mg, $e] = Ui(ho), ji = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    modal: i = !0
  } = e, s = l.useRef(null), d = l.useRef(null), [f, u] = ne({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: ho
  });
  return /* @__PURE__ */ c(
    mg,
    {
      scope: t,
      triggerRef: s,
      contentRef: d,
      contentId: le(),
      titleId: le(),
      descriptionId: le(),
      open: f,
      onOpenChange: u,
      onOpenToggle: l.useCallback(() => u((p) => !p), [u]),
      modal: i,
      children: n
    }
  );
};
ji.displayName = ho;
var Xi = "DialogTrigger", qi = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = $e(Xi, n), a = W(t, r.triggerRef);
    return /* @__PURE__ */ c(
      A.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": na(r.open),
        ...o,
        ref: a,
        onClick: N(e.onClick, r.onOpenToggle)
      }
    );
  }
);
qi.displayName = Xi;
var ea = "DialogPortal", [vg, Zi] = Ui(ea, {
  forceMount: void 0
}), Ji = (e) => {
  const { __scopeDialog: t, forceMount: n, children: o, container: r } = e, a = $e(ea, t);
  return /* @__PURE__ */ c(vg, { scope: t, forceMount: n, children: l.Children.map(o, (i) => /* @__PURE__ */ c(ee, { present: n || a.open, children: /* @__PURE__ */ c(ut, { asChild: !0, container: r, children: i }) })) });
};
Ji.displayName = ea;
var Un = "DialogOverlay", Qi = l.forwardRef(
  (e, t) => {
    const n = Zi(Un, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = $e(Un, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ c(ee, { present: o || a.open, children: /* @__PURE__ */ c(gg, { ...r, ref: t }) }) : null;
  }
);
Qi.displayName = Un;
var hg = /* @__PURE__ */ it("DialogOverlay.RemoveScroll"), gg = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = $e(Un, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ c(pn, { as: hg, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ c(
        A.div,
        {
          "data-state": na(r.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), bt = "DialogContent", ec = l.forwardRef(
  (e, t) => {
    const n = Zi(bt, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = $e(bt, e.__scopeDialog);
    return /* @__PURE__ */ c(ee, { present: o || a.open, children: a.modal ? /* @__PURE__ */ c(bg, { ...r, ref: t }) : /* @__PURE__ */ c(wg, { ...r, ref: t }) });
  }
);
ec.displayName = bt;
var bg = l.forwardRef(
  (e, t) => {
    const n = $e(bt, e.__scopeDialog), o = l.useRef(null), r = W(t, n.contentRef, o);
    return l.useEffect(() => {
      const a = o.current;
      if (a) return vo(a);
    }, []), /* @__PURE__ */ c(
      tc,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: N(e.onCloseAutoFocus, (a) => {
          a.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: N(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: N(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), wg = l.forwardRef(
  (e, t) => {
    const n = $e(bt, e.__scopeDialog), o = l.useRef(!1), r = l.useRef(!1);
    return /* @__PURE__ */ c(
      tc,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          e.onCloseAutoFocus?.(a), a.defaultPrevented || (o.current || n.triggerRef.current?.focus(), a.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          e.onInteractOutside?.(a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = a.target;
          n.triggerRef.current?.contains(i) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), tc = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: a, ...i } = e, s = $e(bt, n), d = l.useRef(null), f = W(t, d);
    return po(), /* @__PURE__ */ z(Se, { children: [
      /* @__PURE__ */ c(
        fn,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: r,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ c(
            nt,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": na(s.open),
              ...i,
              ref: f,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ z(Se, { children: [
        /* @__PURE__ */ c(xg, { titleId: s.titleId }),
        /* @__PURE__ */ c(Sg, { contentRef: d, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), ta = "DialogTitle", nc = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = $e(ta, n);
    return /* @__PURE__ */ c(A.h2, { id: r.titleId, ...o, ref: t });
  }
);
nc.displayName = ta;
var oc = "DialogDescription", rc = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = $e(oc, n);
    return /* @__PURE__ */ c(A.p, { id: r.descriptionId, ...o, ref: t });
  }
);
rc.displayName = oc;
var ac = "DialogClose", sc = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = $e(ac, n);
    return /* @__PURE__ */ c(
      A.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: N(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
sc.displayName = ac;
function na(e) {
  return e ? "open" : "closed";
}
var ic = "DialogTitleWarning", [yg, cc] = _v(ic, {
  contentName: bt,
  titleName: ta,
  docsSlug: "dialog"
}), xg = ({ titleId: e }) => {
  const t = cc(ic), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return l.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, Cg = "DialogDescriptionWarning", Sg = ({ contentRef: e, descriptionId: t }) => {
  const o = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${cc(Cg).contentName}}.`;
  return l.useEffect(() => {
    const r = e.current?.getAttribute("aria-describedby");
    t && r && (document.getElementById(t) || console.warn(o));
  }, [o, e, t]), null;
}, oa = ji, ra = qi, aa = Ji, sa = Qi, ia = ec, ca = nc, la = rc, $t = sc, lc = "AlertDialog", [Eg, x_] = Q(lc, [
  Yi
]), ot = Yi(), dc = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, o = ot(t);
  return /* @__PURE__ */ c(oa, { ...o, ...n, modal: !0 });
};
dc.displayName = lc;
var Mg = "AlertDialogTrigger", uc = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = ot(n);
    return /* @__PURE__ */ c(ra, { ...r, ...o, ref: t });
  }
);
uc.displayName = Mg;
var Rg = "AlertDialogPortal", fc = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, o = ot(t);
  return /* @__PURE__ */ c(aa, { ...o, ...n });
};
fc.displayName = Rg;
var Ng = "AlertDialogOverlay", pc = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = ot(n);
    return /* @__PURE__ */ c(sa, { ...r, ...o, ref: t });
  }
);
pc.displayName = Ng;
var _t = "AlertDialogContent", [Pg, _g] = Eg(_t), Tg = /* @__PURE__ */ gi("AlertDialogContent"), mc = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, children: o, ...r } = e, a = ot(n), i = l.useRef(null), s = W(t, i), d = l.useRef(null);
    return /* @__PURE__ */ c(
      yg,
      {
        contentName: _t,
        titleName: vc,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ c(Pg, { scope: n, cancelRef: d, children: /* @__PURE__ */ z(
          ia,
          {
            role: "alertdialog",
            ...a,
            ...r,
            ref: s,
            onOpenAutoFocus: N(r.onOpenAutoFocus, (f) => {
              f.preventDefault(), d.current?.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (f) => f.preventDefault(),
            onInteractOutside: (f) => f.preventDefault(),
            children: [
              /* @__PURE__ */ c(Tg, { children: o }),
              /* @__PURE__ */ c(Dg, { contentRef: i })
            ]
          }
        ) })
      }
    );
  }
);
mc.displayName = _t;
var vc = "AlertDialogTitle", hc = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = ot(n);
    return /* @__PURE__ */ c(ca, { ...r, ...o, ref: t });
  }
);
hc.displayName = vc;
var gc = "AlertDialogDescription", bc = l.forwardRef((e, t) => {
  const { __scopeAlertDialog: n, ...o } = e, r = ot(n);
  return /* @__PURE__ */ c(la, { ...r, ...o, ref: t });
});
bc.displayName = gc;
var Ag = "AlertDialogAction", wc = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = ot(n);
    return /* @__PURE__ */ c($t, { ...r, ...o, ref: t });
  }
);
wc.displayName = Ag;
var yc = "AlertDialogCancel", xc = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, { cancelRef: r } = _g(yc, n), a = ot(n), i = W(t, r);
    return /* @__PURE__ */ c($t, { ...a, ...o, ref: i });
  }
);
xc.displayName = yc;
var Dg = ({ contentRef: e }) => {
  const t = `\`${_t}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${_t}\` by passing a \`${gc}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${_t}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return l.useEffect(() => {
    document.getElementById(
      e.current?.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, Ig = dc, Og = uc, kg = fc, $g = pc, Lg = mc, Fg = wc, Wg = xc, zg = hc, Bg = bc;
const en = et(
  "inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-11 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
        "icon-sm": "size-6"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Ze = l.forwardRef(
  ({ className: e, variant: t, size: n, asChild: o = !1, ...r }, a) => /* @__PURE__ */ c(
    o ? dt : "button",
    {
      className: C(en({ variant: t, size: n, className: e })),
      ref: a,
      "data-size": n,
      ...r
    }
  )
);
Ze.displayName = "Button";
function C_({
  ...e
}) {
  return /* @__PURE__ */ c(Ig, { "data-slot": "alert-dialog", ...e });
}
function S_({
  ...e
}) {
  return /* @__PURE__ */ c(Og, { "data-slot": "alert-dialog-trigger", ...e });
}
function Vg({
  ...e
}) {
  return /* @__PURE__ */ c(kg, { "data-slot": "alert-dialog-portal", ...e });
}
function Hg({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    $g,
    {
      "data-slot": "alert-dialog-overlay",
      className: C(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
        e
      ),
      ...t
    }
  );
}
function E_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ z(Vg, { children: [
    /* @__PURE__ */ c(Hg, {}),
    /* @__PURE__ */ c(
      Lg,
      {
        "data-slot": "alert-dialog-content",
        className: C(
          "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg",
          e
        ),
        ...t
      }
    )
  ] });
}
function M_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "alert-dialog-header",
      className: C("flex flex-col gap-2 text-center sm:text-start", e),
      ...t
    }
  );
}
function R_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "alert-dialog-footer",
      className: C(
        "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
        e
      ),
      ...t
    }
  );
}
function N_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    zg,
    {
      "data-slot": "alert-dialog-title",
      className: C("text-lg font-semibold", e),
      ...t
    }
  );
}
function P_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Bg,
    {
      "data-slot": "alert-dialog-description",
      className: C("text-muted-foreground text-sm", e),
      ...t
    }
  );
}
function __({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Fg,
    {
      className: C(en(), e),
      ...t
    }
  );
}
function T_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Wg,
    {
      className: C(en({ variant: "outline" }), e),
      ...t
    }
  );
}
var Gg = "AspectRatio", Cc = l.forwardRef(
  (e, t) => {
    const { ratio: n = 1 / 1, style: o, ...r } = e;
    return /* @__PURE__ */ c(
      "div",
      {
        style: {
          // ensures inner element is contained
          position: "relative",
          // ensures padding bottom trick maths works
          width: "100%",
          paddingBottom: `${100 / n}%`
        },
        "data-radix-aspect-ratio-wrapper": "",
        children: /* @__PURE__ */ c(
          A.div,
          {
            ...r,
            ref: t,
            style: {
              ...o,
              // ensures children expand in ratio
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            }
          }
        )
      }
    );
  }
);
Cc.displayName = Gg;
var Kg = Cc;
function A_({
  ...e
}) {
  return /* @__PURE__ */ c(Kg, { "data-slot": "aspect-ratio", ...e });
}
var $n = { exports: {} }, rr = {};
var Os;
function Ug() {
  if (Os) return rr;
  Os = 1;
  var e = _;
  function t(p, m) {
    return p === m && (p !== 0 || 1 / p === 1 / m) || p !== p && m !== m;
  }
  var n = typeof Object.is == "function" ? Object.is : t, o = e.useState, r = e.useEffect, a = e.useLayoutEffect, i = e.useDebugValue;
  function s(p, m) {
    var h = m(), g = o({ inst: { value: h, getSnapshot: m } }), v = g[0].inst, b = g[1];
    return a(
      function() {
        v.value = h, v.getSnapshot = m, d(v) && b({ inst: v });
      },
      [p, h, m]
    ), r(
      function() {
        return d(v) && b({ inst: v }), p(function() {
          d(v) && b({ inst: v });
        });
      },
      [p]
    ), i(h), h;
  }
  function d(p) {
    var m = p.getSnapshot;
    p = p.value;
    try {
      var h = m();
      return !n(p, h);
    } catch {
      return !0;
    }
  }
  function f(p, m) {
    return m();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? f : s;
  return rr.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, rr;
}
var ar = {};
var ks;
function Yg() {
  return ks || (ks = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(h, g) {
      return h === g && (h !== 0 || 1 / h === 1 / g) || h !== h && g !== g;
    }
    function t(h, g) {
      u || r.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var v = g();
      if (!p) {
        var b = g();
        a(v, b) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), p = !0);
      }
      b = i({
        inst: { value: v, getSnapshot: g }
      });
      var w = b[0].inst, y = b[1];
      return d(
        function() {
          w.value = v, w.getSnapshot = g, n(w) && y({ inst: w });
        },
        [h, v, g]
      ), s(
        function() {
          return n(w) && y({ inst: w }), h(function() {
            n(w) && y({ inst: w });
          });
        },
        [h]
      ), f(v), v;
    }
    function n(h) {
      var g = h.getSnapshot;
      h = h.value;
      try {
        var v = g();
        return !a(h, v);
      } catch {
        return !0;
      }
    }
    function o(h, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = _, a = typeof Object.is == "function" ? Object.is : e, i = r.useState, s = r.useEffect, d = r.useLayoutEffect, f = r.useDebugValue, u = !1, p = !1, m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? o : t;
    ar.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), ar;
}
var $s;
function jg() {
  return $s || ($s = 1, process.env.NODE_ENV === "production" ? $n.exports = Ug() : $n.exports = Yg()), $n.exports;
}
var Xg = jg();
function qg() {
  return Xg.useSyncExternalStore(
    Zg,
    () => !0,
    () => !1
  );
}
function Zg() {
  return () => {
  };
}
var da = "Avatar", [Jg, D_] = Q(da), [Qg, Sc] = Jg(da), Ec = l.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...o } = e, [r, a] = l.useState("idle");
    return /* @__PURE__ */ c(
      Qg,
      {
        scope: n,
        imageLoadingStatus: r,
        onImageLoadingStatusChange: a,
        children: /* @__PURE__ */ c(A.span, { ...o, ref: t })
      }
    );
  }
);
Ec.displayName = da;
var Mc = "AvatarImage", Rc = l.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: o, onLoadingStatusChange: r = () => {
    }, ...a } = e, i = Sc(Mc, n), s = eb(o, a), d = q((f) => {
      r(f), i.onImageLoadingStatusChange(f);
    });
    return oe(() => {
      s !== "idle" && d(s);
    }, [s, d]), s === "loaded" ? /* @__PURE__ */ c(A.img, { ...a, ref: t, src: o }) : null;
  }
);
Rc.displayName = Mc;
var Nc = "AvatarFallback", Pc = l.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: o, ...r } = e, a = Sc(Nc, n), [i, s] = l.useState(o === void 0);
    return l.useEffect(() => {
      if (o !== void 0) {
        const d = window.setTimeout(() => s(!0), o);
        return () => window.clearTimeout(d);
      }
    }, [o]), i && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ c(A.span, { ...r, ref: t }) : null;
  }
);
Pc.displayName = Nc;
function Ls(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function eb(e, { referrerPolicy: t, crossOrigin: n }) {
  const o = qg(), r = l.useRef(null), a = o ? (r.current || (r.current = new window.Image()), r.current) : null, [i, s] = l.useState(
    () => Ls(a, e)
  );
  return oe(() => {
    s(Ls(a, e));
  }, [a, e]), oe(() => {
    const d = (p) => () => {
      s(p);
    };
    if (!a) return;
    const f = d("loaded"), u = d("error");
    return a.addEventListener("load", f), a.addEventListener("error", u), t && (a.referrerPolicy = t), typeof n == "string" && (a.crossOrigin = n), () => {
      a.removeEventListener("load", f), a.removeEventListener("error", u);
    };
  }, [a, n, t]), i;
}
var tb = Ec, nb = Rc, ob = Pc;
function I_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    tb,
    {
      "data-slot": "avatar",
      className: C(
        "relative flex size-8 shrink-0 overflow-hidden rounded-full",
        e
      ),
      ...t
    }
  );
}
function O_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    nb,
    {
      "data-slot": "avatar-image",
      className: C("aspect-square size-full", e),
      ...t
    }
  );
}
function k_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    ob,
    {
      "data-slot": "avatar-fallback",
      className: C(
        "bg-muted flex size-full items-center justify-center rounded-full",
        e
      ),
      ...t
    }
  );
}
const rb = et(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function $_({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ c("div", { className: C(rb({ variant: t }), e), ...n });
}
const ab = l.forwardRef(({ ...e }, t) => /* @__PURE__ */ c("nav", { ref: t, "aria-label": "breadcrumb", ...e }));
ab.displayName = "Breadcrumb";
const sb = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  "ol",
  {
    ref: n,
    className: C(
      "text-muted-foreground flex flex-wrap items-center gap-1.5 text-sm break-words sm:gap-2.5",
      e
    ),
    ...t
  }
));
sb.displayName = "BreadcrumbList";
const ib = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  "li",
  {
    ref: n,
    className: C("inline-flex items-center gap-1.5", e),
    ...t
  }
));
ib.displayName = "BreadcrumbItem";
const cb = l.forwardRef(({ asChild: e, className: t, ...n }, o) => /* @__PURE__ */ c(
  e ? dt : "a",
  {
    ref: o,
    className: C("hover:text-foreground transition-colors", t),
    ...n
  }
));
cb.displayName = "BreadcrumbLink";
const lb = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  "span",
  {
    ref: n,
    role: "link",
    "aria-disabled": "true",
    "aria-current": "page",
    className: C("text-foreground font-normal", e),
    ...t
  }
));
lb.displayName = "BreadcrumbPage";
const db = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ c(
  "li",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: C("[&>svg]:h-3.5 [&>svg]:w-3.5", t),
    ...n,
    children: e ?? /* @__PURE__ */ c(mi, {})
  }
);
db.displayName = "BreadcrumbSeparator";
const ub = ({
  className: e,
  ...t
}) => /* @__PURE__ */ z(
  "span",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: C("flex h-9 w-9 items-center justify-center", e),
    ...t,
    children: [
      /* @__PURE__ */ c(Tm, { className: "h-4 w-4" }),
      /* @__PURE__ */ c("span", { className: "sr-only", children: "More" })
    ]
  }
);
ub.displayName = "BreadcrumbElipssis";
function fb(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const pb = {}, Xt = {};
function gt(e, t) {
  try {
    const o = (pb[e] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format)(t).split("GMT")[1];
    return o in Xt ? Xt[o] : Fs(o, o.split(":"));
  } catch {
    if (e in Xt) return Xt[e];
    const n = e?.match(mb);
    return n ? Fs(e, n.slice(1)) : NaN;
  }
}
const mb = /([+-]\d\d):?(\d\d)?/;
function Fs(e, t) {
  const n = +(t[0] || 0), o = +(t[1] || 0), r = +(t[2] || 0) / 60;
  return Xt[e] = n * 60 + o > 0 ? n * 60 + o + r : n * 60 - o - r;
}
class ze extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(gt(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), _c(this), br(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new ze(...n, t) : new ze(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new ze(+this, t);
  }
  getTimezoneOffset() {
    const t = -gt(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), br(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new ze(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Ws = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Ws.test(e)) return;
  const t = e.replace(Ws, "$1UTC");
  ze.prototype[t] && (e.startsWith("get") ? ze.prototype[e] = function() {
    return this.internal[t]();
  } : (ze.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), vb(this), +this;
  }, ze.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), br(this), +this;
  }));
});
function br(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-gt(e.timeZone, e) * 60));
}
function vb(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), _c(e);
}
function _c(e) {
  const t = gt(e.timeZone, e), n = t > 0 ? Math.floor(t) : Math.ceil(t), o = /* @__PURE__ */ new Date(+e);
  o.setUTCHours(o.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), a = -(/* @__PURE__ */ new Date(+o)).getTimezoneOffset(), i = r - a, s = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  i && s && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + i);
  const d = r - n;
  d && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + d);
  const f = /* @__PURE__ */ new Date(+e);
  f.setUTCSeconds(0);
  const u = r > 0 ? f.getSeconds() : (f.getSeconds() - 60) % 60, p = Math.round(-(gt(e.timeZone, e) * 60)) % 60;
  (p || u) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + p), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + p + u));
  const m = gt(e.timeZone, e), h = m > 0 ? Math.floor(m) : Math.ceil(m), v = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - h, b = h !== n, w = v - d;
  if (b && w) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + w);
    const y = gt(e.timeZone, e), x = y > 0 ? Math.floor(y) : Math.ceil(y), E = h - x;
    E && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + E), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + E));
  }
}
class ve extends ze {
  //#region static
  static tz(t, ...n) {
    return n.length ? new ve(...n, t) : new ve(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, o] = this.tzComponents(), r = `${t}${n}:${o}`;
    return this.internal.toISOString().slice(0, -1) + r;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, o, r] = this.internal.toUTCString().split(" ");
    return `${t?.slice(0, -1)} ${o} ${n} ${r}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, o, r] = this.tzComponents();
    return `${t} GMT${n}${o}${r} (${fb(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", o = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), r = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, o, r];
  }
  //#endregion
  withTimeZone(t) {
    return new ve(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new ve(+new Date(t), this.timeZone);
  }
  //#endregion
}
const hb = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, gb = (e, t, n) => {
  let o;
  const r = hb[e];
  return typeof r == "string" ? o = r : t === 1 ? o = r.one : o = r.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function sr(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const bb = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, wb = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, yb = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, xb = {
  date: sr({
    formats: bb,
    defaultWidth: "full"
  }),
  time: sr({
    formats: wb,
    defaultWidth: "full"
  }),
  dateTime: sr({
    formats: yb,
    defaultWidth: "full"
  })
}, Cb = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Sb = (e, t, n, o) => Cb[e];
function Yt(e) {
  return (t, n) => {
    const o = n?.context ? String(n.context) : "standalone";
    let r;
    if (o === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = n?.width ? String(n.width) : i;
      r = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = n?.width ? String(n.width) : e.defaultWidth;
      r = e.values[s] || e.values[i];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[a];
  };
}
const Eb = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Mb = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Rb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Nb = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Pb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, _b = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Tb = (e, t) => {
  const n = Number(e), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Ab = {
  ordinalNumber: Tb,
  era: Yt({
    values: Eb,
    defaultWidth: "wide"
  }),
  quarter: Yt({
    values: Mb,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Yt({
    values: Rb,
    defaultWidth: "wide"
  }),
  day: Yt({
    values: Nb,
    defaultWidth: "wide"
  }),
  dayPeriod: Yt({
    values: Pb,
    defaultWidth: "wide",
    formattingValues: _b,
    defaultFormattingWidth: "wide"
  })
};
function jt(e) {
  return (t, n = {}) => {
    const o = n.width, r = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], a = t.match(r);
    if (!a)
      return null;
    const i = a[0], s = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], d = Array.isArray(s) ? Ib(s, (p) => p.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      Db(s, (p) => p.test(i))
    );
    let f;
    f = e.valueCallback ? e.valueCallback(d) : d, f = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(f)
    ) : f;
    const u = t.slice(i.length);
    return { value: f, rest: u };
  };
}
function Db(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function Ib(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Ob(e) {
  return (t, n = {}) => {
    const o = t.match(e.matchPattern);
    if (!o) return null;
    const r = o[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = t.slice(r.length);
    return { value: i, rest: s };
  };
}
const kb = /^(\d+)(th|st|nd|rd)?/i, $b = /\d+/i, Lb = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Fb = {
  any: [/^b/i, /^(a|c)/i]
}, Wb = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, zb = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Bb = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Vb = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Hb = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Gb = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Kb = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ub = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Yb = {
  ordinalNumber: Ob({
    matchPattern: kb,
    parsePattern: $b,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: jt({
    matchPatterns: Lb,
    defaultMatchWidth: "wide",
    parsePatterns: Fb,
    defaultParseWidth: "any"
  }),
  quarter: jt({
    matchPatterns: Wb,
    defaultMatchWidth: "wide",
    parsePatterns: zb,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: jt({
    matchPatterns: Bb,
    defaultMatchWidth: "wide",
    parsePatterns: Vb,
    defaultParseWidth: "any"
  }),
  day: jt({
    matchPatterns: Hb,
    defaultMatchWidth: "wide",
    parsePatterns: Gb,
    defaultParseWidth: "any"
  }),
  dayPeriod: jt({
    matchPatterns: Kb,
    defaultMatchWidth: "any",
    parsePatterns: Ub,
    defaultParseWidth: "any"
  })
}, Tc = {
  code: "en-US",
  formatDistance: gb,
  formatLong: xb,
  formatRelative: Sb,
  localize: Ab,
  match: Yb,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, zs = 5, jb = 4;
function Xb(e, t) {
  const n = t.startOfMonth(e), o = n.getDay() > 0 ? n.getDay() : 7, r = t.addDays(e, -o + 1), a = t.addDays(r, zs * 7 - 1);
  return t.getMonth(e) === t.getMonth(a) ? zs : jb;
}
function Ac(e, t) {
  const n = t.startOfMonth(e), o = n.getDay();
  return o === 1 ? n : o === 0 ? t.addDays(n, -6) : t.addDays(n, -1 * (o - 1));
}
function qb(e, t) {
  const n = Ac(e, t), o = Xb(e, t);
  return t.addDays(n, o * 7 - 1);
}
class rt {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? ve.tz(this.options.timeZone) : new this.Date(), this.newDate = (o, r, a) => this.overrides?.newDate ? this.overrides.newDate(o, r, a) : this.options.timeZone ? new ve(o, r, a, this.options.timeZone) : new Date(o, r, a), this.addDays = (o, r) => this.overrides?.addDays ? this.overrides.addDays(o, r) : Vm(o, r), this.addMonths = (o, r) => this.overrides?.addMonths ? this.overrides.addMonths(o, r) : Hm(o, r), this.addWeeks = (o, r) => this.overrides?.addWeeks ? this.overrides.addWeeks(o, r) : Gm(o, r), this.addYears = (o, r) => this.overrides?.addYears ? this.overrides.addYears(o, r) : Km(o, r), this.differenceInCalendarDays = (o, r) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(o, r) : Um(o, r), this.differenceInCalendarMonths = (o, r) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(o, r) : Ym(o, r), this.eachMonthOfInterval = (o) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(o) : jm(o), this.endOfBroadcastWeek = (o) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(o) : qb(o, this), this.endOfISOWeek = (o) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(o) : Xm(o), this.endOfMonth = (o) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(o) : qm(o), this.endOfWeek = (o, r) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(o, r) : Zm(o, this.options), this.endOfYear = (o) => this.overrides?.endOfYear ? this.overrides.endOfYear(o) : Jm(o), this.format = (o, r, a) => {
      const i = this.overrides?.format ? this.overrides.format(o, r, this.options) : Qm(o, r, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(i) : i;
    }, this.getISOWeek = (o) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(o) : ev(o), this.getMonth = (o, r) => this.overrides?.getMonth ? this.overrides.getMonth(o, this.options) : tv(o, this.options), this.getYear = (o, r) => this.overrides?.getYear ? this.overrides.getYear(o, this.options) : nv(o, this.options), this.getWeek = (o, r) => this.overrides?.getWeek ? this.overrides.getWeek(o, this.options) : ov(o, this.options), this.isAfter = (o, r) => this.overrides?.isAfter ? this.overrides.isAfter(o, r) : rv(o, r), this.isBefore = (o, r) => this.overrides?.isBefore ? this.overrides.isBefore(o, r) : av(o, r), this.isDate = (o) => this.overrides?.isDate ? this.overrides.isDate(o) : sv(o), this.isSameDay = (o, r) => this.overrides?.isSameDay ? this.overrides.isSameDay(o, r) : iv(o, r), this.isSameMonth = (o, r) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(o, r) : cv(o, r), this.isSameYear = (o, r) => this.overrides?.isSameYear ? this.overrides.isSameYear(o, r) : lv(o, r), this.max = (o) => this.overrides?.max ? this.overrides.max(o) : dv(o), this.min = (o) => this.overrides?.min ? this.overrides.min(o) : uv(o), this.setMonth = (o, r) => this.overrides?.setMonth ? this.overrides.setMonth(o, r) : fv(o, r), this.setYear = (o, r) => this.overrides?.setYear ? this.overrides.setYear(o, r) : pv(o, r), this.startOfBroadcastWeek = (o, r) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(o, this) : Ac(o, this), this.startOfDay = (o) => this.overrides?.startOfDay ? this.overrides.startOfDay(o) : mv(o), this.startOfISOWeek = (o) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(o) : vv(o), this.startOfMonth = (o) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(o) : hv(o), this.startOfWeek = (o, r) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(o, this.options) : gv(o, this.options), this.startOfYear = (o) => this.overrides?.startOfYear ? this.overrides.startOfYear(o) : bv(o), this.options = { locale: Tc, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), o = {};
    for (let r = 0; r < 10; r++)
      o[r.toString()] = n.format(r);
    return o;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (o) => n[o] || o);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
}
const Ge = new rt();
class Dc {
  constructor(t, n, o = Ge) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !o.isSameMonth(t, n)), this.dateLib = o;
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class Zb {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class Jb {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function Qb(e) {
  return _.createElement("button", { ...e });
}
function ew(e) {
  return _.createElement("span", { ...e });
}
function tw(e) {
  const { size: t = 24, orientation: n = "left", className: o } = e;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    _.createElement(
      "svg",
      { className: o, width: t, height: t, viewBox: "0 0 24 24" },
      n === "up" && _.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && _.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && _.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && _.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function nw(e) {
  const { day: t, modifiers: n, ...o } = e;
  return _.createElement("td", { ...o });
}
function ow(e) {
  const { day: t, modifiers: n, ...o } = e, r = _.useRef(null);
  return _.useEffect(() => {
    n.focused && r.current?.focus();
  }, [n.focused]), _.createElement("button", { ref: r, ...o });
}
var V;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(V || (V = {}));
var se;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(se || (se = {}));
var Ae;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Ae || (Ae = {}));
var ye;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(ye || (ye = {}));
function rw(e) {
  const { options: t, className: n, components: o, classNames: r, ...a } = e, i = [r[V.Dropdown], n].join(" "), s = t?.find(({ value: d }) => d === a.value);
  return _.createElement(
    "span",
    { "data-disabled": a.disabled, className: r[V.DropdownRoot] },
    _.createElement(o.Select, { className: i, ...a }, t?.map(({ value: d, label: f, disabled: u }) => _.createElement(o.Option, { key: d, value: d, disabled: u }, f))),
    _.createElement(
      "span",
      { className: r[V.CaptionLabel], "aria-hidden": !0 },
      s?.label,
      _.createElement(o.Chevron, { orientation: "down", size: 18, className: r[V.Chevron] })
    )
  );
}
function aw(e) {
  return _.createElement("div", { ...e });
}
function sw(e) {
  return _.createElement("div", { ...e });
}
function iw(e) {
  const { calendarMonth: t, displayIndex: n, ...o } = e;
  return _.createElement("div", { ...o }, e.children);
}
function cw(e) {
  const { calendarMonth: t, displayIndex: n, ...o } = e;
  return _.createElement("div", { ...o });
}
function lw(e) {
  return _.createElement("table", { ...e });
}
function dw(e) {
  return _.createElement("div", { ...e });
}
const Ic = Pm(void 0);
function mn() {
  const e = _m(Ic);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function uw(e) {
  const { components: t } = mn();
  return _.createElement(t.Dropdown, { ...e });
}
function fw(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: o, nextMonth: r, ...a } = e, { components: i, classNames: s, labels: { labelPrevious: d, labelNext: f } } = mn(), u = Re((m) => {
    r && n?.(m);
  }, [r, n]), p = Re((m) => {
    o && t?.(m);
  }, [o, t]);
  return _.createElement(
    "nav",
    { ...a },
    _.createElement(
      i.PreviousMonthButton,
      { type: "button", className: s[V.PreviousMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": d(o), onClick: p },
      _.createElement(i.Chevron, { disabled: o ? void 0 : !0, className: s[V.Chevron], orientation: "left" })
    ),
    _.createElement(
      i.NextMonthButton,
      { type: "button", className: s[V.NextMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": f(r), onClick: u },
      _.createElement(i.Chevron, { disabled: r ? void 0 : !0, orientation: "right", className: s[V.Chevron] })
    )
  );
}
function pw(e) {
  const { components: t } = mn();
  return _.createElement(t.Button, { ...e });
}
function mw(e) {
  return _.createElement("option", { ...e });
}
function vw(e) {
  const { components: t } = mn();
  return _.createElement(t.Button, { ...e });
}
function hw(e) {
  const { rootRef: t, ...n } = e;
  return _.createElement("div", { ...n, ref: t });
}
function gw(e) {
  return _.createElement("select", { ...e });
}
function bw(e) {
  const { week: t, ...n } = e;
  return _.createElement("tr", { ...n });
}
function ww(e) {
  return _.createElement("th", { ...e });
}
function yw(e) {
  return _.createElement(
    "thead",
    { "aria-hidden": !0 },
    _.createElement("tr", { ...e })
  );
}
function xw(e) {
  const { week: t, ...n } = e;
  return _.createElement("th", { ...n });
}
function Cw(e) {
  return _.createElement("th", { ...e });
}
function Sw(e) {
  return _.createElement("tbody", { ...e });
}
function Ew(e) {
  const { components: t } = mn();
  return _.createElement(t.Dropdown, { ...e });
}
const Mw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Qb,
  CaptionLabel: ew,
  Chevron: tw,
  Day: nw,
  DayButton: ow,
  Dropdown: rw,
  DropdownNav: aw,
  Footer: sw,
  Month: iw,
  MonthCaption: cw,
  MonthGrid: lw,
  Months: dw,
  MonthsDropdown: uw,
  Nav: fw,
  NextMonthButton: pw,
  Option: mw,
  PreviousMonthButton: vw,
  Root: hw,
  Select: gw,
  Week: bw,
  WeekNumber: xw,
  WeekNumberHeader: Cw,
  Weekday: ww,
  Weekdays: yw,
  Weeks: Sw,
  YearsDropdown: Ew
}, Symbol.toStringTag, { value: "Module" }));
function Xe(e, t, n = !1, o = Ge) {
  let { from: r, to: a } = e;
  const { differenceInCalendarDays: i, isSameDay: s } = o;
  return r && a ? (i(a, r) < 0 && ([r, a] = [a, r]), i(t, r) >= (n ? 1 : 0) && i(a, t) >= (n ? 1 : 0)) : !n && a ? s(a, t) : !n && r ? s(r, t) : !1;
}
function Oc(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function ua(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function kc(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function $c(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function Lc(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function Fc(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function qe(e, t, n = Ge) {
  const o = Array.isArray(t) ? t : [t], { isSameDay: r, differenceInCalendarDays: a, isAfter: i } = n;
  return o.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return r(e, s);
    if (Fc(s, n))
      return s.includes(e);
    if (ua(s))
      return Xe(s, e, !1, n);
    if (Lc(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(e.getDay()) : s.dayOfWeek === e.getDay();
    if (Oc(s)) {
      const d = a(s.before, e), f = a(s.after, e), u = d > 0, p = f < 0;
      return i(s.before, s.after) ? p && u : u || p;
    }
    return kc(s) ? a(e, s.after) > 0 : $c(s) ? a(s.before, e) > 0 : typeof s == "function" ? s(e) : !1;
  });
}
function Rw(e, t, n, o, r) {
  const { disabled: a, hidden: i, modifiers: s, showOutsideDays: d, broadcastCalendar: f, today: u } = t, { isSameDay: p, isSameMonth: m, startOfMonth: h, isBefore: g, endOfMonth: v, isAfter: b } = r, w = n && h(n), y = o && v(o), x = {
    [se.focused]: [],
    [se.outside]: [],
    [se.disabled]: [],
    [se.hidden]: [],
    [se.today]: []
  }, E = {};
  for (const S of e) {
    const { date: R, displayMonth: M } = S, P = !!(M && !m(R, M)), T = !!(w && g(R, w)), D = !!(y && b(R, y)), O = !!(a && qe(R, a, r)), B = !!(i && qe(R, i, r)) || T || D || // Broadcast calendar will show outside days as default
    !f && !d && P || f && d === !1 && P, K = p(R, u ?? r.today());
    P && x.outside.push(S), O && x.disabled.push(S), B && x.hidden.push(S), K && x.today.push(S), s && Object.keys(s).forEach((k) => {
      const G = s?.[k];
      G && qe(R, G, r) && (E[k] ? E[k].push(S) : E[k] = [S]);
    });
  }
  return (S) => {
    const R = {
      [se.focused]: !1,
      [se.disabled]: !1,
      [se.hidden]: !1,
      [se.outside]: !1,
      [se.today]: !1
    }, M = {};
    for (const P in x) {
      const T = x[P];
      R[P] = T.some((D) => D === S);
    }
    for (const P in E)
      M[P] = E[P].some((T) => T === S);
    return {
      ...R,
      // custom modifiers should override all the previous ones
      ...M
    };
  };
}
function Nw(e, t, n = {}) {
  return Object.entries(e).filter(([, r]) => r === !0).reduce((r, [a]) => (n[a] ? r.push(n[a]) : t[se[a]] ? r.push(t[se[a]]) : t[Ae[a]] && r.push(t[Ae[a]]), r), [t[V.Day]]);
}
function Pw(e) {
  return {
    ...Mw,
    ...e
  };
}
function _w(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, o]) => {
    n.startsWith("data-") && (t[n] = o);
  }), t;
}
function fa() {
  const e = {};
  for (const t in V)
    e[V[t]] = `rdp-${V[t]}`;
  for (const t in se)
    e[se[t]] = `rdp-${se[t]}`;
  for (const t in Ae)
    e[Ae[t]] = `rdp-${Ae[t]}`;
  for (const t in ye)
    e[ye[t]] = `rdp-${ye[t]}`;
  return e;
}
function Wc(e, t, n) {
  return (n ?? new rt(t)).format(e, "LLLL y");
}
const Tw = Wc;
function Aw(e, t, n) {
  return (n ?? new rt(t)).format(e, "d");
}
function Dw(e, t = Ge) {
  return t.format(e, "LLLL");
}
function Iw(e, t, n) {
  return (n ?? new rt(t)).format(e, "cccccc");
}
function Ow(e, t = Ge) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function kw() {
  return "";
}
function zc(e, t = Ge) {
  return t.format(e, "yyyy");
}
const $w = zc, Lw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: Wc,
  formatDay: Aw,
  formatMonthCaption: Tw,
  formatMonthDropdown: Dw,
  formatWeekNumber: Ow,
  formatWeekNumberHeader: kw,
  formatWeekdayName: Iw,
  formatYearCaption: $w,
  formatYearDropdown: zc
}, Symbol.toStringTag, { value: "Module" }));
function Fw(e) {
  return e?.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e?.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...Lw,
    ...e
  };
}
function Ww(e, t, n, o, r) {
  const { startOfMonth: a, startOfYear: i, endOfYear: s, eachMonthOfInterval: d, getMonth: f } = r;
  return d({
    start: i(e),
    end: s(e)
  }).map((m) => {
    const h = o.formatMonthDropdown(m, r), g = f(m), v = t && m < a(t) || n && m > a(n) || !1;
    return { value: g, label: h, disabled: v };
  });
}
function zw(e, t = {}, n = {}) {
  let o = { ...t?.[V.Day] };
  return Object.entries(e).filter(([, r]) => r === !0).forEach(([r]) => {
    o = {
      ...o,
      ...n?.[r]
    };
  }), o;
}
function Bw(e, t, n) {
  const o = e.today(), r = t ? e.startOfISOWeek(o) : e.startOfWeek(o), a = [];
  for (let i = 0; i < 7; i++) {
    const s = e.addDays(r, i);
    a.push(s);
  }
  return a;
}
function Vw(e, t, n, o, r = !1) {
  if (!e || !t)
    return;
  const { startOfYear: a, endOfYear: i, addYears: s, getYear: d, isBefore: f, isSameYear: u } = o, p = a(e), m = i(t), h = [];
  let g = p;
  for (; f(g, m) || u(g, m); )
    h.push(g), g = s(g, 1);
  return r && h.reverse(), h.map((v) => {
    const b = n.formatYearDropdown(v, o);
    return {
      value: d(v),
      label: b,
      disabled: !1
    };
  });
}
function Bc(e, t, n, o) {
  let r = (o ?? new rt(n)).format(e, "PPPP");
  return t.today && (r = `Today, ${r}`), t.selected && (r = `${r}, selected`), r;
}
const Hw = Bc;
function Vc(e, t, n) {
  return (n ?? new rt(t)).format(e, "LLLL y");
}
const Gw = Vc;
function Kw(e, t, n, o) {
  let r = (o ?? new rt(n)).format(e, "PPPP");
  return t?.today && (r = `Today, ${r}`), r;
}
function Uw(e) {
  return "Choose the Month";
}
function Yw() {
  return "";
}
function jw(e) {
  return "Go to the Next Month";
}
function Xw(e) {
  return "Go to the Previous Month";
}
function qw(e, t, n) {
  return (n ?? new rt(t)).format(e, "cccc");
}
function Zw(e, t) {
  return `Week ${e}`;
}
function Jw(e) {
  return "Week Number";
}
function Qw(e) {
  return "Choose the Year";
}
const ey = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: Gw,
  labelDay: Hw,
  labelDayButton: Bc,
  labelGrid: Vc,
  labelGridcell: Kw,
  labelMonthDropdown: Uw,
  labelNav: Yw,
  labelNext: jw,
  labelPrevious: Xw,
  labelWeekNumber: Zw,
  labelWeekNumberHeader: Jw,
  labelWeekday: qw,
  labelYearDropdown: Qw
}, Symbol.toStringTag, { value: "Module" })), vn = (e) => e instanceof HTMLElement ? e : null, ir = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], ty = (e) => vn(e.querySelector("[data-animated-month]")), cr = (e) => vn(e.querySelector("[data-animated-caption]")), lr = (e) => vn(e.querySelector("[data-animated-weeks]")), ny = (e) => vn(e.querySelector("[data-animated-nav]")), oy = (e) => vn(e.querySelector("[data-animated-weekdays]"));
function ry(e, t, { classNames: n, months: o, focused: r, dateLib: a }) {
  const i = zn(null), s = zn(o), d = zn(!1);
  fi(() => {
    const f = s.current;
    if (s.current = o, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    o.length === 0 || f.length === 0 || o.length !== f.length)
      return;
    const u = a.isSameMonth(o[0].date, f[0].date), p = a.isAfter(o[0].date, f[0].date), m = p ? n[ye.caption_after_enter] : n[ye.caption_before_enter], h = p ? n[ye.weeks_after_enter] : n[ye.weeks_before_enter], g = i.current, v = e.current.cloneNode(!0);
    if (v instanceof HTMLElement ? (ir(v).forEach((x) => {
      if (!(x instanceof HTMLElement))
        return;
      const E = ty(x);
      E && x.contains(E) && x.removeChild(E);
      const S = cr(x);
      S && S.classList.remove(m);
      const R = lr(x);
      R && R.classList.remove(h);
    }), i.current = v) : i.current = null, d.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    r)
      return;
    const b = g instanceof HTMLElement ? ir(g) : [], w = ir(e.current);
    if (w?.every((y) => y instanceof HTMLElement) && b && b.every((y) => y instanceof HTMLElement)) {
      d.current = !0, e.current.style.isolation = "isolate";
      const y = ny(e.current);
      y && (y.style.zIndex = "1"), w.forEach((x, E) => {
        const S = b[E];
        if (!S)
          return;
        x.style.position = "relative", x.style.overflow = "hidden";
        const R = cr(x);
        R && R.classList.add(m);
        const M = lr(x);
        M && M.classList.add(h);
        const P = () => {
          d.current = !1, e.current && (e.current.style.isolation = ""), y && (y.style.zIndex = ""), R && R.classList.remove(m), M && M.classList.remove(h), x.style.position = "", x.style.overflow = "", x.contains(S) && x.removeChild(S);
        };
        S.style.pointerEvents = "none", S.style.position = "absolute", S.style.overflow = "hidden", S.setAttribute("aria-hidden", "true");
        const T = oy(S);
        T && (T.style.opacity = "0");
        const D = cr(S);
        D && (D.classList.add(p ? n[ye.caption_before_exit] : n[ye.caption_after_exit]), D.addEventListener("animationend", P));
        const O = lr(S);
        O && O.classList.add(p ? n[ye.weeks_before_exit] : n[ye.weeks_after_exit]), x.insertBefore(S, x.firstChild);
      });
    }
  });
}
function ay(e, t, n, o) {
  const r = e[0], a = e[e.length - 1], { ISOWeek: i, fixedWeeks: s, broadcastCalendar: d } = n ?? {}, { addDays: f, differenceInCalendarDays: u, differenceInCalendarMonths: p, endOfBroadcastWeek: m, endOfISOWeek: h, endOfMonth: g, endOfWeek: v, isAfter: b, startOfBroadcastWeek: w, startOfISOWeek: y, startOfWeek: x } = o, E = d ? w(r, o) : i ? y(r) : x(r), S = d ? m(a) : i ? h(g(a)) : v(g(a)), R = u(S, E), M = p(a, r) + 1, P = [];
  for (let O = 0; O <= R; O++) {
    const B = f(E, O);
    if (t && b(B, t))
      break;
    P.push(B);
  }
  const D = (d ? 35 : 42) * M;
  if (s && P.length < D) {
    const O = D - P.length;
    for (let B = 0; B < O; B++) {
      const K = f(P[P.length - 1], 1);
      P.push(K);
    }
  }
  return P;
}
function sy(e) {
  const t = [];
  return e.reduce((n, o) => {
    const r = o.weeks.reduce((a, i) => a.concat(i.days.slice()), t.slice());
    return n.concat(r.slice());
  }, t.slice());
}
function iy(e, t, n, o) {
  const { numberOfMonths: r = 1 } = n, a = [];
  for (let i = 0; i < r; i++) {
    const s = o.addMonths(e, i);
    if (t && s > t)
      break;
    a.push(s);
  }
  return a;
}
function Bs(e, t, n, o) {
  const { month: r, defaultMonth: a, today: i = o.today(), numberOfMonths: s = 1 } = e;
  let d = r || a || i;
  const { differenceInCalendarMonths: f, addMonths: u, startOfMonth: p } = o;
  if (n && f(n, d) < s - 1) {
    const m = -1 * (s - 1);
    d = u(n, m);
  }
  return t && f(d, t) < 0 && (d = t), p(d);
}
function cy(e, t, n, o) {
  const { addDays: r, endOfBroadcastWeek: a, endOfISOWeek: i, endOfMonth: s, endOfWeek: d, getISOWeek: f, getWeek: u, startOfBroadcastWeek: p, startOfISOWeek: m, startOfWeek: h } = o, g = e.reduce((v, b) => {
    const w = n.broadcastCalendar ? p(b, o) : n.ISOWeek ? m(b) : h(b), y = n.broadcastCalendar ? a(b) : n.ISOWeek ? i(s(b)) : d(s(b)), x = t.filter((M) => M >= w && M <= y), E = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && x.length < E) {
      const M = t.filter((P) => {
        const T = E - x.length;
        return P > y && P <= r(y, T);
      });
      x.push(...M);
    }
    const S = x.reduce((M, P) => {
      const T = n.ISOWeek ? f(P) : u(P), D = M.find((B) => B.weekNumber === T), O = new Dc(P, b, o);
      return D ? D.days.push(O) : M.push(new Jb(T, [O])), M;
    }, []), R = new Zb(b, S);
    return v.push(R), v;
  }, []);
  return n.reverseMonths ? g.reverse() : g;
}
function ly(e, t) {
  let { startMonth: n, endMonth: o } = e;
  const { startOfYear: r, startOfDay: a, startOfMonth: i, endOfMonth: s, addYears: d, endOfYear: f, newDate: u, today: p } = t, { fromYear: m, toYear: h, fromMonth: g, toMonth: v } = e;
  !n && g && (n = g), !n && m && (n = t.newDate(m, 0, 1)), !o && v && (o = v), !o && h && (o = u(h, 11, 31));
  const b = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = i(n) : m ? n = u(m, 0, 1) : !n && b && (n = r(d(e.today ?? p(), -100))), o ? o = s(o) : h ? o = u(h, 11, 31) : !o && b && (o = f(e.today ?? p())), [
    n && a(n),
    o && a(o)
  ];
}
function dy(e, t, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: a = 1 } = n, { startOfMonth: i, addMonths: s, differenceInCalendarMonths: d } = o, f = r ? a : 1, u = i(e);
  if (!t)
    return s(u, f);
  if (!(d(t, e) < a))
    return s(u, f);
}
function uy(e, t, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: a } = n, { startOfMonth: i, addMonths: s, differenceInCalendarMonths: d } = o, f = r ? a ?? 1 : 1, u = i(e);
  if (!t)
    return s(u, -f);
  if (!(d(u, t) <= 0))
    return s(u, -f);
}
function fy(e) {
  const t = [];
  return e.reduce((n, o) => n.concat(o.weeks.slice()), t.slice());
}
function go(e, t) {
  const [n, o] = Jt(e);
  return [t === void 0 ? n : t, o];
}
function py(e, t) {
  const [n, o] = ly(e, t), { startOfMonth: r, endOfMonth: a } = t, i = Bs(e, n, o, t), [s, d] = go(
    i,
    // initialMonth is always computed from props.month if provided
    e.month ? i : void 0
  );
  ui(() => {
    const R = Bs(e, n, o, t);
    d(R);
  }, [e.timeZone]);
  const f = iy(s, o, e, t), u = ay(f, e.endMonth ? a(e.endMonth) : void 0, e, t), p = cy(f, u, e, t), m = fy(p), h = sy(p), g = uy(s, n, e, t), v = dy(s, o, e, t), { disableNavigation: b, onMonthChange: w } = e, y = (R) => m.some((M) => M.days.some((P) => P.isEqualTo(R))), x = (R) => {
    if (b)
      return;
    let M = r(R);
    n && M < r(n) && (M = r(n)), o && M > r(o) && (M = r(o)), d(M), w?.(M);
  };
  return {
    months: p,
    weeks: m,
    days: h,
    navStart: n,
    navEnd: o,
    previousMonth: g,
    nextMonth: v,
    goToMonth: x,
    goToDay: (R) => {
      y(R) || x(R.date);
    }
  };
}
var Fe;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(Fe || (Fe = {}));
function Vs(e) {
  return !e[se.disabled] && !e[se.hidden] && !e[se.outside];
}
function my(e, t, n, o) {
  let r, a = -1;
  for (const i of e) {
    const s = t(i);
    Vs(s) && (s[se.focused] && a < Fe.FocusedModifier ? (r = i, a = Fe.FocusedModifier) : o?.isEqualTo(i) && a < Fe.LastFocused ? (r = i, a = Fe.LastFocused) : n(i.date) && a < Fe.Selected ? (r = i, a = Fe.Selected) : s[se.today] && a < Fe.Today && (r = i, a = Fe.Today));
  }
  return r || (r = e.find((i) => Vs(t(i)))), r;
}
function vy(e, t, n, o, r, a, i) {
  const { ISOWeek: s, broadcastCalendar: d } = a, { addDays: f, addMonths: u, addWeeks: p, addYears: m, endOfBroadcastWeek: h, endOfISOWeek: g, endOfWeek: v, max: b, min: w, startOfBroadcastWeek: y, startOfISOWeek: x, startOfWeek: E } = i;
  let R = {
    day: f,
    week: p,
    month: u,
    year: m,
    startOfWeek: (M) => d ? y(M, i) : s ? x(M) : E(M),
    endOfWeek: (M) => d ? h(M) : s ? g(M) : v(M)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && o ? R = b([o, R]) : t === "after" && r && (R = w([r, R])), R;
}
function Hc(e, t, n, o, r, a, i, s = 0) {
  if (s > 365)
    return;
  const d = vy(e, t, n.date, o, r, a, i), f = !!(a.disabled && qe(d, a.disabled, i)), u = !!(a.hidden && qe(d, a.hidden, i)), p = d, m = new Dc(d, p, i);
  return !f && !u ? m : Hc(e, t, m, o, r, a, i, s + 1);
}
function hy(e, t, n, o, r) {
  const { autoFocus: a } = e, [i, s] = Jt(), d = my(t.days, n, o || (() => !1), i), [f, u] = Jt(a ? d : void 0);
  return {
    isFocusTarget: (v) => !!d?.isEqualTo(v),
    setFocused: u,
    focused: f,
    blur: () => {
      s(f), u(void 0);
    },
    moveFocus: (v, b) => {
      if (!f)
        return;
      const w = Hc(v, b, f, t.navStart, t.navEnd, e, r);
      w && (t.goToDay(w), u(w));
    }
  };
}
function gy(e, t) {
  const { selected: n, required: o, onSelect: r } = e, [a, i] = go(n, r ? n : void 0), s = r ? n : a, { isSameDay: d } = t, f = (h) => s?.some((g) => d(g, h)) ?? !1, { min: u, max: p } = e;
  return {
    selected: s,
    select: (h, g, v) => {
      let b = [...s ?? []];
      if (f(h)) {
        if (s?.length === u || o && s?.length === 1)
          return;
        b = s?.filter((w) => !d(w, h));
      } else
        s?.length === p ? b = [h] : b = [...b, h];
      return r || i(b), r?.(b, h, g, v), b;
    },
    isSelected: f
  };
}
function by(e, t, n = 0, o = 0, r = !1, a = Ge) {
  const { from: i, to: s } = t || {}, { isSameDay: d, isAfter: f, isBefore: u } = a;
  let p;
  if (!i && !s)
    p = { from: e, to: n > 0 ? void 0 : e };
  else if (i && !s)
    d(i, e) ? n === 0 ? p = { from: i, to: e } : r ? p = { from: i, to: void 0 } : p = void 0 : u(e, i) ? p = { from: e, to: i } : p = { from: i, to: e };
  else if (i && s)
    if (d(i, e) && d(s, e))
      r ? p = { from: i, to: s } : p = void 0;
    else if (d(i, e))
      p = { from: i, to: n > 0 ? void 0 : e };
    else if (d(s, e))
      p = { from: e, to: n > 0 ? void 0 : e };
    else if (u(e, i))
      p = { from: e, to: s };
    else if (f(e, i))
      p = { from: i, to: e };
    else if (f(e, s))
      p = { from: i, to: e };
    else
      throw new Error("Invalid range");
  if (p?.from && p?.to) {
    const m = a.differenceInCalendarDays(p.to, p.from);
    o > 0 && m > o ? p = { from: e, to: void 0 } : n > 1 && m < n && (p = { from: e, to: void 0 });
  }
  return p;
}
function wy(e, t, n = Ge) {
  const o = Array.isArray(t) ? t : [t];
  let r = e.from;
  const a = n.differenceInCalendarDays(e.to, e.from), i = Math.min(a, 6);
  for (let s = 0; s <= i; s++) {
    if (o.includes(r.getDay()))
      return !0;
    r = n.addDays(r, 1);
  }
  return !1;
}
function Hs(e, t, n = Ge) {
  return Xe(e, t.from, !1, n) || Xe(e, t.to, !1, n) || Xe(t, e.from, !1, n) || Xe(t, e.to, !1, n);
}
function yy(e, t, n = Ge) {
  const o = Array.isArray(t) ? t : [t];
  if (o.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? Xe(e, s, !1, n) : Fc(s, n) ? s.some((d) => Xe(e, d, !1, n)) : ua(s) ? s.from && s.to ? Hs(e, { from: s.from, to: s.to }, n) : !1 : Lc(s) ? wy(e, s.dayOfWeek, n) : Oc(s) ? n.isAfter(s.before, s.after) ? Hs(e, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : qe(e.from, s, n) || qe(e.to, s, n) : kc(s) || $c(s) ? qe(e.from, s, n) || qe(e.to, s, n) : !1))
    return !0;
  const i = o.filter((s) => typeof s == "function");
  if (i.length) {
    let s = e.from;
    const d = n.differenceInCalendarDays(e.to, e.from);
    for (let f = 0; f <= d; f++) {
      if (i.some((u) => u(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function xy(e, t) {
  const { disabled: n, excludeDisabled: o, selected: r, required: a, onSelect: i } = e, [s, d] = go(r, i ? r : void 0), f = i ? r : s;
  return {
    selected: f,
    select: (m, h, g) => {
      const { min: v, max: b } = e, w = m ? by(m, f, v, b, a, t) : void 0;
      return o && n && w?.from && w.to && yy({ from: w.from, to: w.to }, n, t) && (w.from = m, w.to = void 0), i || d(w), i?.(w, m, h, g), w;
    },
    isSelected: (m) => f && Xe(f, m, !1, t)
  };
}
function Cy(e, t) {
  const { selected: n, required: o, onSelect: r } = e, [a, i] = go(n, r ? n : void 0), s = r ? n : a, { isSameDay: d } = t;
  return {
    selected: s,
    select: (p, m, h) => {
      let g = p;
      return !o && s && s && d(p, s) && (g = void 0), r || i(g), r?.(g, p, m, h), g;
    },
    isSelected: (p) => s ? d(s, p) : !1
  };
}
function Sy(e, t) {
  const n = Cy(e, t), o = gy(e, t), r = xy(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return o;
    case "range":
      return r;
    default:
      return;
  }
}
function Ey(e) {
  let t = e;
  t.timeZone && (t = {
    ...e
  }, t.today && (t.today = new ve(t.today, t.timeZone)), t.month && (t.month = new ve(t.month, t.timeZone)), t.defaultMonth && (t.defaultMonth = new ve(t.defaultMonth, t.timeZone)), t.startMonth && (t.startMonth = new ve(t.startMonth, t.timeZone)), t.endMonth && (t.endMonth = new ve(t.endMonth, t.timeZone)), t.mode === "single" && t.selected ? t.selected = new ve(t.selected, t.timeZone) : t.mode === "multiple" && t.selected ? t.selected = t.selected?.map((Y) => new ve(Y, t.timeZone)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? new ve(t.selected.from, t.timeZone) : void 0,
    to: t.selected.to ? new ve(t.selected.to, t.timeZone) : void 0
  }));
  const { components: n, formatters: o, labels: r, dateLib: a, locale: i, classNames: s } = Xo(() => {
    const Y = { ...Tc, ...t.locale };
    return {
      dateLib: new rt({
        locale: Y,
        weekStartsOn: t.broadcastCalendar ? 1 : t.weekStartsOn,
        firstWeekContainsDate: t.firstWeekContainsDate,
        useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
        timeZone: t.timeZone,
        numerals: t.numerals
      }, t.dateLib),
      components: Pw(t.components),
      formatters: Fw(t.formatters),
      labels: { ...ey, ...t.labels },
      locale: Y,
      classNames: { ...fa(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]), { captionLayout: d, mode: f, navLayout: u, numberOfMonths: p = 1, onDayBlur: m, onDayClick: h, onDayFocus: g, onDayKeyDown: v, onDayMouseEnter: b, onDayMouseLeave: w, onNextClick: y, onPrevClick: x, showWeekNumber: E, styles: S } = t, { formatCaption: R, formatDay: M, formatMonthDropdown: P, formatWeekNumber: T, formatWeekNumberHeader: D, formatWeekdayName: O, formatYearDropdown: B } = o, K = py(t, a), { days: k, months: G, navStart: L, navEnd: H, previousMonth: $, nextMonth: I, goToMonth: j } = K, ce = Rw(k, t, L, H, a), { isSelected: fe, select: pe, selected: de } = Sy(t, a) ?? {}, { blur: Ee, focused: me, isFocusTarget: F, moveFocus: Z, setFocused: ue } = hy(t, K, ce, fe ?? (() => !1), a), { labelDayButton: J, labelGridcell: te, labelGrid: ie, labelMonthDropdown: we, labelNav: Le, labelPrevious: Gt, labelNext: Kt, labelWeekday: Ut, labelWeekNumber: lm, labelWeekNumberHeader: dm, labelYearDropdown: um } = r, fm = Xo(() => Bw(a, t.ISOWeek), [a, t.ISOWeek]), ws = f !== void 0 || h !== void 0, Ko = Re(() => {
    $ && (j($), x?.($));
  }, [$, j, x]), Uo = Re(() => {
    I && (j(I), y?.(I));
  }, [j, I, y]), pm = Re((Y, re) => (U) => {
    U.preventDefault(), U.stopPropagation(), ue(Y), pe?.(Y.date, re, U), h?.(Y.date, re, U);
  }, [pe, h, ue]), mm = Re((Y, re) => (U) => {
    ue(Y), g?.(Y.date, re, U);
  }, [g, ue]), vm = Re((Y, re) => (U) => {
    Ee(), m?.(Y.date, re, U);
  }, [Ee, m]), hm = Re((Y, re) => (U) => {
    const ae = {
      ArrowLeft: [
        U.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        U.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [U.shiftKey ? "year" : "week", "after"],
      ArrowUp: [U.shiftKey ? "year" : "week", "before"],
      PageUp: [U.shiftKey ? "year" : "month", "before"],
      PageDown: [U.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (ae[U.key]) {
      U.preventDefault(), U.stopPropagation();
      const [Me, X] = ae[U.key];
      Z(Me, X);
    }
    v?.(Y.date, re, U);
  }, [Z, v, t.dir]), gm = Re((Y, re) => (U) => {
    b?.(Y.date, re, U);
  }, [b]), bm = Re((Y, re) => (U) => {
    w?.(Y.date, re, U);
  }, [w]), wm = Re((Y) => (re) => {
    const U = Number(re.target.value), ae = a.setMonth(a.startOfMonth(Y), U);
    j(ae);
  }, [a, j]), ym = Re((Y) => (re) => {
    const U = Number(re.target.value), ae = a.setYear(a.startOfMonth(Y), U);
    j(ae);
  }, [a, j]), { className: xm, style: Cm } = Xo(() => ({
    className: [s[V.Root], t.className].filter(Boolean).join(" "),
    style: { ...S?.[V.Root], ...t.style }
  }), [s, t.className, t.style, S]), Sm = _w(t), ys = zn(null);
  ry(ys, !!t.animate, {
    classNames: s,
    months: G,
    focused: me,
    dateLib: a
  });
  const Em = {
    dayPickerProps: t,
    selected: de,
    select: pe,
    isSelected: fe,
    months: G,
    nextMonth: I,
    previousMonth: $,
    goToMonth: j,
    getModifiers: ce,
    components: n,
    classNames: s,
    styles: S,
    labels: r,
    formatters: o
  };
  return _.createElement(
    Ic.Provider,
    { value: Em },
    _.createElement(
      n.Root,
      { rootRef: t.animate ? ys : void 0, className: xm, style: Cm, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], ...Sm },
      _.createElement(
        n.Months,
        { className: s[V.Months], style: S?.[V.Months] },
        !t.hideNavigation && !u && _.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: s[V.Nav], style: S?.[V.Nav], "aria-label": Le(), onPreviousClick: Ko, onNextClick: Uo, previousMonth: $, nextMonth: I }),
        G.map((Y, re) => _.createElement(
          n.Month,
          {
            "data-animated-month": t.animate ? "true" : void 0,
            className: s[V.Month],
            style: S?.[V.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: re,
            displayIndex: re,
            calendarMonth: Y
          },
          u === "around" && !t.hideNavigation && re === 0 && _.createElement(
            n.PreviousMonthButton,
            { type: "button", className: s[V.PreviousMonthButton], tabIndex: $ ? void 0 : -1, "aria-disabled": $ ? void 0 : !0, "aria-label": Gt($), onClick: Ko, "data-animated-button": t.animate ? "true" : void 0 },
            _.createElement(n.Chevron, { disabled: $ ? void 0 : !0, className: s[V.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
          ),
          _.createElement(n.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: s[V.MonthCaption], style: S?.[V.MonthCaption], calendarMonth: Y, displayIndex: re }, d?.startsWith("dropdown") ? _.createElement(
            n.DropdownNav,
            { className: s[V.Dropdowns], style: S?.[V.Dropdowns] },
            d === "dropdown" || d === "dropdown-months" ? _.createElement(n.MonthsDropdown, { className: s[V.MonthsDropdown], "aria-label": we(), classNames: s, components: n, disabled: !!t.disableNavigation, onChange: wm(Y.date), options: Ww(Y.date, L, H, o, a), style: S?.[V.Dropdown], value: a.getMonth(Y.date) }) : _.createElement("span", null, P(Y.date, a)),
            d === "dropdown" || d === "dropdown-years" ? _.createElement(n.YearsDropdown, { className: s[V.YearsDropdown], "aria-label": um(a.options), classNames: s, components: n, disabled: !!t.disableNavigation, onChange: ym(Y.date), options: Vw(L, H, o, a, !!t.reverseYears), style: S?.[V.Dropdown], value: a.getYear(Y.date) }) : _.createElement("span", null, B(Y.date, a)),
            _.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, R(Y.date, a.options, a))
          ) : (
            // biome-ignore lint/a11y/useSemanticElements: breaking change
            _.createElement(n.CaptionLabel, { className: s[V.CaptionLabel], role: "status", "aria-live": "polite" }, R(Y.date, a.options, a))
          )),
          u === "around" && !t.hideNavigation && re === p - 1 && _.createElement(
            n.NextMonthButton,
            { type: "button", className: s[V.NextMonthButton], tabIndex: I ? void 0 : -1, "aria-disabled": I ? void 0 : !0, "aria-label": Kt(I), onClick: Uo, "data-animated-button": t.animate ? "true" : void 0 },
            _.createElement(n.Chevron, { disabled: I ? void 0 : !0, className: s[V.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
          ),
          re === p - 1 && u === "after" && !t.hideNavigation && _.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: s[V.Nav], style: S?.[V.Nav], "aria-label": Le(), onPreviousClick: Ko, onNextClick: Uo, previousMonth: $, nextMonth: I }),
          _.createElement(
            n.MonthGrid,
            { role: "grid", "aria-multiselectable": f === "multiple" || f === "range", "aria-label": ie(Y.date, a.options, a) || void 0, className: s[V.MonthGrid], style: S?.[V.MonthGrid] },
            !t.hideWeekdays && _.createElement(
              n.Weekdays,
              { "data-animated-weekdays": t.animate ? "true" : void 0, className: s[V.Weekdays], style: S?.[V.Weekdays] },
              E && _.createElement(n.WeekNumberHeader, { "aria-label": dm(a.options), className: s[V.WeekNumberHeader], style: S?.[V.WeekNumberHeader], scope: "col" }, D()),
              fm.map((U) => _.createElement(n.Weekday, { "aria-label": Ut(U, a.options, a), className: s[V.Weekday], key: String(U), style: S?.[V.Weekday], scope: "col" }, O(U, a.options, a)))
            ),
            _.createElement(n.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: s[V.Weeks], style: S?.[V.Weeks] }, Y.weeks.map((U) => _.createElement(
              n.Week,
              { className: s[V.Week], key: U.weekNumber, style: S?.[V.Week], week: U },
              E && // biome-ignore lint/a11y/useSemanticElements: react component
              _.createElement(n.WeekNumber, { week: U, style: S?.[V.WeekNumber], "aria-label": lm(U.weekNumber, {
                locale: i
              }), className: s[V.WeekNumber], scope: "row", role: "rowheader" }, T(U.weekNumber, a)),
              U.days.map((ae) => {
                const { date: Me } = ae, X = ce(ae);
                if (X[se.focused] = !X.hidden && !!me?.isEqualTo(ae), X[Ae.selected] = fe?.(Me) || X.selected, ua(de)) {
                  const { from: Yo, to: jo } = de;
                  X[Ae.range_start] = !!(Yo && jo && a.isSameDay(Me, Yo)), X[Ae.range_end] = !!(Yo && jo && a.isSameDay(Me, jo)), X[Ae.range_middle] = Xe(de, Me, !0, a);
                }
                const Mm = zw(X, S, t.modifiersStyles), Rm = Nw(X, s, t.modifiersClassNames), Nm = !ws && !X.hidden ? te(Me, X, a.options, a) : void 0;
                return (
                  // biome-ignore lint/a11y/useSemanticElements: react component
                  _.createElement(n.Day, { key: `${a.format(Me, "yyyy-MM-dd")}_${a.format(ae.displayMonth, "yyyy-MM")}`, day: ae, modifiers: X, className: Rm.join(" "), style: Mm, role: "gridcell", "aria-selected": X.selected || void 0, "aria-label": Nm, "data-day": a.format(Me, "yyyy-MM-dd"), "data-month": ae.outside ? a.format(Me, "yyyy-MM") : void 0, "data-selected": X.selected || void 0, "data-disabled": X.disabled || void 0, "data-hidden": X.hidden || void 0, "data-outside": ae.outside || void 0, "data-focused": X.focused || void 0, "data-today": X.today || void 0 }, !X.hidden && ws ? _.createElement(n.DayButton, { className: s[V.DayButton], style: S?.[V.DayButton], type: "button", day: ae, modifiers: X, disabled: X.disabled || void 0, tabIndex: F(ae) ? 0 : -1, "aria-label": J(Me, X, a.options, a), onClick: pm(ae, X), onBlur: vm(ae, X), onFocus: mm(ae, X), onKeyDown: hm(ae, X), onMouseEnter: gm(ae, X), onMouseLeave: bm(ae, X) }, M(Me, a.options, a)) : !X.hidden && M(ae.date, a.options, a))
                );
              })
            )))
          )
        ))
      ),
      t.footer && // biome-ignore lint/a11y/useSemanticElements: react component
      _.createElement(n.Footer, { className: s[V.Footer], style: S?.[V.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
function L_({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  captionLayout: o = "label",
  buttonVariant: r = "ghost",
  formatters: a,
  components: i,
  ...s
}) {
  const d = fa();
  return /* @__PURE__ */ c(
    Ey,
    {
      showOutsideDays: n,
      className: C(
        "bg-background group/calendar p-3 [--cell-size:--spacing(8)] [[data-slot=card-content]_&]:bg-transparent [[data-slot=popover-content]_&]:bg-transparent",
        String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`,
        String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`,
        e
      ),
      captionLayout: o,
      formatters: {
        formatMonthDropdown: (f) => f.toLocaleString("default", { month: "short" }),
        ...a
      },
      classNames: {
        root: C("w-fit", d.root),
        months: C(
          "flex gap-4 flex-col md:flex-row relative",
          d.months
        ),
        month: C("flex flex-col w-full gap-4", d.month),
        nav: C(
          "flex items-center gap-1 w-full absolute top-0 inset-x-0 justify-between",
          d.nav
        ),
        button_previous: C(
          en({ variant: r }),
          "size-(--cell-size) aria-disabled:opacity-50 p-0 select-none",
          d.button_previous
        ),
        button_next: C(
          en({ variant: r }),
          "size-(--cell-size) aria-disabled:opacity-50 p-0 select-none",
          d.button_next
        ),
        month_caption: C(
          "flex items-center justify-center h-(--cell-size) w-full px-(--cell-size)",
          d.month_caption
        ),
        dropdowns: C(
          "w-full flex items-center text-sm font-medium justify-center h-(--cell-size) gap-1.5",
          d.dropdowns
        ),
        dropdown_root: C(
          "relative has-focus:border-ring border border-input shadow-xs has-focus:ring-ring/50 has-focus:ring-[3px] rounded-md",
          d.dropdown_root
        ),
        dropdown: C(
          "absolute bg-popover inset-0 opacity-0",
          d.dropdown
        ),
        caption_label: C(
          "select-none font-medium",
          o === "label" ? "text-sm" : "rounded-md pl-2 pr-1 flex items-center gap-1 text-sm h-8 [&>svg]:text-muted-foreground [&>svg]:size-3.5",
          d.caption_label
        ),
        table: "w-full border-collapse",
        weekdays: C("flex", d.weekdays),
        weekday: C(
          "text-muted-foreground rounded-md flex-1 font-normal text-[0.8rem] select-none",
          d.weekday
        ),
        week: C("flex w-full mt-2", d.week),
        week_number_header: C(
          "select-none w-(--cell-size)",
          d.week_number_header
        ),
        week_number: C(
          "text-[0.8rem] select-none text-muted-foreground",
          d.week_number
        ),
        day: C(
          "relative w-full h-full p-0 text-center [&:first-child[data-selected=true]_button]:rounded-l-md [&:last-child[data-selected=true]_button]:rounded-r-md group/day aspect-square select-none",
          d.day
        ),
        range_start: C(
          "rounded-l-md bg-accent",
          d.range_start
        ),
        range_middle: C("rounded-none", d.range_middle),
        range_end: C("rounded-r-md bg-accent", d.range_end),
        today: C(
          "bg-accent text-accent-foreground rounded-md data-[selected=true]:rounded-none",
          d.today
        ),
        outside: C(
          "text-muted-foreground aria-selected:text-muted-foreground",
          d.outside
        ),
        disabled: C(
          "text-muted-foreground opacity-50",
          d.disabled
        ),
        hidden: C("invisible", d.hidden),
        ...t
      },
      components: {
        Root: ({ className: f, rootRef: u, ...p }) => /* @__PURE__ */ c(
          "div",
          {
            "data-slot": "calendar",
            ref: u,
            className: C(f),
            ...p
          }
        ),
        Chevron: ({ className: f, orientation: u, ...p }) => u === "left" ? /* @__PURE__ */ c(Am, { className: C("size-4", f), ...p }) : u === "right" ? /* @__PURE__ */ c(
          io,
          {
            className: C("size-4", f),
            ...p
          }
        ) : /* @__PURE__ */ c(ln, { className: C("size-4", f), ...p }),
        DayButton: My,
        WeekNumber: ({ children: f, ...u }) => /* @__PURE__ */ c("td", { ...u, children: /* @__PURE__ */ c("div", { className: "flex size-(--cell-size) items-center justify-center text-center", children: f }) }),
        ...i
      },
      ...s
    }
  );
}
function My({
  className: e,
  day: t,
  modifiers: n,
  ...o
}) {
  const r = fa(), a = l.useRef(null);
  return l.useEffect(() => {
    n.focused && a.current?.focus();
  }, [n.focused]), /* @__PURE__ */ c(
    Ze,
    {
      ref: a,
      variant: "ghost",
      size: "icon",
      "data-day": t.date.toLocaleDateString(),
      "data-selected-single": n.selected && !n.range_start && !n.range_end && !n.range_middle,
      "data-range-start": n.range_start,
      "data-range-end": n.range_end,
      "data-range-middle": n.range_middle,
      className: C(
        "data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground data-[range-middle=true]:bg-accent data-[range-middle=true]:text-accent-foreground data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-ring/50 dark:hover:text-accent-foreground flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 leading-none font-normal group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:ring-[3px] data-[range-end=true]:rounded-md data-[range-end=true]:rounded-r-md data-[range-middle=true]:rounded-none data-[range-start=true]:rounded-md data-[range-start=true]:rounded-l-md [&>span]:text-xs [&>span]:opacity-70",
        r.day,
        e
      ),
      ...o
    }
  );
}
function F_({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card",
      className: C(
        "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6",
        e
      ),
      ...t
    }
  );
}
function W_({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-header",
      className: C(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
        e
      ),
      ...t
    }
  );
}
function z_({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-title",
      className: C("leading-none font-semibold", e),
      ...t
    }
  );
}
function B_({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-description",
      className: C("text-muted-foreground text-sm", e),
      ...t
    }
  );
}
function V_({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-action",
      className: C(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        e
      ),
      ...t
    }
  );
}
function H_({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-content",
      className: C("px-6", e),
      ...t
    }
  );
}
function G_({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-footer",
      className: C("flex items-center px-6 [.border-t]:pt-6", e),
      ...t
    }
  );
}
const Gc = l.createContext(null);
function bo() {
  const e = l.useContext(Gc);
  if (!e)
    throw new Error("useCarousel must be used within a <Carousel />");
  return e;
}
function K_({
  orientation: e = "horizontal",
  opts: t,
  setApi: n,
  plugins: o,
  className: r,
  children: a,
  ...i
}) {
  const [s, d] = wv(
    {
      ...t,
      axis: e === "horizontal" ? "x" : "y"
    },
    o
  ), [f, u] = l.useState(!1), [p, m] = l.useState(!1), h = l.useCallback((w) => {
    w && (u(w.canScrollPrev()), m(w.canScrollNext()));
  }, []), g = l.useCallback(() => {
    d?.scrollPrev();
  }, [d]), v = l.useCallback(() => {
    d?.scrollNext();
  }, [d]), b = l.useCallback(
    (w) => {
      w.key === "ArrowLeft" ? (w.preventDefault(), g()) : w.key === "ArrowRight" && (w.preventDefault(), v());
    },
    [g, v]
  );
  return l.useEffect(() => {
    !d || !n || n(d);
  }, [d, n]), l.useEffect(() => {
    if (d)
      return h(d), d.on("reInit", h), d.on("select", h), () => {
        d?.off("select", h);
      };
  }, [d, h]), /* @__PURE__ */ c(
    Gc.Provider,
    {
      value: {
        carouselRef: s,
        api: d,
        opts: t,
        orientation: e || (t?.axis === "y" ? "vertical" : "horizontal"),
        scrollPrev: g,
        scrollNext: v,
        canScrollPrev: f,
        canScrollNext: p
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          onKeyDownCapture: b,
          className: C("relative", r),
          role: "region",
          "aria-roledescription": "carousel",
          "data-slot": "carousel",
          ...i,
          children: a
        }
      )
    }
  );
}
function U_({ className: e, ...t }) {
  const { carouselRef: n, orientation: o } = bo();
  return /* @__PURE__ */ c(
    "div",
    {
      ref: n,
      className: "overflow-hidden",
      "data-slot": "carousel-content",
      children: /* @__PURE__ */ c(
        "div",
        {
          className: C(
            "flex",
            o === "horizontal" ? "-ml-4" : "-mt-4 flex-col",
            e
          ),
          ...t
        }
      )
    }
  );
}
function Y_({ className: e, ...t }) {
  const { orientation: n } = bo();
  return /* @__PURE__ */ c(
    "div",
    {
      role: "group",
      "aria-roledescription": "slide",
      "data-slot": "carousel-item",
      className: C(
        "min-w-0 shrink-0 grow-0 basis-full",
        n === "horizontal" ? "pl-4" : "pt-4",
        e
      ),
      ...t
    }
  );
}
function j_({
  className: e,
  variant: t = "outline",
  size: n = "icon",
  ...o
}) {
  const { orientation: r, scrollPrev: a, canScrollPrev: i } = bo();
  return /* @__PURE__ */ z(
    Ze,
    {
      "data-slot": "carousel-previous",
      variant: t,
      size: n,
      className: C(
        "absolute size-8 rounded-full",
        r === "horizontal" ? "top-1/2 -left-12 -translate-y-1/2" : "-top-12 left-1/2 -translate-x-1/2 rotate-90",
        e
      ),
      disabled: !i,
      onClick: a,
      ...o,
      children: [
        /* @__PURE__ */ c(Im, {}),
        /* @__PURE__ */ c("span", { className: "sr-only", children: "Previous slide" })
      ]
    }
  );
}
function X_({
  className: e,
  variant: t = "outline",
  size: n = "icon",
  ...o
}) {
  const { orientation: r, scrollNext: a, canScrollNext: i } = bo();
  return /* @__PURE__ */ z(
    Ze,
    {
      "data-slot": "carousel-next",
      variant: t,
      size: n,
      className: C(
        "absolute size-8 rounded-full",
        r === "horizontal" ? "top-1/2 -right-12 -translate-y-1/2" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90",
        e
      ),
      disabled: !i,
      onClick: a,
      ...o,
      children: [
        /* @__PURE__ */ c(Dm, {}),
        /* @__PURE__ */ c("span", { className: "sr-only", children: "Next slide" })
      ]
    }
  );
}
function Lt(e) {
  const t = l.useRef({ value: e, previous: e });
  return l.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function hn(e) {
  const [t, n] = l.useState(void 0);
  return oe(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const a = r[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const d = a.borderBoxSize, f = Array.isArray(d) ? d[0] : d;
          i = f.inlineSize, s = f.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({ width: i, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var wo = "Checkbox", [Ry, q_] = Q(wo), [Ny, pa] = Ry(wo);
function Py(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: o,
    defaultChecked: r,
    disabled: a,
    form: i,
    name: s,
    onCheckedChange: d,
    required: f,
    value: u = "on",
    // @ts-expect-error
    internal_do_not_use_render: p
  } = e, [m, h] = ne({
    prop: n,
    defaultProp: r ?? !1,
    onChange: d,
    caller: wo
  }), [g, v] = l.useState(null), [b, w] = l.useState(null), y = l.useRef(!1), x = g ? !!i || !!g.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), E = {
    checked: m,
    disabled: a,
    setChecked: h,
    control: g,
    setControl: v,
    name: s,
    form: i,
    value: u,
    hasConsumerStoppedPropagationRef: y,
    required: f,
    defaultChecked: st(r) ? !1 : r,
    isFormControl: x,
    bubbleInput: b,
    setBubbleInput: w
  };
  return /* @__PURE__ */ c(
    Ny,
    {
      scope: t,
      ...E,
      children: _y(p) ? p(E) : o
    }
  );
}
var Kc = "CheckboxTrigger", Uc = l.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...o }, r) => {
    const {
      control: a,
      value: i,
      disabled: s,
      checked: d,
      required: f,
      setControl: u,
      setChecked: p,
      hasConsumerStoppedPropagationRef: m,
      isFormControl: h,
      bubbleInput: g
    } = pa(Kc, e), v = W(r, u), b = l.useRef(d);
    return l.useEffect(() => {
      const w = a?.form;
      if (w) {
        const y = () => p(b.current);
        return w.addEventListener("reset", y), () => w.removeEventListener("reset", y);
      }
    }, [a, p]), /* @__PURE__ */ c(
      A.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": st(d) ? "mixed" : d,
        "aria-required": f,
        "data-state": Jc(d),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: i,
        ...o,
        ref: v,
        onKeyDown: N(t, (w) => {
          w.key === "Enter" && w.preventDefault();
        }),
        onClick: N(n, (w) => {
          p((y) => st(y) ? !0 : !y), g && h && (m.current = w.isPropagationStopped(), m.current || w.stopPropagation());
        })
      }
    );
  }
);
Uc.displayName = Kc;
var Yc = l.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: o,
      checked: r,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: d,
      onCheckedChange: f,
      form: u,
      ...p
    } = e;
    return /* @__PURE__ */ c(
      Py,
      {
        __scopeCheckbox: n,
        checked: r,
        defaultChecked: a,
        disabled: s,
        required: i,
        onCheckedChange: f,
        name: o,
        form: u,
        value: d,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ z(Se, { children: [
          /* @__PURE__ */ c(
            Uc,
            {
              ...p,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          m && /* @__PURE__ */ c(
            Zc,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
Yc.displayName = wo;
var jc = "CheckboxIndicator", Xc = l.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: o, ...r } = e, a = pa(jc, n);
    return /* @__PURE__ */ c(
      ee,
      {
        present: o || st(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ c(
          A.span,
          {
            "data-state": Jc(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...r,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
Xc.displayName = jc;
var qc = "CheckboxBubbleInput", Zc = l.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: o,
      hasConsumerStoppedPropagationRef: r,
      checked: a,
      defaultChecked: i,
      required: s,
      disabled: d,
      name: f,
      value: u,
      form: p,
      bubbleInput: m,
      setBubbleInput: h
    } = pa(qc, e), g = W(n, h), v = Lt(a), b = hn(o);
    l.useEffect(() => {
      const y = m;
      if (!y) return;
      const x = window.HTMLInputElement.prototype, S = Object.getOwnPropertyDescriptor(
        x,
        "checked"
      ).set, R = !r.current;
      if (v !== a && S) {
        const M = new Event("click", { bubbles: R });
        y.indeterminate = st(a), S.call(y, st(a) ? !1 : a), y.dispatchEvent(M);
      }
    }, [m, v, a, r]);
    const w = l.useRef(st(a) ? !1 : a);
    return /* @__PURE__ */ c(
      A.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: i ?? w.current,
        required: s,
        disabled: d,
        name: f,
        value: u,
        form: p,
        ...t,
        tabIndex: -1,
        ref: g,
        style: {
          ...t.style,
          ...b,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
Zc.displayName = qc;
function _y(e) {
  return typeof e == "function";
}
function st(e) {
  return e === "indeterminate";
}
function Jc(e) {
  return st(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Z_({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Yc,
    {
      "data-slot": "checkbox",
      className: C(
        "peer border-input dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t,
      children: /* @__PURE__ */ c(
        Xc,
        {
          "data-slot": "checkbox-indicator",
          className: "flex items-center justify-center text-current transition-none",
          children: /* @__PURE__ */ c(dn, { className: "size-3.5" })
        }
      )
    }
  );
}
function J_({
  ...e
}) {
  return /* @__PURE__ */ c(xi, { "data-slot": "collapsible", ...e });
}
function Q_({
  ...e
}) {
  return /* @__PURE__ */ c(
    Yr,
    {
      "data-slot": "collapsible-trigger",
      ...e
    }
  );
}
function eT({
  ...e
}) {
  return /* @__PURE__ */ c(
    Xr,
    {
      "data-slot": "collapsible-content",
      ...e
    }
  );
}
function Ty({
  ...e
}) {
  return /* @__PURE__ */ c(oa, { "data-slot": "dialog", ...e });
}
function tT({
  ...e
}) {
  return /* @__PURE__ */ c(ra, { "data-slot": "dialog-trigger", ...e });
}
function Ay({
  ...e
}) {
  return /* @__PURE__ */ c(aa, { "data-slot": "dialog-portal", ...e });
}
function nT({
  ...e
}) {
  return /* @__PURE__ */ c($t, { "data-slot": "dialog-close", ...e });
}
function Dy({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    sa,
    {
      "data-slot": "dialog-overlay",
      className: C(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
        e
      ),
      ...t
    }
  );
}
function Iy({
  className: e,
  children: t,
  showCloseButton: n = !0,
  ...o
}) {
  return /* @__PURE__ */ z(Ay, { "data-slot": "dialog-portal", children: [
    /* @__PURE__ */ c(Dy, {}),
    /* @__PURE__ */ z(
      ia,
      {
        "data-slot": "dialog-content",
        className: C(
          "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg",
          e
        ),
        ...o,
        children: [
          t,
          n && /* @__PURE__ */ z(
            $t,
            {
              "data-slot": "dialog-close",
              className: "ring-offset-background bg-muted items-center focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 flex size-7 justify-center rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none rtl:right-auto rtl:left-4 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
              children: [
                /* @__PURE__ */ c(vi, { className: "text-muted-foreground !size-6" }),
                /* @__PURE__ */ c("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ]
      }
    )
  ] });
}
function Oy({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "dialog-header",
      className: C(
        "flex flex-col gap-2 text-center sm:text-left sm:rtl:text-right",
        e
      ),
      ...t
    }
  );
}
function oT({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "dialog-footer",
      className: C(
        "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
        e
      ),
      ...t
    }
  );
}
function ky({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    ca,
    {
      "data-slot": "dialog-title",
      className: C("text-lg leading-none font-semibold", e),
      ...t
    }
  );
}
function $y({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    la,
    {
      "data-slot": "dialog-description",
      className: C("text-muted-foreground text-sm", e),
      ...t
    }
  );
}
function Ly({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Ct,
    {
      "data-slot": "command",
      className: C(
        "bg-popover text-popover-foreground flex h-full w-full flex-col overflow-hidden rounded-md",
        e
      ),
      ...t
    }
  );
}
function rT({
  title: e = "Command Palette",
  description: t = "Search for a command to run...",
  children: n,
  className: o,
  showCloseButton: r = !0,
  ...a
}) {
  return /* @__PURE__ */ z(Ty, { ...a, children: [
    /* @__PURE__ */ z(Oy, { className: "sr-only", children: [
      /* @__PURE__ */ c(ky, { children: e }),
      /* @__PURE__ */ c($y, { children: t })
    ] }),
    /* @__PURE__ */ c(
      Iy,
      {
        className: C("overflow-hidden p-0", o),
        showCloseButton: r,
        children: /* @__PURE__ */ c(Ly, { className: "[&_[cmdk-group-heading]]:text-muted-foreground **:data-[slot=command-input-wrapper]:h-12 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group]]:px-2 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: n })
      }
    )
  ] });
}
function aT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ z(
    "div",
    {
      "data-slot": "command-input-wrapper",
      className: "flex h-9 items-center gap-2 border-b px-3",
      children: [
        /* @__PURE__ */ c(Om, { className: "size-4 shrink-0 opacity-50" }),
        /* @__PURE__ */ c(
          Ct.Input,
          {
            "data-slot": "command-input",
            className: C(
              "placeholder:text-muted-foreground flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50",
              e
            ),
            ...t
          }
        )
      ]
    }
  );
}
function sT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Ct.List,
    {
      "data-slot": "command-list",
      className: C(
        "max-h-[300px] scroll-py-1 overflow-x-hidden overflow-y-auto",
        e
      ),
      ...t
    }
  );
}
function iT({
  ...e
}) {
  return /* @__PURE__ */ c(
    Ct.Empty,
    {
      "data-slot": "command-empty",
      className: "py-6 text-center text-sm",
      ...e
    }
  );
}
function cT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Ct.Group,
    {
      "data-slot": "command-group",
      className: C(
        "text-foreground [&_[cmdk-group-heading]]:text-muted-foreground overflow-hidden p-1 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium",
        e
      ),
      ...t
    }
  );
}
function lT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Ct.Separator,
    {
      "data-slot": "command-separator",
      className: C("bg-border -mx-1 h-px", e),
      ...t
    }
  );
}
function dT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Ct.Item,
    {
      "data-slot": "command-item",
      className: C(
        "data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function uT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "span",
    {
      "data-slot": "command-shortcut",
      className: C(
        "text-muted-foreground ml-auto text-xs tracking-widest",
        e
      ),
      ...t
    }
  );
}
const Fy = ["top", "right", "bottom", "left"], ct = Math.min, xe = Math.max, Yn = Math.round, Ln = Math.floor, Ve = (e) => ({
  x: e,
  y: e
}), Wy = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, zy = {
  start: "end",
  end: "start"
};
function wr(e, t, n) {
  return xe(e, ct(t, n));
}
function Je(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Qe(e) {
  return e.split("-")[0];
}
function Ft(e) {
  return e.split("-")[1];
}
function ma(e) {
  return e === "x" ? "y" : "x";
}
function va(e) {
  return e === "y" ? "height" : "width";
}
const By = /* @__PURE__ */ new Set(["top", "bottom"]);
function Be(e) {
  return By.has(Qe(e)) ? "y" : "x";
}
function ha(e) {
  return ma(Be(e));
}
function Vy(e, t, n) {
  n === void 0 && (n = !1);
  const o = Ft(e), r = ha(e), a = va(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = jn(i)), [i, jn(i)];
}
function Hy(e) {
  const t = jn(e);
  return [yr(e), t, yr(t)];
}
function yr(e) {
  return e.replace(/start|end/g, (t) => zy[t]);
}
const Gs = ["left", "right"], Ks = ["right", "left"], Gy = ["top", "bottom"], Ky = ["bottom", "top"];
function Uy(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Ks : Gs : t ? Gs : Ks;
    case "left":
    case "right":
      return t ? Gy : Ky;
    default:
      return [];
  }
}
function Yy(e, t, n, o) {
  const r = Ft(e);
  let a = Uy(Qe(e), n === "start", o);
  return r && (a = a.map((i) => i + "-" + r), t && (a = a.concat(a.map(yr)))), a;
}
function jn(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Wy[t]);
}
function jy(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Qc(e) {
  return typeof e != "number" ? jy(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Xn(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function Us(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const a = Be(t), i = ha(t), s = va(i), d = Qe(t), f = a === "y", u = o.x + o.width / 2 - r.width / 2, p = o.y + o.height / 2 - r.height / 2, m = o[s] / 2 - r[s] / 2;
  let h;
  switch (d) {
    case "top":
      h = {
        x: u,
        y: o.y - r.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      h = {
        x: o.x + o.width,
        y: p
      };
      break;
    case "left":
      h = {
        x: o.x - r.width,
        y: p
      };
      break;
    default:
      h = {
        x: o.x,
        y: o.y
      };
  }
  switch (Ft(t)) {
    case "start":
      h[i] -= m * (n && f ? -1 : 1);
      break;
    case "end":
      h[i] += m * (n && f ? -1 : 1);
      break;
  }
  return h;
}
const Xy = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: i
  } = n, s = a.filter(Boolean), d = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let f = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: u,
    y: p
  } = Us(f, o, d), m = o, h = {}, g = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: b,
      fn: w
    } = s[v], {
      x: y,
      y: x,
      data: E,
      reset: S
    } = await w({
      x: u,
      y: p,
      initialPlacement: o,
      placement: m,
      strategy: r,
      middlewareData: h,
      rects: f,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = y ?? u, p = x ?? p, h = {
      ...h,
      [b]: {
        ...h[b],
        ...E
      }
    }, S && g <= 50 && (g++, typeof S == "object" && (S.placement && (m = S.placement), S.rects && (f = S.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : S.rects), {
      x: u,
      y: p
    } = Us(f, m, d)), v = -1);
  }
  return {
    x: u,
    y: p,
    placement: m,
    strategy: r,
    middlewareData: h
  };
};
async function tn(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: a,
    rects: i,
    elements: s,
    strategy: d
  } = e, {
    boundary: f = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: p = "floating",
    altBoundary: m = !1,
    padding: h = 0
  } = Je(t, e), g = Qc(h), b = s[m ? p === "floating" ? "reference" : "floating" : p], w = Xn(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(b))) == null || n ? b : b.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: f,
    rootBoundary: u,
    strategy: d
  })), y = p === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), E = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Xn(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: x,
    strategy: d
  }) : y);
  return {
    top: (w.top - S.top + g.top) / E.y,
    bottom: (S.bottom - w.bottom + g.bottom) / E.y,
    left: (w.left - S.left + g.left) / E.x,
    right: (S.right - w.right + g.right) / E.x
  };
}
const qy = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: d
    } = t, {
      element: f,
      padding: u = 0
    } = Je(e, t) || {};
    if (f == null)
      return {};
    const p = Qc(u), m = {
      x: n,
      y: o
    }, h = ha(r), g = va(h), v = await i.getDimensions(f), b = h === "y", w = b ? "top" : "left", y = b ? "bottom" : "right", x = b ? "clientHeight" : "clientWidth", E = a.reference[g] + a.reference[h] - m[h] - a.floating[g], S = m[h] - a.reference[h], R = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(f));
    let M = R ? R[x] : 0;
    (!M || !await (i.isElement == null ? void 0 : i.isElement(R))) && (M = s.floating[x] || a.floating[g]);
    const P = E / 2 - S / 2, T = M / 2 - v[g] / 2 - 1, D = ct(p[w], T), O = ct(p[y], T), B = D, K = M - v[g] - O, k = M / 2 - v[g] / 2 + P, G = wr(B, k, K), L = !d.arrow && Ft(r) != null && k !== G && a.reference[g] / 2 - (k < B ? D : O) - v[g] / 2 < 0, H = L ? k < B ? k - B : k - K : 0;
    return {
      [h]: m[h] + H,
      data: {
        [h]: G,
        centerOffset: k - G - H,
        ...L && {
          alignmentOffset: H
        }
      },
      reset: L
    };
  }
}), Zy = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: d,
        elements: f
      } = t, {
        mainAxis: u = !0,
        crossAxis: p = !0,
        fallbackPlacements: m,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: v = !0,
        ...b
      } = Je(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const w = Qe(r), y = Be(s), x = Qe(s) === s, E = await (d.isRTL == null ? void 0 : d.isRTL(f.floating)), S = m || (x || !v ? [jn(s)] : Hy(s)), R = g !== "none";
      !m && R && S.push(...Yy(s, v, g, E));
      const M = [s, ...S], P = await tn(t, b), T = [];
      let D = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (u && T.push(P[w]), p) {
        const k = Vy(r, i, E);
        T.push(P[k[0]], P[k[1]]);
      }
      if (D = [...D, {
        placement: r,
        overflows: T
      }], !T.every((k) => k <= 0)) {
        var O, B;
        const k = (((O = a.flip) == null ? void 0 : O.index) || 0) + 1, G = M[k];
        if (G && (!(p === "alignment" ? y !== Be(G) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        D.every(($) => Be($.placement) === y ? $.overflows[0] > 0 : !0)))
          return {
            data: {
              index: k,
              overflows: D
            },
            reset: {
              placement: G
            }
          };
        let L = (B = D.filter((H) => H.overflows[0] <= 0).sort((H, $) => H.overflows[1] - $.overflows[1])[0]) == null ? void 0 : B.placement;
        if (!L)
          switch (h) {
            case "bestFit": {
              var K;
              const H = (K = D.filter(($) => {
                if (R) {
                  const I = Be($.placement);
                  return I === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  I === "y";
                }
                return !0;
              }).map(($) => [$.placement, $.overflows.filter((I) => I > 0).reduce((I, j) => I + j, 0)]).sort(($, I) => $[1] - I[1])[0]) == null ? void 0 : K[0];
              H && (L = H);
              break;
            }
            case "initialPlacement":
              L = s;
              break;
          }
        if (r !== L)
          return {
            reset: {
              placement: L
            }
          };
      }
      return {};
    }
  };
};
function Ys(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function js(e) {
  return Fy.some((t) => e[t] >= 0);
}
const Jy = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...r
      } = Je(e, t);
      switch (o) {
        case "referenceHidden": {
          const a = await tn(t, {
            ...r,
            elementContext: "reference"
          }), i = Ys(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: js(i)
            }
          };
        }
        case "escaped": {
          const a = await tn(t, {
            ...r,
            altBoundary: !0
          }), i = Ys(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: js(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, el = /* @__PURE__ */ new Set(["left", "top"]);
async function Qy(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, a = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = Qe(n), s = Ft(n), d = Be(n) === "y", f = el.has(i) ? -1 : 1, u = a && d ? -1 : 1, p = Je(t, e);
  let {
    mainAxis: m,
    crossAxis: h,
    alignmentAxis: g
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: p.mainAxis || 0,
    crossAxis: p.crossAxis || 0,
    alignmentAxis: p.alignmentAxis
  };
  return s && typeof g == "number" && (h = s === "end" ? g * -1 : g), d ? {
    x: h * u,
    y: m * f
  } : {
    x: m * f,
    y: h * u
  };
}
const ex = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: a,
        placement: i,
        middlewareData: s
      } = t, d = await Qy(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: r + d.x,
        y: a + d.y,
        data: {
          ...d,
          placement: i
        }
      };
    }
  };
}, tx = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (b) => {
            let {
              x: w,
              y
            } = b;
            return {
              x: w,
              y
            };
          }
        },
        ...d
      } = Je(e, t), f = {
        x: n,
        y: o
      }, u = await tn(t, d), p = Be(Qe(r)), m = ma(p);
      let h = f[m], g = f[p];
      if (a) {
        const b = m === "y" ? "top" : "left", w = m === "y" ? "bottom" : "right", y = h + u[b], x = h - u[w];
        h = wr(y, h, x);
      }
      if (i) {
        const b = p === "y" ? "top" : "left", w = p === "y" ? "bottom" : "right", y = g + u[b], x = g - u[w];
        g = wr(y, g, x);
      }
      const v = s.fn({
        ...t,
        [m]: h,
        [p]: g
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - o,
          enabled: {
            [m]: a,
            [p]: i
          }
        }
      };
    }
  };
}, nx = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: d = !0,
        crossAxis: f = !0
      } = Je(e, t), u = {
        x: n,
        y: o
      }, p = Be(r), m = ma(p);
      let h = u[m], g = u[p];
      const v = Je(s, t), b = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (d) {
        const x = m === "y" ? "height" : "width", E = a.reference[m] - a.floating[x] + b.mainAxis, S = a.reference[m] + a.reference[x] - b.mainAxis;
        h < E ? h = E : h > S && (h = S);
      }
      if (f) {
        var w, y;
        const x = m === "y" ? "width" : "height", E = el.has(Qe(r)), S = a.reference[p] - a.floating[x] + (E && ((w = i.offset) == null ? void 0 : w[p]) || 0) + (E ? 0 : b.crossAxis), R = a.reference[p] + a.reference[x] + (E ? 0 : ((y = i.offset) == null ? void 0 : y[p]) || 0) - (E ? b.crossAxis : 0);
        g < S ? g = S : g > R && (g = R);
      }
      return {
        [m]: h,
        [p]: g
      };
    }
  };
}, ox = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        rects: a,
        platform: i,
        elements: s
      } = t, {
        apply: d = () => {
        },
        ...f
      } = Je(e, t), u = await tn(t, f), p = Qe(r), m = Ft(r), h = Be(r) === "y", {
        width: g,
        height: v
      } = a.floating;
      let b, w;
      p === "top" || p === "bottom" ? (b = p, w = m === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (w = p, b = m === "end" ? "top" : "bottom");
      const y = v - u.top - u.bottom, x = g - u.left - u.right, E = ct(v - u[b], y), S = ct(g - u[w], x), R = !t.middlewareData.shift;
      let M = E, P = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (P = x), (o = t.middlewareData.shift) != null && o.enabled.y && (M = y), R && !m) {
        const D = xe(u.left, 0), O = xe(u.right, 0), B = xe(u.top, 0), K = xe(u.bottom, 0);
        h ? P = g - 2 * (D !== 0 || O !== 0 ? D + O : xe(u.left, u.right)) : M = v - 2 * (B !== 0 || K !== 0 ? B + K : xe(u.top, u.bottom));
      }
      await d({
        ...t,
        availableWidth: P,
        availableHeight: M
      });
      const T = await i.getDimensions(s.floating);
      return g !== T.width || v !== T.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function yo() {
  return typeof window < "u";
}
function Wt(e) {
  return tl(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ce(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ke(e) {
  var t;
  return (t = (tl(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function tl(e) {
  return yo() ? e instanceof Node || e instanceof Ce(e).Node : !1;
}
function De(e) {
  return yo() ? e instanceof Element || e instanceof Ce(e).Element : !1;
}
function He(e) {
  return yo() ? e instanceof HTMLElement || e instanceof Ce(e).HTMLElement : !1;
}
function Xs(e) {
  return !yo() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ce(e).ShadowRoot;
}
const rx = /* @__PURE__ */ new Set(["inline", "contents"]);
function gn(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = Ie(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !rx.has(r);
}
const ax = /* @__PURE__ */ new Set(["table", "td", "th"]);
function sx(e) {
  return ax.has(Wt(e));
}
const ix = [":popover-open", ":modal"];
function xo(e) {
  return ix.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const cx = ["transform", "translate", "scale", "rotate", "perspective"], lx = ["transform", "translate", "scale", "rotate", "perspective", "filter"], dx = ["paint", "layout", "strict", "content"];
function ga(e) {
  const t = ba(), n = De(e) ? Ie(e) : e;
  return cx.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || lx.some((o) => (n.willChange || "").includes(o)) || dx.some((o) => (n.contain || "").includes(o));
}
function ux(e) {
  let t = lt(e);
  for (; He(t) && !At(t); ) {
    if (ga(t))
      return t;
    if (xo(t))
      return null;
    t = lt(t);
  }
  return null;
}
function ba() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const fx = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function At(e) {
  return fx.has(Wt(e));
}
function Ie(e) {
  return Ce(e).getComputedStyle(e);
}
function Co(e) {
  return De(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function lt(e) {
  if (Wt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Xs(e) && e.host || // Fallback.
    Ke(e)
  );
  return Xs(t) ? t.host : t;
}
function nl(e) {
  const t = lt(e);
  return At(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : He(t) && gn(t) ? t : nl(t);
}
function nn(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = nl(e), a = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = Ce(r);
  if (a) {
    const s = xr(i);
    return t.concat(i, i.visualViewport || [], gn(r) ? r : [], s && n ? nn(s) : []);
  }
  return t.concat(r, nn(r, [], n));
}
function xr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ol(e) {
  const t = Ie(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = He(e), a = r ? e.offsetWidth : n, i = r ? e.offsetHeight : o, s = Yn(n) !== a || Yn(o) !== i;
  return s && (n = a, o = i), {
    width: n,
    height: o,
    $: s
  };
}
function wa(e) {
  return De(e) ? e : e.contextElement;
}
function Tt(e) {
  const t = wa(e);
  if (!He(t))
    return Ve(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: a
  } = ol(t);
  let i = (a ? Yn(n.width) : n.width) / o, s = (a ? Yn(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const px = /* @__PURE__ */ Ve(0);
function rl(e) {
  const t = Ce(e);
  return !ba() || !t.visualViewport ? px : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function mx(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Ce(e) ? !1 : t;
}
function wt(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = wa(e);
  let i = Ve(1);
  t && (o ? De(o) && (i = Tt(o)) : i = Tt(e));
  const s = mx(a, n, o) ? rl(a) : Ve(0);
  let d = (r.left + s.x) / i.x, f = (r.top + s.y) / i.y, u = r.width / i.x, p = r.height / i.y;
  if (a) {
    const m = Ce(a), h = o && De(o) ? Ce(o) : o;
    let g = m, v = xr(g);
    for (; v && o && h !== g; ) {
      const b = Tt(v), w = v.getBoundingClientRect(), y = Ie(v), x = w.left + (v.clientLeft + parseFloat(y.paddingLeft)) * b.x, E = w.top + (v.clientTop + parseFloat(y.paddingTop)) * b.y;
      d *= b.x, f *= b.y, u *= b.x, p *= b.y, d += x, f += E, g = Ce(v), v = xr(g);
    }
  }
  return Xn({
    width: u,
    height: p,
    x: d,
    y: f
  });
}
function So(e, t) {
  const n = Co(e).scrollLeft;
  return t ? t.left + n : wt(Ke(e)).left + n;
}
function al(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - So(e, n), r = n.top + t.scrollTop;
  return {
    x: o,
    y: r
  };
}
function vx(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const a = r === "fixed", i = Ke(o), s = t ? xo(t.floating) : !1;
  if (o === i || s && a)
    return n;
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  }, f = Ve(1);
  const u = Ve(0), p = He(o);
  if ((p || !p && !a) && ((Wt(o) !== "body" || gn(i)) && (d = Co(o)), He(o))) {
    const h = wt(o);
    f = Tt(o), u.x = h.x + o.clientLeft, u.y = h.y + o.clientTop;
  }
  const m = i && !p && !a ? al(i, d) : Ve(0);
  return {
    width: n.width * f.x,
    height: n.height * f.y,
    x: n.x * f.x - d.scrollLeft * f.x + u.x + m.x,
    y: n.y * f.y - d.scrollTop * f.y + u.y + m.y
  };
}
function hx(e) {
  return Array.from(e.getClientRects());
}
function gx(e) {
  const t = Ke(e), n = Co(e), o = e.ownerDocument.body, r = xe(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), a = xe(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + So(e);
  const s = -n.scrollTop;
  return Ie(o).direction === "rtl" && (i += xe(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: a,
    x: i,
    y: s
  };
}
const qs = 25;
function bx(e, t) {
  const n = Ce(e), o = Ke(e), r = n.visualViewport;
  let a = o.clientWidth, i = o.clientHeight, s = 0, d = 0;
  if (r) {
    a = r.width, i = r.height;
    const u = ba();
    (!u || u && t === "fixed") && (s = r.offsetLeft, d = r.offsetTop);
  }
  const f = So(o);
  if (f <= 0) {
    const u = o.ownerDocument, p = u.body, m = getComputedStyle(p), h = u.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, g = Math.abs(o.clientWidth - p.clientWidth - h);
    g <= qs && (a -= g);
  } else f <= qs && (a += f);
  return {
    width: a,
    height: i,
    x: s,
    y: d
  };
}
const wx = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function yx(e, t) {
  const n = wt(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, a = He(e) ? Tt(e) : Ve(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, d = r * a.x, f = o * a.y;
  return {
    width: i,
    height: s,
    x: d,
    y: f
  };
}
function Zs(e, t, n) {
  let o;
  if (t === "viewport")
    o = bx(e, n);
  else if (t === "document")
    o = gx(Ke(e));
  else if (De(t))
    o = yx(t, n);
  else {
    const r = rl(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return Xn(o);
}
function sl(e, t) {
  const n = lt(e);
  return n === t || !De(n) || At(n) ? !1 : Ie(n).position === "fixed" || sl(n, t);
}
function xx(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = nn(e, [], !1).filter((s) => De(s) && Wt(s) !== "body"), r = null;
  const a = Ie(e).position === "fixed";
  let i = a ? lt(e) : e;
  for (; De(i) && !At(i); ) {
    const s = Ie(i), d = ga(i);
    !d && s.position === "fixed" && (r = null), (a ? !d && !r : !d && s.position === "static" && !!r && wx.has(r.position) || gn(i) && !d && sl(e, i)) ? o = o.filter((u) => u !== i) : r = s, i = lt(i);
  }
  return t.set(e, o), o;
}
function Cx(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? xo(t) ? [] : xx(t, this._c) : [].concat(n), o], s = i[0], d = i.reduce((f, u) => {
    const p = Zs(t, u, r);
    return f.top = xe(p.top, f.top), f.right = ct(p.right, f.right), f.bottom = ct(p.bottom, f.bottom), f.left = xe(p.left, f.left), f;
  }, Zs(t, s, r));
  return {
    width: d.right - d.left,
    height: d.bottom - d.top,
    x: d.left,
    y: d.top
  };
}
function Sx(e) {
  const {
    width: t,
    height: n
  } = ol(e);
  return {
    width: t,
    height: n
  };
}
function Ex(e, t, n) {
  const o = He(t), r = Ke(t), a = n === "fixed", i = wt(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const d = Ve(0);
  function f() {
    d.x = So(r);
  }
  if (o || !o && !a)
    if ((Wt(t) !== "body" || gn(r)) && (s = Co(t)), o) {
      const h = wt(t, !0, a, t);
      d.x = h.x + t.clientLeft, d.y = h.y + t.clientTop;
    } else r && f();
  a && !o && r && f();
  const u = r && !o && !a ? al(r, s) : Ve(0), p = i.left + s.scrollLeft - d.x - u.x, m = i.top + s.scrollTop - d.y - u.y;
  return {
    x: p,
    y: m,
    width: i.width,
    height: i.height
  };
}
function dr(e) {
  return Ie(e).position === "static";
}
function Js(e, t) {
  if (!He(e) || Ie(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ke(e) === n && (n = n.ownerDocument.body), n;
}
function il(e, t) {
  const n = Ce(e);
  if (xo(e))
    return n;
  if (!He(e)) {
    let r = lt(e);
    for (; r && !At(r); ) {
      if (De(r) && !dr(r))
        return r;
      r = lt(r);
    }
    return n;
  }
  let o = Js(e, t);
  for (; o && sx(o) && dr(o); )
    o = Js(o, t);
  return o && At(o) && dr(o) && !ga(o) ? n : o || ux(e) || n;
}
const Mx = async function(e) {
  const t = this.getOffsetParent || il, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: Ex(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Rx(e) {
  return Ie(e).direction === "rtl";
}
const Nx = {
  convertOffsetParentRelativeRectToViewportRelativeRect: vx,
  getDocumentElement: Ke,
  getClippingRect: Cx,
  getOffsetParent: il,
  getElementRects: Mx,
  getClientRects: hx,
  getDimensions: Sx,
  getScale: Tt,
  isElement: De,
  isRTL: Rx
};
function cl(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Px(e, t) {
  let n = null, o;
  const r = Ke(e);
  function a() {
    var s;
    clearTimeout(o), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, d) {
    s === void 0 && (s = !1), d === void 0 && (d = 1), a();
    const f = e.getBoundingClientRect(), {
      left: u,
      top: p,
      width: m,
      height: h
    } = f;
    if (s || t(), !m || !h)
      return;
    const g = Ln(p), v = Ln(r.clientWidth - (u + m)), b = Ln(r.clientHeight - (p + h)), w = Ln(u), x = {
      rootMargin: -g + "px " + -v + "px " + -b + "px " + -w + "px",
      threshold: xe(0, ct(1, d)) || 1
    };
    let E = !0;
    function S(R) {
      const M = R[0].intersectionRatio;
      if (M !== d) {
        if (!E)
          return i();
        M ? i(!1, M) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      M === 1 && !cl(f, e.getBoundingClientRect()) && i(), E = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...x,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, x);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function _x(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = o, f = wa(e), u = r || a ? [...f ? nn(f) : [], ...nn(t)] : [];
  u.forEach((w) => {
    r && w.addEventListener("scroll", n, {
      passive: !0
    }), a && w.addEventListener("resize", n);
  });
  const p = f && s ? Px(f, n) : null;
  let m = -1, h = null;
  i && (h = new ResizeObserver((w) => {
    let [y] = w;
    y && y.target === f && h && (h.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(t);
    })), n();
  }), f && !d && h.observe(f), h.observe(t));
  let g, v = d ? wt(e) : null;
  d && b();
  function b() {
    const w = wt(e);
    v && !cl(v, w) && n(), v = w, g = requestAnimationFrame(b);
  }
  return n(), () => {
    var w;
    u.forEach((y) => {
      r && y.removeEventListener("scroll", n), a && y.removeEventListener("resize", n);
    }), p?.(), (w = h) == null || w.disconnect(), h = null, d && cancelAnimationFrame(g);
  };
}
const Tx = ex, Ax = tx, Dx = Zy, Ix = ox, Ox = Jy, Qs = qy, kx = nx, $x = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Nx,
    ...n
  }, a = {
    ...r.platform,
    _c: o
  };
  return Xy(e, t, {
    ...r,
    platform: a
  });
};
var Lx = typeof document < "u", Fx = function() {
}, Hn = Lx ? fi : Fx;
function qn(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!qn(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const a = r[o];
      if (!(a === "_owner" && e.$$typeof) && !qn(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function ll(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ei(e, t) {
  const n = ll(e);
  return Math.round(t * n) / n;
}
function ur(e) {
  const t = l.useRef(e);
  return Hn(() => {
    t.current = e;
  }), t;
}
function Wx(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: d,
    open: f
  } = e, [u, p] = l.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, h] = l.useState(o);
  qn(m, o) || h(o);
  const [g, v] = l.useState(null), [b, w] = l.useState(null), y = l.useCallback(($) => {
    $ !== R.current && (R.current = $, v($));
  }, []), x = l.useCallback(($) => {
    $ !== M.current && (M.current = $, w($));
  }, []), E = a || g, S = i || b, R = l.useRef(null), M = l.useRef(null), P = l.useRef(u), T = d != null, D = ur(d), O = ur(r), B = ur(f), K = l.useCallback(() => {
    if (!R.current || !M.current)
      return;
    const $ = {
      placement: t,
      strategy: n,
      middleware: m
    };
    O.current && ($.platform = O.current), $x(R.current, M.current, $).then((I) => {
      const j = {
        ...I,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: B.current !== !1
      };
      k.current && !qn(P.current, j) && (P.current = j, cn.flushSync(() => {
        p(j);
      }));
    });
  }, [m, t, n, O, B]);
  Hn(() => {
    f === !1 && P.current.isPositioned && (P.current.isPositioned = !1, p(($) => ({
      ...$,
      isPositioned: !1
    })));
  }, [f]);
  const k = l.useRef(!1);
  Hn(() => (k.current = !0, () => {
    k.current = !1;
  }), []), Hn(() => {
    if (E && (R.current = E), S && (M.current = S), E && S) {
      if (D.current)
        return D.current(E, S, K);
      K();
    }
  }, [E, S, K, D, T]);
  const G = l.useMemo(() => ({
    reference: R,
    floating: M,
    setReference: y,
    setFloating: x
  }), [y, x]), L = l.useMemo(() => ({
    reference: E,
    floating: S
  }), [E, S]), H = l.useMemo(() => {
    const $ = {
      position: n,
      left: 0,
      top: 0
    };
    if (!L.floating)
      return $;
    const I = ei(L.floating, u.x), j = ei(L.floating, u.y);
    return s ? {
      ...$,
      transform: "translate(" + I + "px, " + j + "px)",
      ...ll(L.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: I,
      top: j
    };
  }, [n, s, L.floating, u.x, u.y]);
  return l.useMemo(() => ({
    ...u,
    update: K,
    refs: G,
    elements: L,
    floatingStyles: H
  }), [u, K, G, L, H]);
}
const zx = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? Qs({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? Qs({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, Bx = (e, t) => ({
  ...Tx(e),
  options: [e, t]
}), Vx = (e, t) => ({
  ...Ax(e),
  options: [e, t]
}), Hx = (e, t) => ({
  ...kx(e),
  options: [e, t]
}), Gx = (e, t) => ({
  ...Dx(e),
  options: [e, t]
}), Kx = (e, t) => ({
  ...Ix(e),
  options: [e, t]
}), Ux = (e, t) => ({
  ...Ox(e),
  options: [e, t]
}), Yx = (e, t) => ({
  ...zx(e),
  options: [e, t]
});
var jx = "Arrow", dl = l.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...a } = e;
  return /* @__PURE__ */ c(
    A.svg,
    {
      ...a,
      ref: t,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ c("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
dl.displayName = jx;
var Xx = dl, ya = "Popper", [ul, Ue] = Q(ya), [qx, fl] = ul(ya), pl = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = l.useState(null);
  return /* @__PURE__ */ c(qx, { scope: t, anchor: o, onAnchorChange: r, children: n });
};
pl.displayName = ya;
var ml = "PopperAnchor", vl = l.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...r } = e, a = fl(ml, n), i = l.useRef(null), s = W(t, i), d = l.useRef(null);
    return l.useEffect(() => {
      const f = d.current;
      d.current = o?.current || i.current, f !== d.current && a.onAnchorChange(d.current);
    }), o ? null : /* @__PURE__ */ c(A.div, { ...r, ref: s });
  }
);
vl.displayName = ml;
var xa = "PopperContent", [Zx, Jx] = ul(xa), hl = l.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: d = !0,
      collisionBoundary: f = [],
      collisionPadding: u = 0,
      sticky: p = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: g,
      ...v
    } = e, b = fl(xa, n), [w, y] = l.useState(null), x = W(t, (F) => y(F)), [E, S] = l.useState(null), R = hn(E), M = R?.width ?? 0, P = R?.height ?? 0, T = o + (a !== "center" ? "-" + a : ""), D = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, O = Array.isArray(f) ? f : [f], B = O.length > 0, K = {
      padding: D,
      boundary: O.filter(eC),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: B
    }, { refs: k, floatingStyles: G, placement: L, isPositioned: H, middlewareData: $ } = Wx({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: T,
      whileElementsMounted: (...F) => _x(...F, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        Bx({ mainAxis: r + P, alignmentAxis: i }),
        d && Vx({
          mainAxis: !0,
          crossAxis: !1,
          limiter: p === "partial" ? Hx() : void 0,
          ...K
        }),
        d && Gx({ ...K }),
        Kx({
          ...K,
          apply: ({ elements: F, rects: Z, availableWidth: ue, availableHeight: J }) => {
            const { width: te, height: ie } = Z.reference, we = F.floating.style;
            we.setProperty("--radix-popper-available-width", `${ue}px`), we.setProperty("--radix-popper-available-height", `${J}px`), we.setProperty("--radix-popper-anchor-width", `${te}px`), we.setProperty("--radix-popper-anchor-height", `${ie}px`);
          }
        }),
        E && Yx({ element: E, padding: s }),
        tC({ arrowWidth: M, arrowHeight: P }),
        m && Ux({ strategy: "referenceHidden", ...K })
      ]
    }), [I, j] = wl(L), ce = q(g);
    oe(() => {
      H && ce?.();
    }, [H, ce]);
    const fe = $.arrow?.x, pe = $.arrow?.y, de = $.arrow?.centerOffset !== 0, [Ee, me] = l.useState();
    return oe(() => {
      w && me(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ c(
      "div",
      {
        ref: k.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: H ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Ee,
          "--radix-popper-transform-origin": [
            $.transformOrigin?.x,
            $.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...$.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ c(
          Zx,
          {
            scope: n,
            placedSide: I,
            onArrowChange: S,
            arrowX: fe,
            arrowY: pe,
            shouldHideArrow: de,
            children: /* @__PURE__ */ c(
              A.div,
              {
                "data-side": I,
                "data-align": j,
                ...v,
                ref: x,
                style: {
                  ...v.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: H ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
hl.displayName = xa;
var gl = "PopperArrow", Qx = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, bl = l.forwardRef(function(t, n) {
  const { __scopePopper: o, ...r } = t, a = Jx(gl, o), i = Qx[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ c(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ c(
          Xx,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
bl.displayName = gl;
function eC(e) {
  return e !== null;
}
var tC = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: o, middlewareData: r } = t, i = r.arrow?.centerOffset !== 0, s = i ? 0 : e.arrowWidth, d = i ? 0 : e.arrowHeight, [f, u] = wl(n), p = { start: "0%", center: "50%", end: "100%" }[u], m = (r.arrow?.x ?? 0) + s / 2, h = (r.arrow?.y ?? 0) + d / 2;
    let g = "", v = "";
    return f === "bottom" ? (g = i ? p : `${m}px`, v = `${-d}px`) : f === "top" ? (g = i ? p : `${m}px`, v = `${o.floating.height + d}px`) : f === "right" ? (g = `${-d}px`, v = i ? p : `${h}px`) : f === "left" && (g = `${o.floating.width + d}px`, v = i ? p : `${h}px`), { data: { x: g, y: v } };
  }
});
function wl(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var zt = pl, Bt = vl, bn = hl, wn = bl, fr = "rovingFocusGroup.onEntryFocus", nC = { bubbles: !1, cancelable: !0 }, yn = "RovingFocusGroup", [Cr, yl, oC] = tt(yn), [rC, Ye] = Q(
  yn,
  [oC]
), [aC, sC] = rC(yn), xl = l.forwardRef(
  (e, t) => /* @__PURE__ */ c(Cr.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ c(Cr.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ c(iC, { ...e, ref: t }) }) })
);
xl.displayName = yn;
var iC = l.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: r = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: d,
    onEntryFocus: f,
    preventScrollOnEntryFocus: u = !1,
    ...p
  } = e, m = l.useRef(null), h = W(t, m), g = Oe(a), [v, b] = ne({
    prop: i,
    defaultProp: s ?? null,
    onChange: d,
    caller: yn
  }), [w, y] = l.useState(!1), x = q(f), E = yl(n), S = l.useRef(!1), [R, M] = l.useState(0);
  return l.useEffect(() => {
    const P = m.current;
    if (P)
      return P.addEventListener(fr, x), () => P.removeEventListener(fr, x);
  }, [x]), /* @__PURE__ */ c(
    aC,
    {
      scope: n,
      orientation: o,
      dir: g,
      loop: r,
      currentTabStopId: v,
      onItemFocus: l.useCallback(
        (P) => b(P),
        [b]
      ),
      onItemShiftTab: l.useCallback(() => y(!0), []),
      onFocusableItemAdd: l.useCallback(
        () => M((P) => P + 1),
        []
      ),
      onFocusableItemRemove: l.useCallback(
        () => M((P) => P - 1),
        []
      ),
      children: /* @__PURE__ */ c(
        A.div,
        {
          tabIndex: w || R === 0 ? -1 : 0,
          "data-orientation": o,
          ...p,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: N(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: N(e.onFocus, (P) => {
            const T = !S.current;
            if (P.target === P.currentTarget && T && !w) {
              const D = new CustomEvent(fr, nC);
              if (P.currentTarget.dispatchEvent(D), !D.defaultPrevented) {
                const O = E().filter((L) => L.focusable), B = O.find((L) => L.active), K = O.find((L) => L.id === v), G = [B, K, ...O].filter(
                  Boolean
                ).map((L) => L.ref.current);
                El(G, u);
              }
            }
            S.current = !1;
          }),
          onBlur: N(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), Cl = "RovingFocusGroupItem", Sl = l.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: r = !1,
      tabStopId: a,
      children: i,
      ...s
    } = e, d = le(), f = a || d, u = sC(Cl, n), p = u.currentTabStopId === f, m = yl(n), { onFocusableItemAdd: h, onFocusableItemRemove: g, currentTabStopId: v } = u;
    return l.useEffect(() => {
      if (o)
        return h(), () => g();
    }, [o, h, g]), /* @__PURE__ */ c(
      Cr.ItemSlot,
      {
        scope: n,
        id: f,
        focusable: o,
        active: r,
        children: /* @__PURE__ */ c(
          A.span,
          {
            tabIndex: p ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: N(e.onMouseDown, (b) => {
              o ? u.onItemFocus(f) : b.preventDefault();
            }),
            onFocus: N(e.onFocus, () => u.onItemFocus(f)),
            onKeyDown: N(e.onKeyDown, (b) => {
              if (b.key === "Tab" && b.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (b.target !== b.currentTarget) return;
              const w = dC(b, u.orientation, u.dir);
              if (w !== void 0) {
                if (b.metaKey || b.ctrlKey || b.altKey || b.shiftKey) return;
                b.preventDefault();
                let x = m().filter((E) => E.focusable).map((E) => E.ref.current);
                if (w === "last") x.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && x.reverse();
                  const E = x.indexOf(b.currentTarget);
                  x = u.loop ? uC(x, E + 1) : x.slice(E + 1);
                }
                setTimeout(() => El(x));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: p, hasTabStop: v != null }) : i
          }
        )
      }
    );
  }
);
Sl.displayName = Cl;
var cC = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function lC(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function dC(e, t, n) {
  const o = lC(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return cC[o];
}
function El(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function uC(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var xn = xl, Cn = Sl, Sr = ["Enter", " "], fC = ["ArrowDown", "PageUp", "Home"], Ml = ["ArrowUp", "PageDown", "End"], pC = [...fC, ...Ml], mC = {
  ltr: [...Sr, "ArrowRight"],
  rtl: [...Sr, "ArrowLeft"]
}, vC = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Sn = "Menu", [on, hC, gC] = tt(Sn), [St, En] = Q(Sn, [
  gC,
  Ue,
  Ye
]), Mn = Ue(), Rl = Ye(), [Nl, ft] = St(Sn), [bC, Rn] = St(Sn), Pl = (e) => {
  const { __scopeMenu: t, open: n = !1, children: o, dir: r, onOpenChange: a, modal: i = !0 } = e, s = Mn(t), [d, f] = l.useState(null), u = l.useRef(!1), p = q(a), m = Oe(r);
  return l.useEffect(() => {
    const h = () => {
      u.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => u.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ c(zt, { ...s, children: /* @__PURE__ */ c(
    Nl,
    {
      scope: t,
      open: n,
      onOpenChange: p,
      content: d,
      onContentChange: f,
      children: /* @__PURE__ */ c(
        bC,
        {
          scope: t,
          onClose: l.useCallback(() => p(!1), [p]),
          isUsingKeyboardRef: u,
          dir: m,
          modal: i,
          children: o
        }
      )
    }
  ) });
};
Pl.displayName = Sn;
var wC = "MenuAnchor", Ca = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = Mn(n);
    return /* @__PURE__ */ c(Bt, { ...r, ...o, ref: t });
  }
);
Ca.displayName = wC;
var Sa = "MenuPortal", [yC, _l] = St(Sa, {
  forceMount: void 0
}), Tl = (e) => {
  const { __scopeMenu: t, forceMount: n, children: o, container: r } = e, a = ft(Sa, t);
  return /* @__PURE__ */ c(yC, { scope: t, forceMount: n, children: /* @__PURE__ */ c(ee, { present: n || a.open, children: /* @__PURE__ */ c(ut, { asChild: !0, container: r, children: o }) }) });
};
Tl.displayName = Sa;
var Ne = "MenuContent", [xC, Ea] = St(Ne), Al = l.forwardRef(
  (e, t) => {
    const n = _l(Ne, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, a = ft(Ne, e.__scopeMenu), i = Rn(Ne, e.__scopeMenu);
    return /* @__PURE__ */ c(on.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ c(ee, { present: o || a.open, children: /* @__PURE__ */ c(on.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ c(CC, { ...r, ref: t }) : /* @__PURE__ */ c(SC, { ...r, ref: t }) }) }) });
  }
), CC = l.forwardRef(
  (e, t) => {
    const n = ft(Ne, e.__scopeMenu), o = l.useRef(null), r = W(t, o);
    return l.useEffect(() => {
      const a = o.current;
      if (a) return vo(a);
    }, []), /* @__PURE__ */ c(
      Ma,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: N(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), SC = l.forwardRef((e, t) => {
  const n = ft(Ne, e.__scopeMenu);
  return /* @__PURE__ */ c(
    Ma,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), EC = /* @__PURE__ */ it("MenuContent.ScrollLock"), Ma = l.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: o = !1,
      trapFocus: r,
      onOpenAutoFocus: a,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEntryFocus: d,
      onEscapeKeyDown: f,
      onPointerDownOutside: u,
      onFocusOutside: p,
      onInteractOutside: m,
      onDismiss: h,
      disableOutsideScroll: g,
      ...v
    } = e, b = ft(Ne, n), w = Rn(Ne, n), y = Mn(n), x = Rl(n), E = hC(n), [S, R] = l.useState(null), M = l.useRef(null), P = W(t, M, b.onContentChange), T = l.useRef(0), D = l.useRef(""), O = l.useRef(0), B = l.useRef(null), K = l.useRef("right"), k = l.useRef(0), G = g ? pn : l.Fragment, L = g ? { as: EC, allowPinchZoom: !0 } : void 0, H = (I) => {
      const j = D.current + I, ce = E().filter((F) => !F.disabled), fe = document.activeElement, pe = ce.find((F) => F.ref.current === fe)?.textValue, de = ce.map((F) => F.textValue), Ee = $C(de, j, pe), me = ce.find((F) => F.textValue === Ee)?.ref.current;
      (function F(Z) {
        D.current = Z, window.clearTimeout(T.current), Z !== "" && (T.current = window.setTimeout(() => F(""), 1e3));
      })(j), me && setTimeout(() => me.focus());
    };
    l.useEffect(() => () => window.clearTimeout(T.current), []), po();
    const $ = l.useCallback((I) => K.current === B.current?.side && FC(I, B.current?.area), []);
    return /* @__PURE__ */ c(
      xC,
      {
        scope: n,
        searchRef: D,
        onItemEnter: l.useCallback(
          (I) => {
            $(I) && I.preventDefault();
          },
          [$]
        ),
        onItemLeave: l.useCallback(
          (I) => {
            $(I) || (M.current?.focus(), R(null));
          },
          [$]
        ),
        onTriggerLeave: l.useCallback(
          (I) => {
            $(I) && I.preventDefault();
          },
          [$]
        ),
        pointerGraceTimerRef: O,
        onPointerGraceIntentChange: l.useCallback((I) => {
          B.current = I;
        }, []),
        children: /* @__PURE__ */ c(G, { ...L, children: /* @__PURE__ */ c(
          fn,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: N(a, (I) => {
              I.preventDefault(), M.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ c(
              nt,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: f,
                onPointerDownOutside: u,
                onFocusOutside: p,
                onInteractOutside: m,
                onDismiss: h,
                children: /* @__PURE__ */ c(
                  xn,
                  {
                    asChild: !0,
                    ...x,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: o,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: R,
                    onEntryFocus: N(d, (I) => {
                      w.isUsingKeyboardRef.current || I.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ c(
                      bn,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": jl(b.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ...y,
                        ...v,
                        ref: P,
                        style: { outline: "none", ...v.style },
                        onKeyDown: N(v.onKeyDown, (I) => {
                          const ce = I.target.closest("[data-radix-menu-content]") === I.currentTarget, fe = I.ctrlKey || I.altKey || I.metaKey, pe = I.key.length === 1;
                          ce && (I.key === "Tab" && I.preventDefault(), !fe && pe && H(I.key));
                          const de = M.current;
                          if (I.target !== de || !pC.includes(I.key)) return;
                          I.preventDefault();
                          const me = E().filter((F) => !F.disabled).map((F) => F.ref.current);
                          Ml.includes(I.key) && me.reverse(), OC(me);
                        }),
                        onBlur: N(e.onBlur, (I) => {
                          I.currentTarget.contains(I.target) || (window.clearTimeout(T.current), D.current = "");
                        }),
                        onPointerMove: N(
                          e.onPointerMove,
                          rn((I) => {
                            const j = I.target, ce = k.current !== I.clientX;
                            if (I.currentTarget.contains(j) && ce) {
                              const fe = I.clientX > k.current ? "right" : "left";
                              K.current = fe, k.current = I.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Al.displayName = Ne;
var MC = "MenuGroup", Ra = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ c(A.div, { role: "group", ...o, ref: t });
  }
);
Ra.displayName = MC;
var RC = "MenuLabel", Dl = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ c(A.div, { ...o, ref: t });
  }
);
Dl.displayName = RC;
var Zn = "MenuItem", ti = "menu.itemSelect", Eo = l.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: o, ...r } = e, a = l.useRef(null), i = Rn(Zn, e.__scopeMenu), s = Ea(Zn, e.__scopeMenu), d = W(t, a), f = l.useRef(!1), u = () => {
      const p = a.current;
      if (!n && p) {
        const m = new CustomEvent(ti, { bubbles: !0, cancelable: !0 });
        p.addEventListener(ti, (h) => o?.(h), { once: !0 }), Qt(p, m), m.defaultPrevented ? f.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ c(
      Il,
      {
        ...r,
        ref: d,
        disabled: n,
        onClick: N(e.onClick, u),
        onPointerDown: (p) => {
          e.onPointerDown?.(p), f.current = !0;
        },
        onPointerUp: N(e.onPointerUp, (p) => {
          f.current || p.currentTarget?.click();
        }),
        onKeyDown: N(e.onKeyDown, (p) => {
          const m = s.searchRef.current !== "";
          n || m && p.key === " " || Sr.includes(p.key) && (p.currentTarget.click(), p.preventDefault());
        })
      }
    );
  }
);
Eo.displayName = Zn;
var Il = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: o = !1, textValue: r, ...a } = e, i = Ea(Zn, n), s = Rl(n), d = l.useRef(null), f = W(t, d), [u, p] = l.useState(!1), [m, h] = l.useState("");
    return l.useEffect(() => {
      const g = d.current;
      g && h((g.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ c(
      on.ItemSlot,
      {
        scope: n,
        disabled: o,
        textValue: r ?? m,
        children: /* @__PURE__ */ c(Cn, { asChild: !0, ...s, focusable: !o, children: /* @__PURE__ */ c(
          A.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": o || void 0,
            "data-disabled": o ? "" : void 0,
            ...a,
            ref: f,
            onPointerMove: N(
              e.onPointerMove,
              rn((g) => {
                o ? i.onItemLeave(g) : (i.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: N(
              e.onPointerLeave,
              rn((g) => i.onItemLeave(g))
            ),
            onFocus: N(e.onFocus, () => p(!0)),
            onBlur: N(e.onBlur, () => p(!1))
          }
        ) })
      }
    );
  }
), NC = "MenuCheckboxItem", Ol = l.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: o, ...r } = e;
    return /* @__PURE__ */ c(Wl, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ c(
      Eo,
      {
        role: "menuitemcheckbox",
        "aria-checked": Jn(n) ? "mixed" : n,
        ...r,
        ref: t,
        "data-state": _a(n),
        onSelect: N(
          r.onSelect,
          () => o?.(Jn(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ol.displayName = NC;
var kl = "MenuRadioGroup", [PC, _C] = St(
  kl,
  { value: void 0, onValueChange: () => {
  } }
), $l = l.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: o, ...r } = e, a = q(o);
    return /* @__PURE__ */ c(PC, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ c(Ra, { ...r, ref: t }) });
  }
);
$l.displayName = kl;
var Ll = "MenuRadioItem", Fl = l.forwardRef(
  (e, t) => {
    const { value: n, ...o } = e, r = _C(Ll, e.__scopeMenu), a = n === r.value;
    return /* @__PURE__ */ c(Wl, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ c(
      Eo,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...o,
        ref: t,
        "data-state": _a(a),
        onSelect: N(
          o.onSelect,
          () => r.onValueChange?.(n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Fl.displayName = Ll;
var Na = "MenuItemIndicator", [Wl, TC] = St(
  Na,
  { checked: !1 }
), zl = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: o, ...r } = e, a = TC(Na, n);
    return /* @__PURE__ */ c(
      ee,
      {
        present: o || Jn(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ c(
          A.span,
          {
            ...r,
            ref: t,
            "data-state": _a(a.checked)
          }
        )
      }
    );
  }
);
zl.displayName = Na;
var AC = "MenuSeparator", Bl = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ c(
      A.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...o,
        ref: t
      }
    );
  }
);
Bl.displayName = AC;
var DC = "MenuArrow", Vl = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = Mn(n);
    return /* @__PURE__ */ c(wn, { ...r, ...o, ref: t });
  }
);
Vl.displayName = DC;
var Pa = "MenuSub", [IC, Hl] = St(Pa), Gl = (e) => {
  const { __scopeMenu: t, children: n, open: o = !1, onOpenChange: r } = e, a = ft(Pa, t), i = Mn(t), [s, d] = l.useState(null), [f, u] = l.useState(null), p = q(r);
  return l.useEffect(() => (a.open === !1 && p(!1), () => p(!1)), [a.open, p]), /* @__PURE__ */ c(zt, { ...i, children: /* @__PURE__ */ c(
    Nl,
    {
      scope: t,
      open: o,
      onOpenChange: p,
      content: f,
      onContentChange: u,
      children: /* @__PURE__ */ c(
        IC,
        {
          scope: t,
          contentId: le(),
          triggerId: le(),
          trigger: s,
          onTriggerChange: d,
          children: n
        }
      )
    }
  ) });
};
Gl.displayName = Pa;
var qt = "MenuSubTrigger", Kl = l.forwardRef(
  (e, t) => {
    const n = ft(qt, e.__scopeMenu), o = Rn(qt, e.__scopeMenu), r = Hl(qt, e.__scopeMenu), a = Ea(qt, e.__scopeMenu), i = l.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: d } = a, f = { __scopeMenu: e.__scopeMenu }, u = l.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return l.useEffect(() => u, [u]), l.useEffect(() => {
      const p = s.current;
      return () => {
        window.clearTimeout(p), d(null);
      };
    }, [s, d]), /* @__PURE__ */ c(Ca, { asChild: !0, ...f, children: /* @__PURE__ */ c(
      Il,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": jl(n.open),
        ...e,
        ref: un(t, r.onTriggerChange),
        onClick: (p) => {
          e.onClick?.(p), !(e.disabled || p.defaultPrevented) && (p.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: N(
          e.onPointerMove,
          rn((p) => {
            a.onItemEnter(p), !p.defaultPrevented && !e.disabled && !n.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: N(
          e.onPointerLeave,
          rn((p) => {
            u();
            const m = n.content?.getBoundingClientRect();
            if (m) {
              const h = n.content?.dataset.side, g = h === "right", v = g ? -5 : 5, b = m[g ? "left" : "right"], w = m[g ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: p.clientX + v, y: p.clientY },
                  { x: b, y: m.top },
                  { x: w, y: m.top },
                  { x: w, y: m.bottom },
                  { x: b, y: m.bottom }
                ],
                side: h
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(p), p.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: N(e.onKeyDown, (p) => {
          const m = a.searchRef.current !== "";
          e.disabled || m && p.key === " " || mC[o.dir].includes(p.key) && (n.onOpenChange(!0), n.content?.focus(), p.preventDefault());
        })
      }
    ) });
  }
);
Kl.displayName = qt;
var Ul = "MenuSubContent", Yl = l.forwardRef(
  (e, t) => {
    const n = _l(Ne, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, a = ft(Ne, e.__scopeMenu), i = Rn(Ne, e.__scopeMenu), s = Hl(Ul, e.__scopeMenu), d = l.useRef(null), f = W(t, d);
    return /* @__PURE__ */ c(on.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ c(ee, { present: o || a.open, children: /* @__PURE__ */ c(on.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ c(
      Ma,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...r,
        ref: f,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          i.isUsingKeyboardRef.current && d.current?.focus(), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: N(e.onFocusOutside, (u) => {
          u.target !== s.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: N(e.onEscapeKeyDown, (u) => {
          i.onClose(), u.preventDefault();
        }),
        onKeyDown: N(e.onKeyDown, (u) => {
          const p = u.currentTarget.contains(u.target), m = vC[i.dir].includes(u.key);
          p && m && (a.onOpenChange(!1), s.trigger?.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
Yl.displayName = Ul;
function jl(e) {
  return e ? "open" : "closed";
}
function Jn(e) {
  return e === "indeterminate";
}
function _a(e) {
  return Jn(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function OC(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function kC(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
function $C(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((f) => f === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = kC(e, Math.max(a, 0));
  r.length === 1 && (i = i.filter((f) => f !== n));
  const d = i.find(
    (f) => f.toLowerCase().startsWith(r.toLowerCase())
  );
  return d !== n ? d : void 0;
}
function LC(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a], d = t[i], f = s.x, u = s.y, p = d.x, m = d.y;
    u > o != m > o && n < (p - f) * (o - u) / (m - u) + f && (r = !r);
  }
  return r;
}
function FC(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return LC(n, t);
}
function rn(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Ta = Pl, Aa = Ca, Da = Tl, Ia = Al, Oa = Ra, ka = Dl, $a = Eo, La = Ol, Fa = $l, Wa = Fl, za = zl, Ba = Bl, Va = Vl, Ha = Gl, Ga = Kl, Ka = Yl, Ua = "ContextMenu", [WC, fT] = Q(Ua, [
  En
]), he = En(), [zC, Xl] = WC(Ua), ql = (e) => {
  const { __scopeContextMenu: t, children: n, onOpenChange: o, dir: r, modal: a = !0 } = e, [i, s] = l.useState(!1), d = he(t), f = q(o), u = l.useCallback(
    (p) => {
      s(p), f(p);
    },
    [f]
  );
  return /* @__PURE__ */ c(
    zC,
    {
      scope: t,
      open: i,
      onOpenChange: u,
      modal: a,
      children: /* @__PURE__ */ c(
        Ta,
        {
          ...d,
          dir: r,
          open: i,
          onOpenChange: u,
          modal: a,
          children: n
        }
      )
    }
  );
};
ql.displayName = Ua;
var Zl = "ContextMenuTrigger", Jl = l.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, disabled: o = !1, ...r } = e, a = Xl(Zl, n), i = he(n), s = l.useRef({ x: 0, y: 0 }), d = l.useRef({
      getBoundingClientRect: () => DOMRect.fromRect({ width: 0, height: 0, ...s.current })
    }), f = l.useRef(0), u = l.useCallback(
      () => window.clearTimeout(f.current),
      []
    ), p = (m) => {
      s.current = { x: m.clientX, y: m.clientY }, a.onOpenChange(!0);
    };
    return l.useEffect(() => u, [u]), l.useEffect(() => void (o && u()), [o, u]), /* @__PURE__ */ z(Se, { children: [
      /* @__PURE__ */ c(Aa, { ...i, virtualRef: d }),
      /* @__PURE__ */ c(
        A.span,
        {
          "data-state": a.open ? "open" : "closed",
          "data-disabled": o ? "" : void 0,
          ...r,
          ref: t,
          style: { WebkitTouchCallout: "none", ...e.style },
          onContextMenu: o ? e.onContextMenu : N(e.onContextMenu, (m) => {
            u(), p(m), m.preventDefault();
          }),
          onPointerDown: o ? e.onPointerDown : N(
            e.onPointerDown,
            Fn((m) => {
              u(), f.current = window.setTimeout(() => p(m), 700);
            })
          ),
          onPointerMove: o ? e.onPointerMove : N(e.onPointerMove, Fn(u)),
          onPointerCancel: o ? e.onPointerCancel : N(e.onPointerCancel, Fn(u)),
          onPointerUp: o ? e.onPointerUp : N(e.onPointerUp, Fn(u))
        }
      )
    ] });
  }
);
Jl.displayName = Zl;
var BC = "ContextMenuPortal", Ql = (e) => {
  const { __scopeContextMenu: t, ...n } = e, o = he(t);
  return /* @__PURE__ */ c(Da, { ...o, ...n });
};
Ql.displayName = BC;
var ed = "ContextMenuContent", td = l.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...o } = e, r = Xl(ed, n), a = he(n), i = l.useRef(!1);
    return /* @__PURE__ */ c(
      Ia,
      {
        ...a,
        ...o,
        ref: t,
        side: "right",
        sideOffset: 2,
        align: "start",
        onCloseAutoFocus: (s) => {
          e.onCloseAutoFocus?.(s), !s.defaultPrevented && i.current && s.preventDefault(), i.current = !1;
        },
        onInteractOutside: (s) => {
          e.onInteractOutside?.(s), !s.defaultPrevented && !r.modal && (i.current = !0);
        },
        style: {
          ...e.style,
          "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
td.displayName = ed;
var VC = "ContextMenuGroup", nd = l.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...o } = e, r = he(n);
    return /* @__PURE__ */ c(Oa, { ...r, ...o, ref: t });
  }
);
nd.displayName = VC;
var HC = "ContextMenuLabel", od = l.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...o } = e, r = he(n);
    return /* @__PURE__ */ c(ka, { ...r, ...o, ref: t });
  }
);
od.displayName = HC;
var GC = "ContextMenuItem", rd = l.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...o } = e, r = he(n);
    return /* @__PURE__ */ c($a, { ...r, ...o, ref: t });
  }
);
rd.displayName = GC;
var KC = "ContextMenuCheckboxItem", ad = l.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...o } = e, r = he(n);
  return /* @__PURE__ */ c(La, { ...r, ...o, ref: t });
});
ad.displayName = KC;
var UC = "ContextMenuRadioGroup", sd = l.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...o } = e, r = he(n);
  return /* @__PURE__ */ c(Fa, { ...r, ...o, ref: t });
});
sd.displayName = UC;
var YC = "ContextMenuRadioItem", id = l.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...o } = e, r = he(n);
  return /* @__PURE__ */ c(Wa, { ...r, ...o, ref: t });
});
id.displayName = YC;
var jC = "ContextMenuItemIndicator", cd = l.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...o } = e, r = he(n);
  return /* @__PURE__ */ c(za, { ...r, ...o, ref: t });
});
cd.displayName = jC;
var XC = "ContextMenuSeparator", ld = l.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...o } = e, r = he(n);
  return /* @__PURE__ */ c(Ba, { ...r, ...o, ref: t });
});
ld.displayName = XC;
var qC = "ContextMenuArrow", ZC = l.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...o } = e, r = he(n);
    return /* @__PURE__ */ c(Va, { ...r, ...o, ref: t });
  }
);
ZC.displayName = qC;
var dd = "ContextMenuSub", ud = (e) => {
  const { __scopeContextMenu: t, children: n, onOpenChange: o, open: r, defaultOpen: a } = e, i = he(t), [s, d] = ne({
    prop: r,
    defaultProp: a ?? !1,
    onChange: o,
    caller: dd
  });
  return /* @__PURE__ */ c(Ha, { ...i, open: s, onOpenChange: d, children: n });
};
ud.displayName = dd;
var JC = "ContextMenuSubTrigger", fd = l.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...o } = e, r = he(n);
  return /* @__PURE__ */ c(Ga, { ...r, ...o, ref: t });
});
fd.displayName = JC;
var QC = "ContextMenuSubContent", pd = l.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...o } = e, r = he(n);
  return /* @__PURE__ */ c(
    Ka,
    {
      ...r,
      ...o,
      ref: t,
      style: {
        ...e.style,
        "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
pd.displayName = QC;
function Fn(e) {
  return (t) => t.pointerType !== "mouse" ? e(t) : void 0;
}
var eS = ql, tS = Jl, md = Ql, nS = td, oS = nd, rS = od, aS = rd, sS = ad, iS = sd, cS = id, vd = cd, lS = ld, dS = ud, uS = fd, fS = pd;
function pT({
  ...e
}) {
  return /* @__PURE__ */ c(eS, { "data-slot": "context-menu", ...e });
}
function mT({
  ...e
}) {
  return /* @__PURE__ */ c(tS, { "data-slot": "context-menu-trigger", ...e });
}
function vT({
  ...e
}) {
  return /* @__PURE__ */ c(oS, { "data-slot": "context-menu-group", ...e });
}
function hT({
  ...e
}) {
  return /* @__PURE__ */ c(md, { "data-slot": "context-menu-portal", ...e });
}
function gT({
  ...e
}) {
  return /* @__PURE__ */ c(dS, { "data-slot": "context-menu-sub", ...e });
}
function bT({
  ...e
}) {
  return /* @__PURE__ */ c(
    iS,
    {
      "data-slot": "context-menu-radio-group",
      ...e
    }
  );
}
function wT({
  className: e,
  inset: t,
  children: n,
  ...o
}) {
  return /* @__PURE__ */ z(
    uS,
    {
      "data-slot": "context-menu-sub-trigger",
      "data-inset": t,
      className: C(
        "focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground flex cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o,
      children: [
        n,
        /* @__PURE__ */ c(io, { className: "ml-auto" })
      ]
    }
  );
}
function yT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    fS,
    {
      "data-slot": "context-menu-sub-content",
      className: C(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-(--radix-context-menu-content-transform-origin) overflow-hidden rounded-md border p-1 shadow-lg",
        e
      ),
      ...t
    }
  );
}
function xT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(md, { children: /* @__PURE__ */ c(
    nS,
    {
      "data-slot": "context-menu-content",
      className: C(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--radix-context-menu-content-available-height) min-w-[8rem] origin-(--radix-context-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md",
        e
      ),
      ...t
    }
  ) });
}
function CT({
  className: e,
  inset: t,
  variant: n = "default",
  ...o
}) {
  return /* @__PURE__ */ c(
    aS,
    {
      "data-slot": "context-menu-item",
      "data-inset": t,
      "data-variant": n,
      className: C(
        "focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o
    }
  );
}
function ST({
  className: e,
  children: t,
  checked: n,
  ...o
}) {
  return /* @__PURE__ */ z(
    sS,
    {
      "data-slot": "context-menu-checkbox-item",
      className: C(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: n,
      ...o,
      children: [
        /* @__PURE__ */ c("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ c(vd, { children: /* @__PURE__ */ c(dn, { className: "size-4" }) }) }),
        t
      ]
    }
  );
}
function ET({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ z(
    cS,
    {
      "data-slot": "context-menu-radio-item",
      className: C(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ c("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ c(vd, { children: /* @__PURE__ */ c(co, { className: "size-2 fill-current" }) }) }),
        t
      ]
    }
  );
}
function MT({
  className: e,
  inset: t,
  ...n
}) {
  return /* @__PURE__ */ c(
    rS,
    {
      "data-slot": "context-menu-label",
      "data-inset": t,
      className: C(
        "text-foreground px-2 py-1.5 text-sm font-medium data-[inset]:pl-8",
        e
      ),
      ...n
    }
  );
}
function RT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    lS,
    {
      "data-slot": "context-menu-separator",
      className: C("bg-border -mx-1 my-1 h-px", e),
      ...t
    }
  );
}
function NT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "span",
    {
      "data-slot": "context-menu-shortcut",
      className: C(
        "text-muted-foreground ml-auto text-xs tracking-widest",
        e
      ),
      ...t
    }
  );
}
var Mo = "DropdownMenu", [pS, PT] = Q(
  Mo,
  [En]
), ge = En(), [mS, hd] = pS(Mo), gd = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: o,
    open: r,
    defaultOpen: a,
    onOpenChange: i,
    modal: s = !0
  } = e, d = ge(t), f = l.useRef(null), [u, p] = ne({
    prop: r,
    defaultProp: a ?? !1,
    onChange: i,
    caller: Mo
  });
  return /* @__PURE__ */ c(
    mS,
    {
      scope: t,
      triggerId: le(),
      triggerRef: f,
      contentId: le(),
      open: u,
      onOpenChange: p,
      onOpenToggle: l.useCallback(() => p((m) => !m), [p]),
      modal: s,
      children: /* @__PURE__ */ c(Ta, { ...d, open: u, onOpenChange: p, dir: o, modal: s, children: n })
    }
  );
};
gd.displayName = Mo;
var bd = "DropdownMenuTrigger", wd = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: o = !1, ...r } = e, a = hd(bd, n), i = ge(n);
    return /* @__PURE__ */ c(Aa, { asChild: !0, ...i, children: /* @__PURE__ */ c(
      A.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": o ? "" : void 0,
        disabled: o,
        ...r,
        ref: un(t, a.triggerRef),
        onPointerDown: N(e.onPointerDown, (s) => {
          !o && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
        }),
        onKeyDown: N(e.onKeyDown, (s) => {
          o || (["Enter", " "].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
wd.displayName = bd;
var vS = "DropdownMenuPortal", yd = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, o = ge(t);
  return /* @__PURE__ */ c(Da, { ...o, ...n });
};
yd.displayName = vS;
var xd = "DropdownMenuContent", Cd = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = hd(xd, n), a = ge(n), i = l.useRef(!1);
    return /* @__PURE__ */ c(
      Ia,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...a,
        ...o,
        ref: t,
        onCloseAutoFocus: N(e.onCloseAutoFocus, (s) => {
          i.current || r.triggerRef.current?.focus(), i.current = !1, s.preventDefault();
        }),
        onInteractOutside: N(e.onInteractOutside, (s) => {
          const d = s.detail.originalEvent, f = d.button === 0 && d.ctrlKey === !0, u = d.button === 2 || f;
          (!r.modal || u) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Cd.displayName = xd;
var hS = "DropdownMenuGroup", Sd = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ge(n);
    return /* @__PURE__ */ c(Oa, { ...r, ...o, ref: t });
  }
);
Sd.displayName = hS;
var gS = "DropdownMenuLabel", Ed = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ge(n);
    return /* @__PURE__ */ c(ka, { ...r, ...o, ref: t });
  }
);
Ed.displayName = gS;
var bS = "DropdownMenuItem", Md = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ge(n);
    return /* @__PURE__ */ c($a, { ...r, ...o, ref: t });
  }
);
Md.displayName = bS;
var wS = "DropdownMenuCheckboxItem", Rd = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ge(n);
  return /* @__PURE__ */ c(La, { ...r, ...o, ref: t });
});
Rd.displayName = wS;
var yS = "DropdownMenuRadioGroup", Nd = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ge(n);
  return /* @__PURE__ */ c(Fa, { ...r, ...o, ref: t });
});
Nd.displayName = yS;
var xS = "DropdownMenuRadioItem", Pd = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ge(n);
  return /* @__PURE__ */ c(Wa, { ...r, ...o, ref: t });
});
Pd.displayName = xS;
var CS = "DropdownMenuItemIndicator", _d = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ge(n);
  return /* @__PURE__ */ c(za, { ...r, ...o, ref: t });
});
_d.displayName = CS;
var SS = "DropdownMenuSeparator", Td = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ge(n);
  return /* @__PURE__ */ c(Ba, { ...r, ...o, ref: t });
});
Td.displayName = SS;
var ES = "DropdownMenuArrow", MS = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ge(n);
    return /* @__PURE__ */ c(Va, { ...r, ...o, ref: t });
  }
);
MS.displayName = ES;
var RS = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: o, onOpenChange: r, defaultOpen: a } = e, i = ge(t), [s, d] = ne({
    prop: o,
    defaultProp: a ?? !1,
    onChange: r,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ c(Ha, { ...i, open: s, onOpenChange: d, children: n });
}, NS = "DropdownMenuSubTrigger", Ad = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ge(n);
  return /* @__PURE__ */ c(Ga, { ...r, ...o, ref: t });
});
Ad.displayName = NS;
var PS = "DropdownMenuSubContent", Dd = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ge(n);
  return /* @__PURE__ */ c(
    Ka,
    {
      ...r,
      ...o,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Dd.displayName = PS;
var _S = gd, TS = wd, Id = yd, AS = Cd, DS = Sd, IS = Ed, OS = Md, kS = Rd, $S = Nd, LS = Pd, Od = _d, FS = Td, WS = RS, zS = Ad, BS = Dd;
function _T({
  ...e
}) {
  return /* @__PURE__ */ c(_S, { "data-slot": "dropdown-menu", ...e });
}
function TT({
  ...e
}) {
  return /* @__PURE__ */ c(Id, { "data-slot": "dropdown-menu-portal", ...e });
}
function AT({
  ...e
}) {
  return /* @__PURE__ */ c(
    TS,
    {
      "data-slot": "dropdown-menu-trigger",
      ...e
    }
  );
}
function DT({
  className: e,
  sideOffset: t = 4,
  ...n
}) {
  return /* @__PURE__ */ c(Id, { children: /* @__PURE__ */ c(
    AS,
    {
      "data-slot": "dropdown-menu-content",
      sideOffset: t,
      className: C(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md",
        e
      ),
      ...n
    }
  ) });
}
function IT({
  ...e
}) {
  return /* @__PURE__ */ c(DS, { "data-slot": "dropdown-menu-group", ...e });
}
function OT({
  className: e,
  inset: t,
  variant: n = "default",
  ...o
}) {
  return /* @__PURE__ */ c(
    OS,
    {
      "data-slot": "dropdown-menu-item",
      "data-inset": t,
      "data-variant": n,
      className: C(
        "focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o
    }
  );
}
function kT({
  className: e,
  children: t,
  checked: n,
  ...o
}) {
  return /* @__PURE__ */ z(
    kS,
    {
      "data-slot": "dropdown-menu-checkbox-item",
      className: C(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: n,
      ...o,
      children: [
        /* @__PURE__ */ c("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ c(Od, { children: /* @__PURE__ */ c(dn, { className: "size-4" }) }) }),
        t
      ]
    }
  );
}
function $T({
  ...e
}) {
  return /* @__PURE__ */ c(
    $S,
    {
      "data-slot": "dropdown-menu-radio-group",
      ...e
    }
  );
}
function LT({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ z(
    LS,
    {
      "data-slot": "dropdown-menu-radio-item",
      className: C(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ c("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ c(Od, { children: /* @__PURE__ */ c(co, { className: "size-2 fill-current" }) }) }),
        t
      ]
    }
  );
}
function FT({
  className: e,
  inset: t,
  ...n
}) {
  return /* @__PURE__ */ c(
    IS,
    {
      "data-slot": "dropdown-menu-label",
      "data-inset": t,
      className: C(
        "px-2 py-1.5 text-sm font-medium data-[inset]:pl-8",
        e
      ),
      ...n
    }
  );
}
function WT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    FS,
    {
      "data-slot": "dropdown-menu-separator",
      className: C("bg-border -mx-1 my-1 h-px", e),
      ...t
    }
  );
}
function zT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "span",
    {
      "data-slot": "dropdown-menu-shortcut",
      className: C(
        "text-muted-foreground ml-auto text-xs tracking-widest",
        e
      ),
      ...t
    }
  );
}
function BT({
  ...e
}) {
  return /* @__PURE__ */ c(WS, { "data-slot": "dropdown-menu-sub", ...e });
}
function VT({
  className: e,
  inset: t,
  children: n,
  ...o
}) {
  return /* @__PURE__ */ z(
    zS,
    {
      "data-slot": "dropdown-menu-sub-trigger",
      "data-inset": t,
      className: C(
        "focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o,
      children: [
        n,
        /* @__PURE__ */ c(io, { className: "ml-auto size-4" })
      ]
    }
  );
}
function HT({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    BS,
    {
      "data-slot": "dropdown-menu-sub-content",
      className: C(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-md border p-1 shadow-lg",
        e
      ),
      ...t
    }
  );
}
var VS = "Label", kd = l.forwardRef((e, t) => /* @__PURE__ */ c(
  A.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      n.target.closest("button, input, select, textarea") || (e.onMouseDown?.(n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
kd.displayName = VS;
var HS = kd;
function GS({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    HS,
    {
      "data-slot": "label",
      className: C(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        e
      ),
      ...t
    }
  );
}
const GT = yv, $d = l.createContext(
  {}
), KT = ({
  ...e
}) => /* @__PURE__ */ c($d.Provider, { value: { name: e.name }, children: /* @__PURE__ */ c(xv, { ...e }) }), Ro = () => {
  const e = l.useContext($d), t = l.useContext(Ld), { getFieldState: n } = Cv(), o = Sv({ name: e.name }), r = n(e.name, o);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: a } = t;
  return {
    id: a,
    name: e.name,
    formItemId: `${a}-form-item`,
    formDescriptionId: `${a}-form-item-description`,
    formMessageId: `${a}-form-item-message`,
    ...r
  };
}, Ld = l.createContext(
  {}
);
function UT({ className: e, ...t }) {
  const n = l.useId();
  return /* @__PURE__ */ c(Ld.Provider, { value: { id: n }, children: /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "form-item",
      className: C("grid gap-2", e),
      ...t
    }
  ) });
}
function YT({
  className: e,
  ...t
}) {
  const { error: n, formItemId: o } = Ro();
  return /* @__PURE__ */ c(
    GS,
    {
      "data-slot": "form-label",
      "data-error": !!n,
      className: C("data-[error=true]:text-destructive", e),
      htmlFor: o,
      ...t
    }
  );
}
function jT({ ...e }) {
  const { error: t, formItemId: n, formDescriptionId: o, formMessageId: r } = Ro();
  return /* @__PURE__ */ c(
    dt,
    {
      "data-slot": "form-control",
      id: n,
      "aria-describedby": t ? `${o} ${r}` : `${o}`,
      "aria-invalid": !!t,
      ...e
    }
  );
}
function XT({ className: e, ...t }) {
  const { formDescriptionId: n } = Ro();
  return /* @__PURE__ */ c(
    "p",
    {
      "data-slot": "form-description",
      id: n,
      className: C("text-muted-foreground text-sm", e),
      ...t
    }
  );
}
function qT({ className: e, ...t }) {
  const { error: n, formMessageId: o } = Ro(), r = n ? String(n?.message ?? "") : t.children;
  return r ? /* @__PURE__ */ c(
    "p",
    {
      "data-slot": "form-message",
      id: o,
      className: C("text-destructive text-sm", e),
      ...t,
      children: r
    }
  ) : null;
}
var pr, No = "HoverCard", [Fd, ZT] = Q(No, [
  Ue
]), Po = Ue(), [KS, _o] = Fd(No), Wd = (e) => {
  const {
    __scopeHoverCard: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    openDelay: i = 700,
    closeDelay: s = 300
  } = e, d = Po(t), f = l.useRef(0), u = l.useRef(0), p = l.useRef(!1), m = l.useRef(!1), [h, g] = ne({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: No
  }), v = l.useCallback(() => {
    clearTimeout(u.current), f.current = window.setTimeout(() => g(!0), i);
  }, [i, g]), b = l.useCallback(() => {
    clearTimeout(f.current), !p.current && !m.current && (u.current = window.setTimeout(() => g(!1), s));
  }, [s, g]), w = l.useCallback(() => g(!1), [g]);
  return l.useEffect(() => () => {
    clearTimeout(f.current), clearTimeout(u.current);
  }, []), /* @__PURE__ */ c(
    KS,
    {
      scope: t,
      open: h,
      onOpenChange: g,
      onOpen: v,
      onClose: b,
      onDismiss: w,
      hasSelectionRef: p,
      isPointerDownOnContentRef: m,
      children: /* @__PURE__ */ c(zt, { ...d, children: n })
    }
  );
};
Wd.displayName = No;
var zd = "HoverCardTrigger", Bd = l.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...o } = e, r = _o(zd, n), a = Po(n);
    return /* @__PURE__ */ c(Bt, { asChild: !0, ...a, children: /* @__PURE__ */ c(
      A.a,
      {
        "data-state": r.open ? "open" : "closed",
        ...o,
        ref: t,
        onPointerEnter: N(e.onPointerEnter, eo(r.onOpen)),
        onPointerLeave: N(e.onPointerLeave, eo(r.onClose)),
        onFocus: N(e.onFocus, r.onOpen),
        onBlur: N(e.onBlur, r.onClose),
        onTouchStart: N(e.onTouchStart, (i) => i.preventDefault())
      }
    ) });
  }
);
Bd.displayName = zd;
var Ya = "HoverCardPortal", [US, YS] = Fd(Ya, {
  forceMount: void 0
}), Vd = (e) => {
  const { __scopeHoverCard: t, forceMount: n, children: o, container: r } = e, a = _o(Ya, t);
  return /* @__PURE__ */ c(US, { scope: t, forceMount: n, children: /* @__PURE__ */ c(ee, { present: n || a.open, children: /* @__PURE__ */ c(ut, { asChild: !0, container: r, children: o }) }) });
};
Vd.displayName = Ya;
var Qn = "HoverCardContent", Hd = l.forwardRef(
  (e, t) => {
    const n = YS(Qn, e.__scopeHoverCard), { forceMount: o = n.forceMount, ...r } = e, a = _o(Qn, e.__scopeHoverCard);
    return /* @__PURE__ */ c(ee, { present: o || a.open, children: /* @__PURE__ */ c(
      jS,
      {
        "data-state": a.open ? "open" : "closed",
        ...r,
        onPointerEnter: N(e.onPointerEnter, eo(a.onOpen)),
        onPointerLeave: N(e.onPointerLeave, eo(a.onClose)),
        ref: t
      }
    ) });
  }
);
Hd.displayName = Qn;
var jS = l.forwardRef((e, t) => {
  const {
    __scopeHoverCard: n,
    onEscapeKeyDown: o,
    onPointerDownOutside: r,
    onFocusOutside: a,
    onInteractOutside: i,
    ...s
  } = e, d = _o(Qn, n), f = Po(n), u = l.useRef(null), p = W(t, u), [m, h] = l.useState(!1);
  return l.useEffect(() => {
    if (m) {
      const g = document.body;
      return pr = g.style.userSelect || g.style.webkitUserSelect, g.style.userSelect = "none", g.style.webkitUserSelect = "none", () => {
        g.style.userSelect = pr, g.style.webkitUserSelect = pr;
      };
    }
  }, [m]), l.useEffect(() => {
    if (u.current) {
      const g = () => {
        h(!1), d.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          document.getSelection()?.toString() !== "" && (d.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", g), () => {
        document.removeEventListener("pointerup", g), d.hasSelectionRef.current = !1, d.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [d.isPointerDownOnContentRef, d.hasSelectionRef]), l.useEffect(() => {
    u.current && ZS(u.current).forEach((v) => v.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ c(
    nt,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: i,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: N(a, (g) => {
        g.preventDefault();
      }),
      onDismiss: d.onDismiss,
      children: /* @__PURE__ */ c(
        bn,
        {
          ...f,
          ...s,
          onPointerDown: N(s.onPointerDown, (g) => {
            g.currentTarget.contains(g.target) && h(!0), d.hasSelectionRef.current = !1, d.isPointerDownOnContentRef.current = !0;
          }),
          ref: p,
          style: {
            ...s.style,
            userSelect: m ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: m ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), XS = "HoverCardArrow", qS = l.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...o } = e, r = Po(n);
    return /* @__PURE__ */ c(wn, { ...r, ...o, ref: t });
  }
);
qS.displayName = XS;
function eo(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function ZS(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
var JS = Wd, QS = Bd, eE = Vd, tE = Hd;
function JT({
  ...e
}) {
  return /* @__PURE__ */ c(JS, { "data-slot": "hover-card", ...e });
}
function QT({
  ...e
}) {
  return /* @__PURE__ */ c(QS, { "data-slot": "hover-card-trigger", ...e });
}
function e0({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ...o
}) {
  return /* @__PURE__ */ c(eE, { "data-slot": "hover-card-portal", children: /* @__PURE__ */ c(
    tE,
    {
      "data-slot": "hover-card-content",
      align: t,
      sideOffset: n,
      className: C(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-64 origin-(--radix-hover-card-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden",
        e
      ),
      ...o
    }
  ) });
}
function Gd({ className: e, type: t, ...n }) {
  return /* @__PURE__ */ c(
    "input",
    {
      type: t,
      "data-slot": "input",
      className: C(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        e
      ),
      ...n
    }
  );
}
function nE({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "textarea",
    {
      "data-slot": "textarea",
      className: C(
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        e
      ),
      ...t
    }
  );
}
function t0({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "input-group",
      role: "group",
      className: C(
        "group/input-group border-input dark:bg-input/30 relative flex w-full items-center rounded-md border shadow-xs transition-[color,box-shadow] outline-none",
        "h-9 min-w-0 has-[>textarea]:h-auto",
        // Variants based on alignment.
        "has-[>[data-align=inline-start]]:[&>input]:pl-2",
        "has-[>[data-align=inline-end]]:[&>input]:pr-2",
        "has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3",
        "has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3",
        // Focus state.
        "has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot=input-group-control]:focus-visible]:ring-[3px]",
        // Error state.
        "has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[[data-slot][aria-invalid=true]]:border-destructive dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40",
        e
      ),
      ...t
    }
  );
}
const oE = et(
  "text-muted-foreground flex h-auto cursor-text items-center justify-center gap-2 py-1.5 text-sm font-medium select-none [&>svg:not([class*='size-'])]:size-4 [&>kbd]:rounded-[calc(var(--radius)-5px)] group-data-[disabled=true]/input-group:opacity-50",
  {
    variants: {
      align: {
        "inline-start": "order-first ps-3 has-[>button]:ml-[-0.45rem] has-[>kbd]:ml-[-0.35rem]",
        "inline-end": "order-last pr-3 has-[>button]:mr-[-0.45rem] has-[>kbd]:mr-[-0.35rem]",
        "block-start": "order-first w-full justify-start px-3 pt-3 [.border-b]:pb-3 group-has-[>input]/input-group:pt-2.5",
        "block-end": "order-last w-full justify-start px-3 pb-3 [.border-t]:pt-3 group-has-[>input]/input-group:pb-2.5"
      }
    },
    defaultVariants: {
      align: "inline-start"
    }
  }
);
function n0({
  className: e,
  align: t = "inline-start",
  ...n
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      role: "group",
      "data-slot": "input-group-addon",
      "data-align": t,
      className: C(oE({ align: t }), e),
      onClick: (o) => {
        o.target.closest("button") || o.currentTarget.parentElement?.querySelector("input")?.focus();
      },
      ...n
    }
  );
}
const rE = et(
  "text-sm shadow-none flex gap-2 items-center",
  {
    variants: {
      size: {
        xs: "h-6 gap-1 px-2 rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-3.5 has-[>svg]:px-2",
        sm: "h-8 px-2.5 gap-1.5 rounded-md has-[>svg]:px-2.5",
        "icon-xs": "size-6 rounded-[calc(var(--radius)-5px)] p-0 has-[>svg]:p-0",
        "icon-sm": "size-8 p-0 has-[>svg]:p-0"
      }
    },
    defaultVariants: {
      size: "xs"
    }
  }
);
function o0({
  className: e,
  type: t = "button",
  variant: n = "ghost",
  size: o = "xs",
  ...r
}) {
  return /* @__PURE__ */ c(
    Ze,
    {
      type: t,
      "data-size": o,
      variant: n,
      className: C(rE({ size: o }), e),
      ...r
    }
  );
}
function r0({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "span",
    {
      className: C(
        "text-muted-foreground flex items-center gap-2 text-sm [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function a0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Gd,
    {
      "data-slot": "input-group-control",
      className: C(
        "flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0 dark:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function s0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    nE,
    {
      "data-slot": "input-group-control",
      className: C(
        "flex-1 resize-none rounded-none border-0 bg-transparent py-3 shadow-none focus-visible:ring-0 dark:bg-transparent",
        e
      ),
      ...t
    }
  );
}
const aE = l.forwardRef(({ className: e, containerClassName: t, ...n }, o) => /* @__PURE__ */ c(
  Ev,
  {
    ref: o,
    containerClassName: C(
      "flex items-center gap-2 has-[:disabled]:opacity-50",
      t
    ),
    className: C("disabled:cursor-not-allowed", e),
    ...n
  }
));
aE.displayName = "InputOTP";
const sE = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c("div", { ref: n, className: C("flex items-center", e), ...t }));
sE.displayName = "InputOTPGroup";
const iE = l.forwardRef(({ index: e, className: t, ...n }, o) => {
  const r = l.useContext(Mv), { char: a, hasFakeCaret: i, isActive: s } = r.slots[e];
  return /* @__PURE__ */ z(
    "div",
    {
      ref: o,
      className: C(
        "border-input relative flex h-9 w-9 items-center justify-center border-y border-r text-sm shadow-sm transition-all first:rounded-l-md first:border-l last:rounded-r-md",
        s && "ring-ring z-10 ring-1",
        t
      ),
      ...n,
      children: [
        a,
        i && /* @__PURE__ */ c("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ c("div", { className: "animate-caret-blink bg-foreground h-4 w-px duration-1000" }) })
      ]
    }
  );
});
iE.displayName = "InputOTPSlot";
const cE = l.forwardRef(({ ...e }, t) => /* @__PURE__ */ c("div", { ref: t, role: "separator", ...e, children: /* @__PURE__ */ c(km, {}) }));
cE.displayName = "InputOTPSeparator";
var Nn = "Menubar", [Er, lE, dE] = tt(Nn), [Kd, i0] = Q(Nn, [
  dE,
  Ye
]), be = En(), Ud = Ye(), [uE, ja] = Kd(Nn), Yd = l.forwardRef(
  (e, t) => {
    const {
      __scopeMenubar: n,
      value: o,
      onValueChange: r,
      defaultValue: a,
      loop: i = !0,
      dir: s,
      ...d
    } = e, f = Oe(s), u = Ud(n), [p, m] = ne({
      prop: o,
      onChange: r,
      defaultProp: a ?? "",
      caller: Nn
    }), [h, g] = l.useState(null);
    return /* @__PURE__ */ c(
      uE,
      {
        scope: n,
        value: p,
        onMenuOpen: l.useCallback(
          (v) => {
            m(v), g(v);
          },
          [m]
        ),
        onMenuClose: l.useCallback(() => m(""), [m]),
        onMenuToggle: l.useCallback(
          (v) => {
            m((b) => b ? "" : v), g(v);
          },
          [m]
        ),
        dir: f,
        loop: i,
        children: /* @__PURE__ */ c(Er.Provider, { scope: n, children: /* @__PURE__ */ c(Er.Slot, { scope: n, children: /* @__PURE__ */ c(
          xn,
          {
            asChild: !0,
            ...u,
            orientation: "horizontal",
            loop: i,
            dir: f,
            currentTabStopId: h,
            onCurrentTabStopIdChange: g,
            children: /* @__PURE__ */ c(A.div, { role: "menubar", ...d, ref: t })
          }
        ) }) })
      }
    );
  }
);
Yd.displayName = Nn;
var Xa = "MenubarMenu", [fE, jd] = Kd(Xa), Xd = (e) => {
  const { __scopeMenubar: t, value: n, ...o } = e, r = le(), a = n || r || "LEGACY_REACT_AUTO_VALUE", i = ja(Xa, t), s = be(t), d = l.useRef(null), f = l.useRef(!1), u = i.value === a;
  return l.useEffect(() => {
    u || (f.current = !1);
  }, [u]), /* @__PURE__ */ c(
    fE,
    {
      scope: t,
      value: a,
      triggerId: le(),
      triggerRef: d,
      contentId: le(),
      wasKeyboardTriggerOpenRef: f,
      children: /* @__PURE__ */ c(
        Ta,
        {
          ...s,
          open: u,
          onOpenChange: (p) => {
            p || i.onMenuClose();
          },
          modal: !1,
          dir: i.dir,
          ...o
        }
      )
    }
  );
};
Xd.displayName = Xa;
var Mr = "MenubarTrigger", qd = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, disabled: o = !1, ...r } = e, a = Ud(n), i = be(n), s = ja(Mr, n), d = jd(Mr, n), f = l.useRef(null), u = W(t, f, d.triggerRef), [p, m] = l.useState(!1), h = s.value === d.value;
    return /* @__PURE__ */ c(Er.ItemSlot, { scope: n, value: d.value, disabled: o, children: /* @__PURE__ */ c(
      Cn,
      {
        asChild: !0,
        ...a,
        focusable: !o,
        tabStopId: d.value,
        children: /* @__PURE__ */ c(Aa, { asChild: !0, ...i, children: /* @__PURE__ */ c(
          A.button,
          {
            type: "button",
            role: "menuitem",
            id: d.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": h,
            "aria-controls": h ? d.contentId : void 0,
            "data-highlighted": p ? "" : void 0,
            "data-state": h ? "open" : "closed",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            ...r,
            ref: u,
            onPointerDown: N(e.onPointerDown, (g) => {
              !o && g.button === 0 && g.ctrlKey === !1 && (s.onMenuOpen(d.value), h || g.preventDefault());
            }),
            onPointerEnter: N(e.onPointerEnter, () => {
              !!s.value && !h && (s.onMenuOpen(d.value), f.current?.focus());
            }),
            onKeyDown: N(e.onKeyDown, (g) => {
              o || (["Enter", " "].includes(g.key) && s.onMenuToggle(d.value), g.key === "ArrowDown" && s.onMenuOpen(d.value), ["Enter", " ", "ArrowDown"].includes(g.key) && (d.wasKeyboardTriggerOpenRef.current = !0, g.preventDefault()));
            }),
            onFocus: N(e.onFocus, () => m(!0)),
            onBlur: N(e.onBlur, () => m(!1))
          }
        ) })
      }
    ) });
  }
);
qd.displayName = Mr;
var pE = "MenubarPortal", Zd = (e) => {
  const { __scopeMenubar: t, ...n } = e, o = be(t);
  return /* @__PURE__ */ c(Da, { ...o, ...n });
};
Zd.displayName = pE;
var Rr = "MenubarContent", Jd = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, align: o = "start", ...r } = e, a = be(n), i = ja(Rr, n), s = jd(Rr, n), d = lE(n), f = l.useRef(!1);
    return /* @__PURE__ */ c(
      Ia,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        "data-radix-menubar-content": "",
        ...a,
        ...r,
        ref: t,
        align: o,
        onCloseAutoFocus: N(e.onCloseAutoFocus, (u) => {
          !!!i.value && !f.current && s.triggerRef.current?.focus(), f.current = !1, u.preventDefault();
        }),
        onFocusOutside: N(e.onFocusOutside, (u) => {
          const p = u.target;
          d().some((h) => h.ref.current?.contains(p)) && u.preventDefault();
        }),
        onInteractOutside: N(e.onInteractOutside, () => {
          f.current = !0;
        }),
        onEntryFocus: (u) => {
          s.wasKeyboardTriggerOpenRef.current || u.preventDefault();
        },
        onKeyDown: N(
          e.onKeyDown,
          (u) => {
            if (["ArrowRight", "ArrowLeft"].includes(u.key)) {
              const p = u.target, m = p.hasAttribute("data-radix-menubar-subtrigger"), h = p.closest("[data-radix-menubar-content]") !== u.currentTarget, v = (i.dir === "rtl" ? "ArrowRight" : "ArrowLeft") === u.key;
              if (!v && m || h && v) return;
              let y = d().filter((S) => !S.disabled).map((S) => S.value);
              v && y.reverse();
              const x = y.indexOf(s.value);
              y = i.loop ? RE(y, x + 1) : y.slice(x + 1);
              const [E] = y;
              E && i.onMenuOpen(E);
            }
          },
          { checkForDefaultPrevented: !1 }
        ),
        style: {
          ...e.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Jd.displayName = Rr;
var mE = "MenubarGroup", Qd = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...o } = e, r = be(n);
    return /* @__PURE__ */ c(Oa, { ...r, ...o, ref: t });
  }
);
Qd.displayName = mE;
var vE = "MenubarLabel", eu = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...o } = e, r = be(n);
    return /* @__PURE__ */ c(ka, { ...r, ...o, ref: t });
  }
);
eu.displayName = vE;
var hE = "MenubarItem", tu = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...o } = e, r = be(n);
    return /* @__PURE__ */ c($a, { ...r, ...o, ref: t });
  }
);
tu.displayName = hE;
var gE = "MenubarCheckboxItem", nu = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...o } = e, r = be(n);
    return /* @__PURE__ */ c(La, { ...r, ...o, ref: t });
  }
);
nu.displayName = gE;
var bE = "MenubarRadioGroup", ou = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...o } = e, r = be(n);
    return /* @__PURE__ */ c(Fa, { ...r, ...o, ref: t });
  }
);
ou.displayName = bE;
var wE = "MenubarRadioItem", ru = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...o } = e, r = be(n);
    return /* @__PURE__ */ c(Wa, { ...r, ...o, ref: t });
  }
);
ru.displayName = wE;
var yE = "MenubarItemIndicator", au = l.forwardRef((e, t) => {
  const { __scopeMenubar: n, ...o } = e, r = be(n);
  return /* @__PURE__ */ c(za, { ...r, ...o, ref: t });
});
au.displayName = yE;
var xE = "MenubarSeparator", su = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...o } = e, r = be(n);
    return /* @__PURE__ */ c(Ba, { ...r, ...o, ref: t });
  }
);
su.displayName = xE;
var CE = "MenubarArrow", SE = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...o } = e, r = be(n);
    return /* @__PURE__ */ c(Va, { ...r, ...o, ref: t });
  }
);
SE.displayName = CE;
var iu = "MenubarSub", cu = (e) => {
  const { __scopeMenubar: t, children: n, open: o, onOpenChange: r, defaultOpen: a } = e, i = be(t), [s, d] = ne({
    prop: o,
    defaultProp: a ?? !1,
    onChange: r,
    caller: iu
  });
  return /* @__PURE__ */ c(Ha, { ...i, open: s, onOpenChange: d, children: n });
};
cu.displayName = iu;
var EE = "MenubarSubTrigger", lu = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...o } = e, r = be(n);
    return /* @__PURE__ */ c(
      Ga,
      {
        "data-radix-menubar-subtrigger": "",
        ...r,
        ...o,
        ref: t
      }
    );
  }
);
lu.displayName = EE;
var ME = "MenubarSubContent", du = l.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...o } = e, r = be(n);
    return /* @__PURE__ */ c(
      Ka,
      {
        ...r,
        "data-radix-menubar-content": "",
        ...o,
        ref: t,
        style: {
          ...e.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
du.displayName = ME;
function RE(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var NE = Yd, PE = Xd, _E = qd, TE = Zd, AE = Jd, DE = Qd, IE = eu, OE = tu, kE = nu, $E = ou, LE = ru, uu = au, FE = su, WE = cu, zE = lu, BE = du;
function c0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    NE,
    {
      "data-slot": "menubar",
      className: C(
        "bg-background flex h-9 items-center gap-1 rounded-md border p-1 shadow-xs",
        e
      ),
      ...t
    }
  );
}
function l0({
  ...e
}) {
  return /* @__PURE__ */ c(PE, { "data-slot": "menubar-menu", ...e });
}
function d0({
  ...e
}) {
  return /* @__PURE__ */ c(DE, { "data-slot": "menubar-group", ...e });
}
function VE({
  ...e
}) {
  return /* @__PURE__ */ c(TE, { "data-slot": "menubar-portal", ...e });
}
function u0({
  ...e
}) {
  return /* @__PURE__ */ c($E, { "data-slot": "menubar-radio-group", ...e });
}
function f0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    _E,
    {
      "data-slot": "menubar-trigger",
      className: C(
        "focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground flex items-center rounded-sm px-2 py-1 text-sm font-medium outline-hidden select-none",
        e
      ),
      ...t
    }
  );
}
function p0({
  className: e,
  align: t = "start",
  alignOffset: n = -4,
  sideOffset: o = 8,
  ...r
}) {
  return /* @__PURE__ */ c(VE, { children: /* @__PURE__ */ c(
    AE,
    {
      "data-slot": "menubar-content",
      align: t,
      alignOffset: n,
      sideOffset: o,
      className: C(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[12rem] origin-(--radix-menubar-content-transform-origin) overflow-hidden rounded-md border p-1 shadow-md",
        e
      ),
      ...r
    }
  ) });
}
function m0({
  className: e,
  inset: t,
  variant: n = "default",
  ...o
}) {
  return /* @__PURE__ */ c(
    OE,
    {
      "data-slot": "menubar-item",
      "data-inset": t,
      "data-variant": n,
      className: C(
        "focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o
    }
  );
}
function v0({
  className: e,
  children: t,
  checked: n,
  ...o
}) {
  return /* @__PURE__ */ z(
    kE,
    {
      "data-slot": "menubar-checkbox-item",
      className: C(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-xs py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: n,
      ...o,
      children: [
        /* @__PURE__ */ c("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ c(uu, { children: /* @__PURE__ */ c(dn, { className: "size-4" }) }) }),
        t
      ]
    }
  );
}
function h0({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ z(
    LE,
    {
      "data-slot": "menubar-radio-item",
      className: C(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-xs py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ c("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ c(uu, { children: /* @__PURE__ */ c(co, { className: "size-2 fill-current" }) }) }),
        t
      ]
    }
  );
}
function g0({
  className: e,
  inset: t,
  ...n
}) {
  return /* @__PURE__ */ c(
    IE,
    {
      "data-slot": "menubar-label",
      "data-inset": t,
      className: C(
        "px-2 py-1.5 text-sm font-medium data-[inset]:pl-8",
        e
      ),
      ...n
    }
  );
}
function b0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    FE,
    {
      "data-slot": "menubar-separator",
      className: C("bg-border -mx-1 my-1 h-px", e),
      ...t
    }
  );
}
function w0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "span",
    {
      "data-slot": "menubar-shortcut",
      className: C(
        "text-muted-foreground ml-auto text-xs tracking-widest",
        e
      ),
      ...t
    }
  );
}
function y0({
  ...e
}) {
  return /* @__PURE__ */ c(WE, { "data-slot": "menubar-sub", ...e });
}
function x0({
  className: e,
  inset: t,
  children: n,
  ...o
}) {
  return /* @__PURE__ */ z(
    zE,
    {
      "data-slot": "menubar-sub-trigger",
      "data-inset": t,
      className: C(
        "focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground flex cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-none select-none data-[inset]:pl-8",
        e
      ),
      ...o,
      children: [
        n,
        /* @__PURE__ */ c(io, { className: "ml-auto h-4 w-4" })
      ]
    }
  );
}
function C0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    BE,
    {
      "data-slot": "menubar-sub-content",
      className: C(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-(--radix-menubar-content-transform-origin) overflow-hidden rounded-md border p-1 shadow-lg",
        e
      ),
      ...t
    }
  );
}
var fu = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), HE = "VisuallyHidden", To = l.forwardRef(
  (e, t) => /* @__PURE__ */ c(
    A.span,
    {
      ...e,
      ref: t,
      style: { ...fu, ...e.style }
    }
  )
);
To.displayName = HE;
var pu = To, Et = "NavigationMenu", [qa, mu, GE] = tt(Et), [Nr, KE, UE] = tt(Et), [Za, S0] = Q(
  Et,
  [GE, UE]
), [YE, Pe] = Za(Et), [jE, XE] = Za(Et), vu = l.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: o,
      onValueChange: r,
      defaultValue: a,
      delayDuration: i = 200,
      skipDelayDuration: s = 300,
      orientation: d = "horizontal",
      dir: f,
      ...u
    } = e, [p, m] = l.useState(null), h = W(t, (T) => m(T)), g = Oe(f), v = l.useRef(0), b = l.useRef(0), w = l.useRef(0), [y, x] = l.useState(!0), [E, S] = ne({
      prop: o,
      onChange: (T) => {
        const D = T !== "", O = s > 0;
        D ? (window.clearTimeout(w.current), O && x(!1)) : (window.clearTimeout(w.current), w.current = window.setTimeout(
          () => x(!0),
          s
        )), r?.(T);
      },
      defaultProp: a ?? "",
      caller: Et
    }), R = l.useCallback(() => {
      window.clearTimeout(b.current), b.current = window.setTimeout(() => S(""), 150);
    }, [S]), M = l.useCallback(
      (T) => {
        window.clearTimeout(b.current), S(T);
      },
      [S]
    ), P = l.useCallback(
      (T) => {
        E === T ? window.clearTimeout(b.current) : v.current = window.setTimeout(() => {
          window.clearTimeout(b.current), S(T);
        }, i);
      },
      [E, S, i]
    );
    return l.useEffect(() => () => {
      window.clearTimeout(v.current), window.clearTimeout(b.current), window.clearTimeout(w.current);
    }, []), /* @__PURE__ */ c(
      hu,
      {
        scope: n,
        isRootMenu: !0,
        value: E,
        dir: g,
        orientation: d,
        rootNavigationMenu: p,
        onTriggerEnter: (T) => {
          window.clearTimeout(v.current), y ? P(T) : M(T);
        },
        onTriggerLeave: () => {
          window.clearTimeout(v.current), R();
        },
        onContentEnter: () => window.clearTimeout(b.current),
        onContentLeave: R,
        onItemSelect: (T) => {
          S((D) => D === T ? "" : T);
        },
        onItemDismiss: () => S(""),
        children: /* @__PURE__ */ c(
          A.nav,
          {
            "aria-label": "Main",
            "data-orientation": d,
            dir: g,
            ...u,
            ref: h
          }
        )
      }
    );
  }
);
vu.displayName = Et;
var Pr = "NavigationMenuSub", qE = l.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: o,
      onValueChange: r,
      defaultValue: a,
      orientation: i = "horizontal",
      ...s
    } = e, d = Pe(Pr, n), [f, u] = ne({
      prop: o,
      onChange: r,
      defaultProp: a ?? "",
      caller: Pr
    });
    return /* @__PURE__ */ c(
      hu,
      {
        scope: n,
        isRootMenu: !1,
        value: f,
        dir: d.dir,
        orientation: i,
        rootNavigationMenu: d.rootNavigationMenu,
        onTriggerEnter: (p) => u(p),
        onItemSelect: (p) => u(p),
        onItemDismiss: () => u(""),
        children: /* @__PURE__ */ c(A.div, { "data-orientation": i, ...s, ref: t })
      }
    );
  }
);
qE.displayName = Pr;
var hu = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: o,
    dir: r,
    orientation: a,
    children: i,
    value: s,
    onItemSelect: d,
    onItemDismiss: f,
    onTriggerEnter: u,
    onTriggerLeave: p,
    onContentEnter: m,
    onContentLeave: h
  } = e, [g, v] = l.useState(null), [b, w] = l.useState(/* @__PURE__ */ new Map()), [y, x] = l.useState(null);
  return /* @__PURE__ */ c(
    YE,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: o,
      value: s,
      previousValue: Lt(s),
      baseId: le(),
      dir: r,
      orientation: a,
      viewport: g,
      onViewportChange: v,
      indicatorTrack: y,
      onIndicatorTrackChange: x,
      onTriggerEnter: q(u),
      onTriggerLeave: q(p),
      onContentEnter: q(m),
      onContentLeave: q(h),
      onItemSelect: q(d),
      onItemDismiss: q(f),
      onViewportContentChange: l.useCallback((E, S) => {
        w((R) => (R.set(E, S), new Map(R)));
      }, []),
      onViewportContentRemove: l.useCallback((E) => {
        w((S) => S.has(E) ? (S.delete(E), new Map(S)) : S);
      }, []),
      children: /* @__PURE__ */ c(qa.Provider, { scope: t, children: /* @__PURE__ */ c(jE, { scope: t, items: b, children: i }) })
    }
  );
}, gu = "NavigationMenuList", bu = l.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = Pe(gu, n), a = /* @__PURE__ */ c(A.ul, { "data-orientation": r.orientation, ...o, ref: t });
    return /* @__PURE__ */ c(A.div, { style: { position: "relative" }, ref: r.onIndicatorTrackChange, children: /* @__PURE__ */ c(qa.Slot, { scope: n, children: r.isRootMenu ? /* @__PURE__ */ c(Pu, { asChild: !0, children: a }) : a }) });
  }
);
bu.displayName = gu;
var wu = "NavigationMenuItem", [ZE, yu] = Za(wu), xu = l.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: o, ...r } = e, a = le(), i = o || a || "LEGACY_REACT_AUTO_VALUE", s = l.useRef(null), d = l.useRef(null), f = l.useRef(null), u = l.useRef(() => {
    }), p = l.useRef(!1), m = l.useCallback((g = "start") => {
      if (s.current) {
        u.current();
        const v = Tr(s.current);
        v.length && es(g === "start" ? v : v.reverse());
      }
    }, []), h = l.useCallback(() => {
      if (s.current) {
        const g = Tr(s.current);
        g.length && (u.current = rM(g));
      }
    }, []);
    return /* @__PURE__ */ c(
      ZE,
      {
        scope: n,
        value: i,
        triggerRef: d,
        contentRef: s,
        focusProxyRef: f,
        wasEscapeCloseRef: p,
        onEntryKeyDown: m,
        onFocusProxyEnter: m,
        onRootContentClose: h,
        onContentFocusOutside: h,
        children: /* @__PURE__ */ c(A.li, { ...r, ref: t })
      }
    );
  }
);
xu.displayName = wu;
var _r = "NavigationMenuTrigger", Cu = l.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: o, ...r } = e, a = Pe(_r, e.__scopeNavigationMenu), i = yu(_r, e.__scopeNavigationMenu), s = l.useRef(null), d = W(s, i.triggerRef, t), f = Tu(a.baseId, i.value), u = Au(a.baseId, i.value), p = l.useRef(!1), m = l.useRef(!1), h = i.value === a.value;
  return /* @__PURE__ */ z(Se, { children: [
    /* @__PURE__ */ c(qa.ItemSlot, { scope: n, value: i.value, children: /* @__PURE__ */ c(_u, { asChild: !0, children: /* @__PURE__ */ c(
      A.button,
      {
        id: f,
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-state": ts(h),
        "aria-expanded": h,
        "aria-controls": u,
        ...r,
        ref: d,
        onPointerEnter: N(e.onPointerEnter, () => {
          m.current = !1, i.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: N(
          e.onPointerMove,
          to(() => {
            o || m.current || i.wasEscapeCloseRef.current || p.current || (a.onTriggerEnter(i.value), p.current = !0);
          })
        ),
        onPointerLeave: N(
          e.onPointerLeave,
          to(() => {
            o || (a.onTriggerLeave(), p.current = !1);
          })
        ),
        onClick: N(e.onClick, () => {
          a.onItemSelect(i.value), m.current = h;
        }),
        onKeyDown: N(e.onKeyDown, (g) => {
          const b = { horizontal: "ArrowDown", vertical: a.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[a.orientation];
          h && g.key === b && (i.onEntryKeyDown(), g.preventDefault());
        })
      }
    ) }) }),
    h && /* @__PURE__ */ z(Se, { children: [
      /* @__PURE__ */ c(
        pu,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: i.focusProxyRef,
          onFocus: (g) => {
            const v = i.contentRef.current, b = g.relatedTarget, w = b === s.current, y = v?.contains(b);
            (w || !y) && i.onFocusProxyEnter(w ? "start" : "end");
          }
        }
      ),
      a.viewport && /* @__PURE__ */ c("span", { "aria-owns": u })
    ] })
  ] });
});
Cu.displayName = _r;
var JE = "NavigationMenuLink", ni = "navigationMenu.linkSelect", Su = l.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: o, onSelect: r, ...a } = e;
    return /* @__PURE__ */ c(_u, { asChild: !0, children: /* @__PURE__ */ c(
      A.a,
      {
        "data-active": o ? "" : void 0,
        "aria-current": o ? "page" : void 0,
        ...a,
        ref: t,
        onClick: N(
          e.onClick,
          (i) => {
            const s = i.target, d = new CustomEvent(ni, {
              bubbles: !0,
              cancelable: !0
            });
            if (s.addEventListener(ni, (f) => r?.(f), { once: !0 }), Qt(s, d), !d.defaultPrevented && !i.metaKey) {
              const f = new CustomEvent(Gn, {
                bubbles: !0,
                cancelable: !0
              });
              Qt(s, f);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Su.displayName = JE;
var Ja = "NavigationMenuIndicator", Eu = l.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Pe(Ja, e.__scopeNavigationMenu), a = !!r.value;
  return r.indicatorTrack ? pi.createPortal(
    /* @__PURE__ */ c(ee, { present: n || a, children: /* @__PURE__ */ c(QE, { ...o, ref: t }) }),
    r.indicatorTrack
  ) : null;
});
Eu.displayName = Ja;
var QE = l.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...o } = e, r = Pe(Ja, n), a = mu(n), [i, s] = l.useState(
    null
  ), [d, f] = l.useState(null), u = r.orientation === "horizontal", p = !!r.value;
  l.useEffect(() => {
    const g = a().find((v) => v.value === r.value)?.ref.current;
    g && s(g);
  }, [a, r.value]);
  const m = () => {
    i && f({
      size: u ? i.offsetWidth : i.offsetHeight,
      offset: u ? i.offsetLeft : i.offsetTop
    });
  };
  return Ar(i, m), Ar(r.indicatorTrack, m), d ? /* @__PURE__ */ c(
    A.div,
    {
      "aria-hidden": !0,
      "data-state": p ? "visible" : "hidden",
      "data-orientation": r.orientation,
      ...o,
      ref: t,
      style: {
        position: "absolute",
        ...u ? {
          left: 0,
          width: d.size + "px",
          transform: `translateX(${d.offset}px)`
        } : {
          top: 0,
          height: d.size + "px",
          transform: `translateY(${d.offset}px)`
        },
        ...o.style
      }
    }
  ) : null;
}), Dt = "NavigationMenuContent", Mu = l.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Pe(Dt, e.__scopeNavigationMenu), a = yu(Dt, e.__scopeNavigationMenu), i = W(a.contentRef, t), s = a.value === r.value, d = {
    value: a.value,
    triggerRef: a.triggerRef,
    focusProxyRef: a.focusProxyRef,
    wasEscapeCloseRef: a.wasEscapeCloseRef,
    onContentFocusOutside: a.onContentFocusOutside,
    onRootContentClose: a.onRootContentClose,
    ...o
  };
  return r.viewport ? /* @__PURE__ */ c(eM, { forceMount: n, ...d, ref: i }) : /* @__PURE__ */ c(ee, { present: n || s, children: /* @__PURE__ */ c(
    Ru,
    {
      "data-state": ts(s),
      ...d,
      ref: i,
      onPointerEnter: N(e.onPointerEnter, r.onContentEnter),
      onPointerLeave: N(
        e.onPointerLeave,
        to(r.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !s && r.isRootMenu ? "none" : void 0,
        ...d.style
      }
    }
  ) });
});
Mu.displayName = Dt;
var eM = l.forwardRef((e, t) => {
  const n = Pe(Dt, e.__scopeNavigationMenu), { onViewportContentChange: o, onViewportContentRemove: r } = n;
  return oe(() => {
    o(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, o]), oe(() => () => r(e.value), [e.value, r]), null;
}), Gn = "navigationMenu.rootContentDismiss", Ru = l.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: o,
    triggerRef: r,
    focusProxyRef: a,
    wasEscapeCloseRef: i,
    onRootContentClose: s,
    onContentFocusOutside: d,
    ...f
  } = e, u = Pe(Dt, n), p = l.useRef(null), m = W(p, t), h = Tu(u.baseId, o), g = Au(u.baseId, o), v = mu(n), b = l.useRef(null), { onItemDismiss: w } = u;
  l.useEffect(() => {
    const x = p.current;
    if (u.isRootMenu && x) {
      const E = () => {
        w(), s(), x.contains(document.activeElement) && r.current?.focus();
      };
      return x.addEventListener(Gn, E), () => x.removeEventListener(Gn, E);
    }
  }, [u.isRootMenu, e.value, r, w, s]);
  const y = l.useMemo(() => {
    const E = v().map((D) => D.value);
    u.dir === "rtl" && E.reverse();
    const S = E.indexOf(u.value), R = E.indexOf(u.previousValue), M = o === u.value, P = R === E.indexOf(o);
    if (!M && !P) return b.current;
    const T = (() => {
      if (S !== R) {
        if (M && R !== -1) return S > R ? "from-end" : "from-start";
        if (P && S !== -1) return S > R ? "to-start" : "to-end";
      }
      return null;
    })();
    return b.current = T, T;
  }, [u.previousValue, u.value, u.dir, v, o]);
  return /* @__PURE__ */ c(Pu, { asChild: !0, children: /* @__PURE__ */ c(
    nt,
    {
      id: g,
      "aria-labelledby": h,
      "data-motion": y,
      "data-orientation": u.orientation,
      ...f,
      ref: m,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        const x = new Event(Gn, {
          bubbles: !0,
          cancelable: !0
        });
        p.current?.dispatchEvent(x);
      },
      onFocusOutside: N(e.onFocusOutside, (x) => {
        d();
        const E = x.target;
        u.rootNavigationMenu?.contains(E) && x.preventDefault();
      }),
      onPointerDownOutside: N(e.onPointerDownOutside, (x) => {
        const E = x.target, S = v().some((M) => M.ref.current?.contains(E)), R = u.isRootMenu && u.viewport?.contains(E);
        (S || R || !u.isRootMenu) && x.preventDefault();
      }),
      onKeyDown: N(e.onKeyDown, (x) => {
        const E = x.altKey || x.ctrlKey || x.metaKey;
        if (x.key === "Tab" && !E) {
          const R = Tr(x.currentTarget), M = document.activeElement, P = R.findIndex((O) => O === M), D = x.shiftKey ? R.slice(0, P).reverse() : R.slice(P + 1, R.length);
          es(D) ? x.preventDefault() : a.current?.focus();
        }
      }),
      onEscapeKeyDown: N(e.onEscapeKeyDown, (x) => {
        i.current = !0;
      })
    }
  ) });
}), Qa = "NavigationMenuViewport", Nu = l.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = !!Pe(Qa, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ c(ee, { present: n || a, children: /* @__PURE__ */ c(tM, { ...o, ref: t }) });
});
Nu.displayName = Qa;
var tM = l.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: o, ...r } = e, a = Pe(Qa, n), i = W(t, a.onViewportChange), s = XE(
    Dt,
    e.__scopeNavigationMenu
  ), [d, f] = l.useState(null), [u, p] = l.useState(null), m = d ? d?.width + "px" : void 0, h = d ? d?.height + "px" : void 0, g = !!a.value, v = g ? a.value : a.previousValue;
  return Ar(u, () => {
    u && f({ width: u.offsetWidth, height: u.offsetHeight });
  }), /* @__PURE__ */ c(
    A.div,
    {
      "data-state": ts(g),
      "data-orientation": a.orientation,
      ...r,
      ref: i,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !g && a.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": m,
        "--radix-navigation-menu-viewport-height": h,
        ...r.style
      },
      onPointerEnter: N(e.onPointerEnter, a.onContentEnter),
      onPointerLeave: N(e.onPointerLeave, to(a.onContentLeave)),
      children: Array.from(s.items).map(([w, { ref: y, forceMount: x, ...E }]) => {
        const S = v === w;
        return /* @__PURE__ */ c(ee, { present: x || S, children: /* @__PURE__ */ c(
          Ru,
          {
            ...E,
            ref: un(y, (R) => {
              S && R && p(R);
            })
          }
        ) }, w);
      })
    }
  );
}), nM = "FocusGroup", Pu = l.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = Pe(nM, n);
    return /* @__PURE__ */ c(Nr.Provider, { scope: n, children: /* @__PURE__ */ c(Nr.Slot, { scope: n, children: /* @__PURE__ */ c(A.div, { dir: r.dir, ...o, ref: t }) }) });
  }
), oi = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], oM = "FocusGroupItem", _u = l.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = KE(n), a = Pe(oM, n);
    return /* @__PURE__ */ c(Nr.ItemSlot, { scope: n, children: /* @__PURE__ */ c(
      A.button,
      {
        ...o,
        ref: t,
        onKeyDown: N(e.onKeyDown, (i) => {
          if (["Home", "End", ...oi].includes(i.key)) {
            let d = r().map((p) => p.ref.current);
            if ([a.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(i.key) && d.reverse(), oi.includes(i.key)) {
              const p = d.indexOf(i.currentTarget);
              d = d.slice(p + 1);
            }
            setTimeout(() => es(d)), i.preventDefault();
          }
        })
      }
    ) });
  }
);
function Tr(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function es(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function rM(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function Ar(e, t) {
  const n = q(t);
  oe(() => {
    let o = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(o), r.unobserve(e);
      };
    }
  }, [e, n]);
}
function ts(e) {
  return e ? "open" : "closed";
}
function Tu(e, t) {
  return `${e}-trigger-${t}`;
}
function Au(e, t) {
  return `${e}-content-${t}`;
}
function to(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var aM = vu, sM = bu, iM = xu, cM = Cu, lM = Su, dM = Eu, uM = Mu, fM = Nu;
function E0({
  className: e,
  children: t,
  viewport: n = !0,
  ...o
}) {
  return /* @__PURE__ */ z(
    aM,
    {
      "data-slot": "navigation-menu",
      "data-viewport": n,
      className: C(
        "group/navigation-menu relative flex max-w-max flex-1 items-center justify-center",
        e
      ),
      ...o,
      children: [
        t,
        n && /* @__PURE__ */ c(mM, {})
      ]
    }
  );
}
function M0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    sM,
    {
      "data-slot": "navigation-menu-list",
      className: C(
        "group flex flex-1 list-none items-center justify-center gap-1",
        e
      ),
      ...t
    }
  );
}
function R0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    iM,
    {
      "data-slot": "navigation-menu-item",
      className: C("relative", e),
      ...t
    }
  );
}
const pM = et(
  "group inline-flex h-9 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=open]:hover:bg-accent data-[state=open]:text-accent-foreground data-[state=open]:focus:bg-accent data-[state=open]:bg-accent/50 focus-visible:ring-ring/50 outline-none transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1"
);
function N0({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ z(
    cM,
    {
      "data-slot": "navigation-menu-trigger",
      className: C(pM(), "group", e),
      ...n,
      children: [
        t,
        " ",
        /* @__PURE__ */ c(
          ln,
          {
            className: "relative top-[1px] ml-1 size-3 transition duration-300 group-data-[state=open]:rotate-180",
            "aria-hidden": "true"
          }
        )
      ]
    }
  );
}
function P0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    uM,
    {
      "data-slot": "navigation-menu-content",
      className: C(
        "data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 top-0 left-0 w-full p-2 pr-2.5 md:absolute md:w-auto",
        "group-data-[viewport=false]/navigation-menu:bg-popover group-data-[viewport=false]/navigation-menu:text-popover-foreground group-data-[viewport=false]/navigation-menu:data-[state=open]:animate-in group-data-[viewport=false]/navigation-menu:data-[state=closed]:animate-out group-data-[viewport=false]/navigation-menu:data-[state=closed]:zoom-out-95 group-data-[viewport=false]/navigation-menu:data-[state=open]:zoom-in-95 group-data-[viewport=false]/navigation-menu:data-[state=open]:fade-in-0 group-data-[viewport=false]/navigation-menu:data-[state=closed]:fade-out-0 group-data-[viewport=false]/navigation-menu:top-full group-data-[viewport=false]/navigation-menu:mt-1.5 group-data-[viewport=false]/navigation-menu:overflow-hidden group-data-[viewport=false]/navigation-menu:rounded-md group-data-[viewport=false]/navigation-menu:border group-data-[viewport=false]/navigation-menu:shadow group-data-[viewport=false]/navigation-menu:duration-200 **:data-[slot=navigation-menu-link]:focus:ring-0 **:data-[slot=navigation-menu-link]:focus:outline-none",
        e
      ),
      ...t
    }
  );
}
function mM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      className: C(
        "absolute top-full left-0 isolate z-50 flex justify-center"
      ),
      children: /* @__PURE__ */ c(
        fM,
        {
          "data-slot": "navigation-menu-viewport",
          className: C(
            "origin-top-center bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border shadow md:w-[var(--radix-navigation-menu-viewport-width)]",
            e
          ),
          ...t
        }
      )
    }
  );
}
function _0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    lM,
    {
      "data-slot": "navigation-menu-link",
      className: C(
        "data-[active=true]:focus:bg-accent data-[active=true]:hover:bg-accent data-[active=true]:bg-accent/50 data-[active=true]:text-accent-foreground hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus-visible:ring-ring/50 [&_svg:not([class*='text-'])]:text-muted-foreground flex flex-col gap-1 rounded-sm p-2 text-sm transition-all outline-none focus-visible:ring-[3px] focus-visible:outline-1 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function T0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    dM,
    {
      "data-slot": "navigation-menu-indicator",
      className: C(
        "data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden",
        e
      ),
      ...t,
      children: /* @__PURE__ */ c("div", { className: "bg-border relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm shadow-md" })
    }
  );
}
function A0({
  currentPage: e,
  pageCount: t,
  onPageChange: n
}) {
  const o = e > 0, r = e < t - 1, a = e + 1, s = (() => {
    const d = [];
    if (t <= 5)
      for (let u = 1; u <= t; u++)
        d.push(u);
    else {
      let u = Math.max(1, a - 2), p = Math.min(t, a + 2);
      a <= 3 ? p = Math.min(t, 5) : a >= t - 2 && (u = Math.max(1, t - 4));
      for (let m = u; m <= p; m++)
        d.push(m);
    }
    return d;
  })();
  return /* @__PURE__ */ z("div", { className: "flex items-center justify-center space-x-1 py-4", children: [
    /* @__PURE__ */ z(
      Ze,
      {
        variant: "outline",
        className: "h-10 w-10 cursor-pointer rounded-lg border-gray-300 p-0 hover:bg-gray-50",
        onClick: () => n(e - 1),
        disabled: !o,
        children: [
          /* @__PURE__ */ c("span", { className: "sr-only", children: "الصفحة السابقة" }),
          /* @__PURE__ */ c(mi, { className: "h-4 w-4" })
        ]
      }
    ),
    s.map((d) => /* @__PURE__ */ c(
      Ze,
      {
        variant: d === a ? "default" : "outline",
        className: `h-10 w-10 cursor-pointer rounded-lg p-0 ${d === a ? "border-green-500 bg-green-500 text-white hover:bg-green-600" : "border-gray-300 text-gray-700 hover:bg-gray-50"}`,
        onClick: () => n(d - 1),
        children: d
      },
      d
    )),
    /* @__PURE__ */ z(
      Ze,
      {
        variant: "outline",
        className: "h-10 w-10 cursor-pointer rounded-lg border-gray-300 p-0 hover:bg-gray-50",
        onClick: () => n(e + 1),
        disabled: !r,
        children: [
          /* @__PURE__ */ c("span", { className: "sr-only", children: "الصفحة التالية" }),
          /* @__PURE__ */ c($m, { className: "h-4 w-4" })
        ]
      }
    )
  ] });
}
var Ao = "Popover", [Du, D0] = Q(Ao, [
  Ue
]), Pn = Ue(), [vM, pt] = Du(Ao), Iu = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    modal: i = !1
  } = e, s = Pn(t), d = l.useRef(null), [f, u] = l.useState(!1), [p, m] = ne({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: Ao
  });
  return /* @__PURE__ */ c(zt, { ...s, children: /* @__PURE__ */ c(
    vM,
    {
      scope: t,
      contentId: le(),
      triggerRef: d,
      open: p,
      onOpenChange: m,
      onOpenToggle: l.useCallback(() => m((h) => !h), [m]),
      hasCustomAnchor: f,
      onCustomAnchorAdd: l.useCallback(() => u(!0), []),
      onCustomAnchorRemove: l.useCallback(() => u(!1), []),
      modal: i,
      children: n
    }
  ) });
};
Iu.displayName = Ao;
var Ou = "PopoverAnchor", ku = l.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = pt(Ou, n), a = Pn(n), { onCustomAnchorAdd: i, onCustomAnchorRemove: s } = r;
    return l.useEffect(() => (i(), () => s()), [i, s]), /* @__PURE__ */ c(Bt, { ...a, ...o, ref: t });
  }
);
ku.displayName = Ou;
var $u = "PopoverTrigger", Lu = l.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = pt($u, n), a = Pn(n), i = W(t, r.triggerRef), s = /* @__PURE__ */ c(
      A.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": Vu(r.open),
        ...o,
        ref: i,
        onClick: N(e.onClick, r.onOpenToggle)
      }
    );
    return r.hasCustomAnchor ? s : /* @__PURE__ */ c(Bt, { asChild: !0, ...a, children: s });
  }
);
Lu.displayName = $u;
var ns = "PopoverPortal", [hM, gM] = Du(ns, {
  forceMount: void 0
}), Fu = (e) => {
  const { __scopePopover: t, forceMount: n, children: o, container: r } = e, a = pt(ns, t);
  return /* @__PURE__ */ c(hM, { scope: t, forceMount: n, children: /* @__PURE__ */ c(ee, { present: n || a.open, children: /* @__PURE__ */ c(ut, { asChild: !0, container: r, children: o }) }) });
};
Fu.displayName = ns;
var It = "PopoverContent", Wu = l.forwardRef(
  (e, t) => {
    const n = gM(It, e.__scopePopover), { forceMount: o = n.forceMount, ...r } = e, a = pt(It, e.__scopePopover);
    return /* @__PURE__ */ c(ee, { present: o || a.open, children: a.modal ? /* @__PURE__ */ c(wM, { ...r, ref: t }) : /* @__PURE__ */ c(yM, { ...r, ref: t }) });
  }
);
Wu.displayName = It;
var bM = /* @__PURE__ */ it("PopoverContent.RemoveScroll"), wM = l.forwardRef(
  (e, t) => {
    const n = pt(It, e.__scopePopover), o = l.useRef(null), r = W(t, o), a = l.useRef(!1);
    return l.useEffect(() => {
      const i = o.current;
      if (i) return vo(i);
    }, []), /* @__PURE__ */ c(pn, { as: bM, allowPinchZoom: !0, children: /* @__PURE__ */ c(
      zu,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: N(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), a.current || n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: N(
          e.onPointerDownOutside,
          (i) => {
            const s = i.detail.originalEvent, d = s.button === 0 && s.ctrlKey === !0, f = s.button === 2 || d;
            a.current = f;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: N(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), yM = l.forwardRef(
  (e, t) => {
    const n = pt(It, e.__scopePopover), o = l.useRef(!1), r = l.useRef(!1);
    return /* @__PURE__ */ c(
      zu,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          e.onCloseAutoFocus?.(a), a.defaultPrevented || (o.current || n.triggerRef.current?.focus(), a.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          e.onInteractOutside?.(a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = a.target;
          n.triggerRef.current?.contains(i) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), zu = l.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: o,
      onOpenAutoFocus: r,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: d,
      onFocusOutside: f,
      onInteractOutside: u,
      ...p
    } = e, m = pt(It, n), h = Pn(n);
    return po(), /* @__PURE__ */ c(
      fn,
      {
        asChild: !0,
        loop: !0,
        trapped: o,
        onMountAutoFocus: r,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ c(
          nt,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: u,
            onEscapeKeyDown: s,
            onPointerDownOutside: d,
            onFocusOutside: f,
            onDismiss: () => m.onOpenChange(!1),
            children: /* @__PURE__ */ c(
              bn,
              {
                "data-state": Vu(m.open),
                role: "dialog",
                id: m.contentId,
                ...h,
                ...p,
                ref: t,
                style: {
                  ...p.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Bu = "PopoverClose", xM = l.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = pt(Bu, n);
    return /* @__PURE__ */ c(
      A.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: N(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
xM.displayName = Bu;
var CM = "PopoverArrow", SM = l.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = Pn(n);
    return /* @__PURE__ */ c(wn, { ...r, ...o, ref: t });
  }
);
SM.displayName = CM;
function Vu(e) {
  return e ? "open" : "closed";
}
var EM = Iu, MM = ku, RM = Lu, NM = Fu, PM = Wu;
function I0({
  ...e
}) {
  return /* @__PURE__ */ c(EM, { "data-slot": "popover", ...e });
}
function O0({
  ...e
}) {
  return /* @__PURE__ */ c(RM, { "data-slot": "popover-trigger", ...e });
}
function k0({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ...o
}) {
  return /* @__PURE__ */ c(NM, { children: /* @__PURE__ */ c(
    PM,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: n,
      className: C(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden",
        e
      ),
      ...o
    }
  ) });
}
function $0({
  ...e
}) {
  return /* @__PURE__ */ c(MM, { "data-slot": "popover-anchor", ...e });
}
var os = "Progress", rs = 100, [_M, L0] = Q(os), [TM, AM] = _M(os), Hu = l.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: o = null,
      max: r,
      getValueLabel: a = DM,
      ...i
    } = e;
    (r || r === 0) && !ri(r) && console.error(IM(`${r}`, "Progress"));
    const s = ri(r) ? r : rs;
    o !== null && !ai(o, s) && console.error(OM(`${o}`, "Progress"));
    const d = ai(o, s) ? o : null, f = no(d) ? a(d, s) : void 0;
    return /* @__PURE__ */ c(TM, { scope: n, value: d, max: s, children: /* @__PURE__ */ c(
      A.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": no(d) ? d : void 0,
        "aria-valuetext": f,
        role: "progressbar",
        "data-state": Uu(d, s),
        "data-value": d ?? void 0,
        "data-max": s,
        ...i,
        ref: t
      }
    ) });
  }
);
Hu.displayName = os;
var Gu = "ProgressIndicator", Ku = l.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...o } = e, r = AM(Gu, n);
    return /* @__PURE__ */ c(
      A.div,
      {
        "data-state": Uu(r.value, r.max),
        "data-value": r.value ?? void 0,
        "data-max": r.max,
        ...o,
        ref: t
      }
    );
  }
);
Ku.displayName = Gu;
function DM(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function Uu(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function no(e) {
  return typeof e == "number";
}
function ri(e) {
  return no(e) && !isNaN(e) && e > 0;
}
function ai(e, t) {
  return no(e) && !isNaN(e) && e <= t && e >= 0;
}
function IM(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${rs}\`.`;
}
function OM(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${rs} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var kM = Hu, $M = Ku;
function F0({
  className: e,
  value: t,
  ...n
}) {
  return /* @__PURE__ */ c(
    kM,
    {
      "data-slot": "progress",
      className: C(
        "bg-primary/20 relative h-2 w-full overflow-hidden rounded-full",
        e
      ),
      ...n,
      children: /* @__PURE__ */ c(
        $M,
        {
          "data-slot": "progress-indicator",
          className: "bg-primary h-full w-full flex-1 transition-all",
          style: { transform: `translateX(-${100 - (t || 0)}%)` }
        }
      )
    }
  );
}
var as = "Radio", [LM, Yu] = Q(as), [FM, WM] = LM(as), ju = l.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: o,
      checked: r = !1,
      required: a,
      disabled: i,
      value: s = "on",
      onCheck: d,
      form: f,
      ...u
    } = e, [p, m] = l.useState(null), h = W(t, (b) => m(b)), g = l.useRef(!1), v = p ? f || !!p.closest("form") : !0;
    return /* @__PURE__ */ z(FM, { scope: n, checked: r, disabled: i, children: [
      /* @__PURE__ */ c(
        A.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": r,
          "data-state": Ju(r),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...u,
          ref: h,
          onClick: N(e.onClick, (b) => {
            r || d?.(), v && (g.current = b.isPropagationStopped(), g.current || b.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ c(
        Zu,
        {
          control: p,
          bubbles: !g.current,
          name: o,
          value: s,
          checked: r,
          required: a,
          disabled: i,
          form: f,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
ju.displayName = as;
var Xu = "RadioIndicator", qu = l.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: o, ...r } = e, a = WM(Xu, n);
    return /* @__PURE__ */ c(ee, { present: o || a.checked, children: /* @__PURE__ */ c(
      A.span,
      {
        "data-state": Ju(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    ) });
  }
);
qu.displayName = Xu;
var zM = "RadioBubbleInput", Zu = l.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: n,
    bubbles: o = !0,
    ...r
  }, a) => {
    const i = l.useRef(null), s = W(i, a), d = Lt(n), f = hn(t);
    return l.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const p = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        p,
        "checked"
      ).set;
      if (d !== n && h) {
        const g = new Event("click", { bubbles: o });
        h.call(u, n), u.dispatchEvent(g);
      }
    }, [d, n, o]), /* @__PURE__ */ c(
      A.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: n,
        ...r,
        tabIndex: -1,
        ref: s,
        style: {
          ...r.style,
          ...f,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Zu.displayName = zM;
function Ju(e) {
  return e ? "checked" : "unchecked";
}
var BM = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Do = "RadioGroup", [VM, W0] = Q(Do, [
  Ye,
  Yu
]), Qu = Ye(), ef = Yu(), [HM, GM] = VM(Do), tf = l.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: o,
      defaultValue: r,
      value: a,
      required: i = !1,
      disabled: s = !1,
      orientation: d,
      dir: f,
      loop: u = !0,
      onValueChange: p,
      ...m
    } = e, h = Qu(n), g = Oe(f), [v, b] = ne({
      prop: a,
      defaultProp: r ?? null,
      onChange: p,
      caller: Do
    });
    return /* @__PURE__ */ c(
      HM,
      {
        scope: n,
        name: o,
        required: i,
        disabled: s,
        value: v,
        onValueChange: b,
        children: /* @__PURE__ */ c(
          xn,
          {
            asChild: !0,
            ...h,
            orientation: d,
            dir: g,
            loop: u,
            children: /* @__PURE__ */ c(
              A.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": d,
                "data-disabled": s ? "" : void 0,
                dir: g,
                ...m,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
tf.displayName = Do;
var nf = "RadioGroupItem", of = l.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: o, ...r } = e, a = GM(nf, n), i = a.disabled || o, s = Qu(n), d = ef(n), f = l.useRef(null), u = W(t, f), p = a.value === r.value, m = l.useRef(!1);
    return l.useEffect(() => {
      const h = (v) => {
        BM.includes(v.key) && (m.current = !0);
      }, g = () => m.current = !1;
      return document.addEventListener("keydown", h), document.addEventListener("keyup", g), () => {
        document.removeEventListener("keydown", h), document.removeEventListener("keyup", g);
      };
    }, []), /* @__PURE__ */ c(
      Cn,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: p,
        children: /* @__PURE__ */ c(
          ju,
          {
            disabled: i,
            required: a.required,
            checked: p,
            ...d,
            ...r,
            name: a.name,
            ref: u,
            onCheck: () => a.onValueChange(r.value),
            onKeyDown: N((h) => {
              h.key === "Enter" && h.preventDefault();
            }),
            onFocus: N(r.onFocus, () => {
              m.current && f.current?.click();
            })
          }
        )
      }
    );
  }
);
of.displayName = nf;
var KM = "RadioGroupIndicator", rf = l.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...o } = e, r = ef(n);
    return /* @__PURE__ */ c(qu, { ...r, ...o, ref: t });
  }
);
rf.displayName = KM;
var UM = tf, YM = of, jM = rf;
function z0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    UM,
    {
      "data-slot": "radio-group",
      className: C("grid gap-3", e),
      ...t
    }
  );
}
function B0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    YM,
    {
      "data-slot": "radio-group-item",
      className: C(
        "border-input text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square size-4 shrink-0 rounded-full border shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t,
      children: /* @__PURE__ */ c(
        jM,
        {
          "data-slot": "radio-group-indicator",
          className: "relative flex items-center justify-center",
          children: /* @__PURE__ */ c(co, { className: "fill-primary absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2" })
        }
      )
    }
  );
}
function V0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Kr.PanelGroup,
    {
      "data-slot": "resizable-panel-group",
      className: C(
        "flex h-full w-full data-[panel-group-direction=vertical]:flex-col",
        e
      ),
      ...t
    }
  );
}
function H0({
  ...e
}) {
  return /* @__PURE__ */ c(Kr.Panel, { "data-slot": "resizable-panel", ...e });
}
function G0({
  withHandle: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ c(
    Kr.PanelResizeHandle,
    {
      "data-slot": "resizable-handle",
      className: C(
        "bg-border focus-visible:ring-ring relative flex w-px items-center justify-center after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:ring-1 focus-visible:ring-offset-1 focus-visible:outline-hidden data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:translate-x-0 data-[panel-group-direction=vertical]:after:-translate-y-1/2 [&[data-panel-group-direction=vertical]>div]:rotate-90",
        t
      ),
      ...n,
      children: e && /* @__PURE__ */ c("div", { className: "bg-border z-10 flex h-4 w-3 items-center justify-center rounded-xs border", children: /* @__PURE__ */ c(Lm, { className: "size-2.5" }) })
    }
  );
}
function an(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function XM(e, t) {
  return l.useReducer((n, o) => t[n][o] ?? n, e);
}
var ss = "ScrollArea", [af, K0] = Q(ss), [qM, _e] = af(ss), sf = l.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: o = "hover",
      dir: r,
      scrollHideDelay: a = 600,
      ...i
    } = e, [s, d] = l.useState(null), [f, u] = l.useState(null), [p, m] = l.useState(null), [h, g] = l.useState(null), [v, b] = l.useState(null), [w, y] = l.useState(0), [x, E] = l.useState(0), [S, R] = l.useState(!1), [M, P] = l.useState(!1), T = W(t, (O) => d(O)), D = Oe(r);
    return /* @__PURE__ */ c(
      qM,
      {
        scope: n,
        type: o,
        dir: D,
        scrollHideDelay: a,
        scrollArea: s,
        viewport: f,
        onViewportChange: u,
        content: p,
        onContentChange: m,
        scrollbarX: h,
        onScrollbarXChange: g,
        scrollbarXEnabled: S,
        onScrollbarXEnabledChange: R,
        scrollbarY: v,
        onScrollbarYChange: b,
        scrollbarYEnabled: M,
        onScrollbarYEnabledChange: P,
        onCornerWidthChange: y,
        onCornerHeightChange: E,
        children: /* @__PURE__ */ c(
          A.div,
          {
            dir: D,
            ...i,
            ref: T,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": x + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
sf.displayName = ss;
var cf = "ScrollAreaViewport", lf = l.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: o, nonce: r, ...a } = e, i = _e(cf, n), s = l.useRef(null), d = W(t, s, i.onViewportChange);
    return /* @__PURE__ */ z(Se, { children: [
      /* @__PURE__ */ c(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ c(
        A.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...a,
          ref: d,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ c("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
lf.displayName = cf;
var je = "ScrollAreaScrollbar", df = l.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = _e(je, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: i } = r, s = e.orientation === "horizontal";
    return l.useEffect(() => (s ? a(!0) : i(!0), () => {
      s ? a(!1) : i(!1);
    }), [s, a, i]), r.type === "hover" ? /* @__PURE__ */ c(ZM, { ...o, ref: t, forceMount: n }) : r.type === "scroll" ? /* @__PURE__ */ c(JM, { ...o, ref: t, forceMount: n }) : r.type === "auto" ? /* @__PURE__ */ c(uf, { ...o, ref: t, forceMount: n }) : r.type === "always" ? /* @__PURE__ */ c(is, { ...o, ref: t }) : null;
  }
);
df.displayName = je;
var ZM = l.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = _e(je, e.__scopeScrollArea), [a, i] = l.useState(!1);
  return l.useEffect(() => {
    const s = r.scrollArea;
    let d = 0;
    if (s) {
      const f = () => {
        window.clearTimeout(d), i(!0);
      }, u = () => {
        d = window.setTimeout(() => i(!1), r.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", f), s.addEventListener("pointerleave", u), () => {
        window.clearTimeout(d), s.removeEventListener("pointerenter", f), s.removeEventListener("pointerleave", u);
      };
    }
  }, [r.scrollArea, r.scrollHideDelay]), /* @__PURE__ */ c(ee, { present: n || a, children: /* @__PURE__ */ c(
    uf,
    {
      "data-state": a ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), JM = l.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = _e(je, e.__scopeScrollArea), a = e.orientation === "horizontal", i = Oo(() => d("SCROLL_END"), 100), [s, d] = XM("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return l.useEffect(() => {
    if (s === "idle") {
      const f = window.setTimeout(() => d("HIDE"), r.scrollHideDelay);
      return () => window.clearTimeout(f);
    }
  }, [s, r.scrollHideDelay, d]), l.useEffect(() => {
    const f = r.viewport, u = a ? "scrollLeft" : "scrollTop";
    if (f) {
      let p = f[u];
      const m = () => {
        const h = f[u];
        p !== h && (d("SCROLL"), i()), p = h;
      };
      return f.addEventListener("scroll", m), () => f.removeEventListener("scroll", m);
    }
  }, [r.viewport, a, d, i]), /* @__PURE__ */ c(ee, { present: n || s !== "hidden", children: /* @__PURE__ */ c(
    is,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: N(e.onPointerEnter, () => d("POINTER_ENTER")),
      onPointerLeave: N(e.onPointerLeave, () => d("POINTER_LEAVE"))
    }
  ) });
}), uf = l.forwardRef((e, t) => {
  const n = _e(je, e.__scopeScrollArea), { forceMount: o, ...r } = e, [a, i] = l.useState(!1), s = e.orientation === "horizontal", d = Oo(() => {
    if (n.viewport) {
      const f = n.viewport.offsetWidth < n.viewport.scrollWidth, u = n.viewport.offsetHeight < n.viewport.scrollHeight;
      i(s ? f : u);
    }
  }, 10);
  return Ot(n.viewport, d), Ot(n.content, d), /* @__PURE__ */ c(ee, { present: o || a, children: /* @__PURE__ */ c(
    is,
    {
      "data-state": a ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), is = l.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...o } = e, r = _e(je, e.__scopeScrollArea), a = l.useRef(null), i = l.useRef(0), [s, d] = l.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), f = hf(s.viewport, s.content), u = {
    ...o,
    sizes: s,
    onSizesChange: d,
    hasThumb: f > 0 && f < 1,
    onThumbChange: (m) => a.current = m,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (m) => i.current = m
  };
  function p(m, h) {
    return rR(m, i.current, s, h);
  }
  return n === "horizontal" ? /* @__PURE__ */ c(
    QM,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && a.current) {
          const m = r.viewport.scrollLeft, h = si(m, s, r.dir);
          a.current.style.transform = `translate3d(${h}px, 0, 0)`;
        }
      },
      onWheelScroll: (m) => {
        r.viewport && (r.viewport.scrollLeft = m);
      },
      onDragScroll: (m) => {
        r.viewport && (r.viewport.scrollLeft = p(m, r.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ c(
    eR,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && a.current) {
          const m = r.viewport.scrollTop, h = si(m, s);
          a.current.style.transform = `translate3d(0, ${h}px, 0)`;
        }
      },
      onWheelScroll: (m) => {
        r.viewport && (r.viewport.scrollTop = m);
      },
      onDragScroll: (m) => {
        r.viewport && (r.viewport.scrollTop = p(m));
      }
    }
  ) : null;
}), QM = l.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...r } = e, a = _e(je, e.__scopeScrollArea), [i, s] = l.useState(), d = l.useRef(null), f = W(t, d, a.onScrollbarXChange);
  return l.useEffect(() => {
    d.current && s(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ c(
    pf,
    {
      "data-orientation": "horizontal",
      ...r,
      ref: f,
      sizes: n,
      style: {
        bottom: 0,
        left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Io(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, p) => {
        if (a.viewport) {
          const m = a.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(m), bf(m, p) && u.preventDefault();
        }
      },
      onResize: () => {
        d.current && a.viewport && i && o({
          content: a.viewport.scrollWidth,
          viewport: a.viewport.offsetWidth,
          scrollbar: {
            size: d.current.clientWidth,
            paddingStart: ro(i.paddingLeft),
            paddingEnd: ro(i.paddingRight)
          }
        });
      }
    }
  );
}), eR = l.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...r } = e, a = _e(je, e.__scopeScrollArea), [i, s] = l.useState(), d = l.useRef(null), f = W(t, d, a.onScrollbarYChange);
  return l.useEffect(() => {
    d.current && s(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ c(
    pf,
    {
      "data-orientation": "vertical",
      ...r,
      ref: f,
      sizes: n,
      style: {
        top: 0,
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Io(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, p) => {
        if (a.viewport) {
          const m = a.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(m), bf(m, p) && u.preventDefault();
        }
      },
      onResize: () => {
        d.current && a.viewport && i && o({
          content: a.viewport.scrollHeight,
          viewport: a.viewport.offsetHeight,
          scrollbar: {
            size: d.current.clientHeight,
            paddingStart: ro(i.paddingTop),
            paddingEnd: ro(i.paddingBottom)
          }
        });
      }
    }
  );
}), [tR, ff] = af(je), pf = l.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: o,
    hasThumb: r,
    onThumbChange: a,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: d,
    onDragScroll: f,
    onWheelScroll: u,
    onResize: p,
    ...m
  } = e, h = _e(je, n), [g, v] = l.useState(null), b = W(t, (T) => v(T)), w = l.useRef(null), y = l.useRef(""), x = h.viewport, E = o.content - o.viewport, S = q(u), R = q(d), M = Oo(p, 10);
  function P(T) {
    if (w.current) {
      const D = T.clientX - w.current.left, O = T.clientY - w.current.top;
      f({ x: D, y: O });
    }
  }
  return l.useEffect(() => {
    const T = (D) => {
      const O = D.target;
      g?.contains(O) && S(D, E);
    };
    return document.addEventListener("wheel", T, { passive: !1 }), () => document.removeEventListener("wheel", T, { passive: !1 });
  }, [x, g, E, S]), l.useEffect(R, [o, R]), Ot(g, M), Ot(h.content, M), /* @__PURE__ */ c(
    tR,
    {
      scope: n,
      scrollbar: g,
      hasThumb: r,
      onThumbChange: q(a),
      onThumbPointerUp: q(i),
      onThumbPositionChange: R,
      onThumbPointerDown: q(s),
      children: /* @__PURE__ */ c(
        A.div,
        {
          ...m,
          ref: b,
          style: { position: "absolute", ...m.style },
          onPointerDown: N(e.onPointerDown, (T) => {
            T.button === 0 && (T.target.setPointerCapture(T.pointerId), w.current = g.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), P(T));
          }),
          onPointerMove: N(e.onPointerMove, P),
          onPointerUp: N(e.onPointerUp, (T) => {
            const D = T.target;
            D.hasPointerCapture(T.pointerId) && D.releasePointerCapture(T.pointerId), document.body.style.webkitUserSelect = y.current, h.viewport && (h.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), oo = "ScrollAreaThumb", mf = l.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = ff(oo, e.__scopeScrollArea);
    return /* @__PURE__ */ c(ee, { present: n || r.hasThumb, children: /* @__PURE__ */ c(nR, { ref: t, ...o }) });
  }
), nR = l.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: o, ...r } = e, a = _e(oo, n), i = ff(oo, n), { onThumbPositionChange: s } = i, d = W(
      t,
      (p) => i.onThumbChange(p)
    ), f = l.useRef(void 0), u = Oo(() => {
      f.current && (f.current(), f.current = void 0);
    }, 100);
    return l.useEffect(() => {
      const p = a.viewport;
      if (p) {
        const m = () => {
          if (u(), !f.current) {
            const h = aR(p, s);
            f.current = h, s();
          }
        };
        return s(), p.addEventListener("scroll", m), () => p.removeEventListener("scroll", m);
      }
    }, [a.viewport, u, s]), /* @__PURE__ */ c(
      A.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...r,
        ref: d,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: N(e.onPointerDownCapture, (p) => {
          const h = p.target.getBoundingClientRect(), g = p.clientX - h.left, v = p.clientY - h.top;
          i.onThumbPointerDown({ x: g, y: v });
        }),
        onPointerUp: N(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
mf.displayName = oo;
var cs = "ScrollAreaCorner", vf = l.forwardRef(
  (e, t) => {
    const n = _e(cs, e.__scopeScrollArea), o = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && o ? /* @__PURE__ */ c(oR, { ...e, ref: t }) : null;
  }
);
vf.displayName = cs;
var oR = l.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...o } = e, r = _e(cs, n), [a, i] = l.useState(0), [s, d] = l.useState(0), f = !!(a && s);
  return Ot(r.scrollbarX, () => {
    const u = r.scrollbarX?.offsetHeight || 0;
    r.onCornerHeightChange(u), d(u);
  }), Ot(r.scrollbarY, () => {
    const u = r.scrollbarY?.offsetWidth || 0;
    r.onCornerWidthChange(u), i(u);
  }), f ? /* @__PURE__ */ c(
    A.div,
    {
      ...o,
      ref: t,
      style: {
        width: a,
        height: s,
        position: "absolute",
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function ro(e) {
  return e ? parseInt(e, 10) : 0;
}
function hf(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Io(e) {
  const t = hf(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - n) * t;
  return Math.max(o, 18);
}
function rR(e, t, n, o = "ltr") {
  const r = Io(n), a = r / 2, i = t || a, s = r - i, d = n.scrollbar.paddingStart + i, f = n.scrollbar.size - n.scrollbar.paddingEnd - s, u = n.content - n.viewport, p = o === "ltr" ? [0, u] : [u * -1, 0];
  return gf([d, f], p)(e);
}
function si(e, t, n = "ltr") {
  const o = Io(t), r = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - r, i = t.content - t.viewport, s = a - o, d = n === "ltr" ? [0, i] : [i * -1, 0], f = an(e, d);
  return gf([0, i], [0, s])(f);
}
function gf(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function bf(e, t) {
  return e > 0 && e < t;
}
var aR = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return (function r() {
    const a = { left: e.scrollLeft, top: e.scrollTop }, i = n.left !== a.left, s = n.top !== a.top;
    (i || s) && t(), n = a, o = window.requestAnimationFrame(r);
  })(), () => window.cancelAnimationFrame(o);
};
function Oo(e, t) {
  const n = q(e), o = l.useRef(0);
  return l.useEffect(() => () => window.clearTimeout(o.current), []), l.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(n, t);
  }, [n, t]);
}
function Ot(e, t) {
  const n = q(t);
  oe(() => {
    let o = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(o), r.unobserve(e);
      };
    }
  }, [e, n]);
}
var sR = sf, iR = lf, cR = vf;
function U0({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ z(
    sR,
    {
      "data-slot": "scroll-area",
      className: C("relative", e),
      ...n,
      children: [
        /* @__PURE__ */ c(
          iR,
          {
            "data-slot": "scroll-area-viewport",
            className: "focus-visible:ring-ring/50 size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:outline-1",
            children: t
          }
        ),
        /* @__PURE__ */ c(lR, {}),
        /* @__PURE__ */ c(cR, {})
      ]
    }
  );
}
function lR({
  className: e,
  orientation: t = "vertical",
  ...n
}) {
  return /* @__PURE__ */ c(
    df,
    {
      "data-slot": "scroll-area-scrollbar",
      orientation: t,
      className: C(
        "flex touch-none p-px transition-colors select-none",
        t === "vertical" && "h-full w-2.5 border-l border-l-transparent",
        t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent",
        e
      ),
      ...n,
      children: /* @__PURE__ */ c(
        mf,
        {
          "data-slot": "scroll-area-thumb",
          className: "bg-border relative flex-1 rounded-full"
        }
      )
    }
  );
}
var dR = [" ", "Enter", "ArrowUp", "ArrowDown"], uR = [" ", "Enter"], yt = "Select", [ko, $o, fR] = tt(yt), [Vt, Y0] = Q(yt, [
  fR,
  Ue
]), Lo = Ue(), [pR, mt] = Vt(yt), [mR, vR] = Vt(yt), wf = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    value: i,
    defaultValue: s,
    onValueChange: d,
    dir: f,
    name: u,
    autoComplete: p,
    disabled: m,
    required: h,
    form: g
  } = e, v = Lo(t), [b, w] = l.useState(null), [y, x] = l.useState(null), [E, S] = l.useState(!1), R = Oe(f), [M, P] = ne({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: yt
  }), [T, D] = ne({
    prop: i,
    defaultProp: s,
    onChange: d,
    caller: yt
  }), O = l.useRef(null), B = b ? g || !!b.closest("form") : !0, [K, k] = l.useState(/* @__PURE__ */ new Set()), G = Array.from(K).map((L) => L.props.value).join(";");
  return /* @__PURE__ */ c(zt, { ...v, children: /* @__PURE__ */ z(
    pR,
    {
      required: h,
      scope: t,
      trigger: b,
      onTriggerChange: w,
      valueNode: y,
      onValueNodeChange: x,
      valueNodeHasChildren: E,
      onValueNodeHasChildrenChange: S,
      contentId: le(),
      value: T,
      onValueChange: D,
      open: M,
      onOpenChange: P,
      dir: R,
      triggerPointerDownPosRef: O,
      disabled: m,
      children: [
        /* @__PURE__ */ c(ko.Provider, { scope: t, children: /* @__PURE__ */ c(
          mR,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: l.useCallback((L) => {
              k((H) => new Set(H).add(L));
            }, []),
            onNativeOptionRemove: l.useCallback((L) => {
              k((H) => {
                const $ = new Set(H);
                return $.delete(L), $;
              });
            }, []),
            children: n
          }
        ) }),
        B ? /* @__PURE__ */ z(
          Gf,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: u,
            autoComplete: p,
            value: T,
            onChange: (L) => D(L.target.value),
            disabled: m,
            form: g,
            children: [
              T === void 0 ? /* @__PURE__ */ c("option", { value: "" }) : null,
              Array.from(K)
            ]
          },
          G
        ) : null
      ]
    }
  ) });
};
wf.displayName = yt;
var yf = "SelectTrigger", xf = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: o = !1, ...r } = e, a = Lo(n), i = mt(yf, n), s = i.disabled || o, d = W(t, i.onTriggerChange), f = $o(n), u = l.useRef("touch"), [p, m, h] = Uf((v) => {
      const b = f().filter((x) => !x.disabled), w = b.find((x) => x.value === i.value), y = Yf(b, v, w);
      y !== void 0 && i.onValueChange(y.value);
    }), g = (v) => {
      s || (i.onOpenChange(!0), h()), v && (i.triggerPointerDownPosRef.current = {
        x: Math.round(v.pageX),
        y: Math.round(v.pageY)
      });
    };
    return /* @__PURE__ */ c(Bt, { asChild: !0, ...a, children: /* @__PURE__ */ c(
      A.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": Kf(i.value) ? "" : void 0,
        ...r,
        ref: d,
        onClick: N(r.onClick, (v) => {
          v.currentTarget.focus(), u.current !== "mouse" && g(v);
        }),
        onPointerDown: N(r.onPointerDown, (v) => {
          u.current = v.pointerType;
          const b = v.target;
          b.hasPointerCapture(v.pointerId) && b.releasePointerCapture(v.pointerId), v.button === 0 && v.ctrlKey === !1 && v.pointerType === "mouse" && (g(v), v.preventDefault());
        }),
        onKeyDown: N(r.onKeyDown, (v) => {
          const b = p.current !== "";
          !(v.ctrlKey || v.altKey || v.metaKey) && v.key.length === 1 && m(v.key), !(b && v.key === " ") && dR.includes(v.key) && (g(), v.preventDefault());
        })
      }
    ) });
  }
);
xf.displayName = yf;
var Cf = "SelectValue", Sf = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, children: a, placeholder: i = "", ...s } = e, d = mt(Cf, n), { onValueNodeHasChildrenChange: f } = d, u = a !== void 0, p = W(t, d.onValueNodeChange);
    return oe(() => {
      f(u);
    }, [f, u]), /* @__PURE__ */ c(
      A.span,
      {
        ...s,
        ref: p,
        style: { pointerEvents: "none" },
        children: Kf(d.value) ? /* @__PURE__ */ c(Se, { children: i }) : a
      }
    );
  }
);
Sf.displayName = Cf;
var hR = "SelectIcon", Ef = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: o, ...r } = e;
    return /* @__PURE__ */ c(A.span, { "aria-hidden": !0, ...r, ref: t, children: o || "▼" });
  }
);
Ef.displayName = hR;
var gR = "SelectPortal", Mf = (e) => /* @__PURE__ */ c(ut, { asChild: !0, ...e });
Mf.displayName = gR;
var xt = "SelectContent", Rf = l.forwardRef(
  (e, t) => {
    const n = mt(xt, e.__scopeSelect), [o, r] = l.useState();
    if (oe(() => {
      r(new DocumentFragment());
    }, []), !n.open) {
      const a = o;
      return a ? cn.createPortal(
        /* @__PURE__ */ c(Nf, { scope: e.__scopeSelect, children: /* @__PURE__ */ c(ko.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ c("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ c(Pf, { ...e, ref: t });
  }
);
Rf.displayName = xt;
var Te = 10, [Nf, vt] = Vt(xt), bR = "SelectContentImpl", wR = /* @__PURE__ */ it("SelectContent.RemoveScroll"), Pf = l.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: o = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: d,
      align: f,
      alignOffset: u,
      arrowPadding: p,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: g,
      hideWhenDetached: v,
      avoidCollisions: b,
      //
      ...w
    } = e, y = mt(xt, n), [x, E] = l.useState(null), [S, R] = l.useState(null), M = W(t, (F) => E(F)), [P, T] = l.useState(null), [D, O] = l.useState(
      null
    ), B = $o(n), [K, k] = l.useState(!1), G = l.useRef(!1);
    l.useEffect(() => {
      if (x) return vo(x);
    }, [x]), po();
    const L = l.useCallback(
      (F) => {
        const [Z, ...ue] = B().map((ie) => ie.ref.current), [J] = ue.slice(-1), te = document.activeElement;
        for (const ie of F)
          if (ie === te || (ie?.scrollIntoView({ block: "nearest" }), ie === Z && S && (S.scrollTop = 0), ie === J && S && (S.scrollTop = S.scrollHeight), ie?.focus(), document.activeElement !== te)) return;
      },
      [B, S]
    ), H = l.useCallback(
      () => L([P, x]),
      [L, P, x]
    );
    l.useEffect(() => {
      K && H();
    }, [K, H]);
    const { onOpenChange: $, triggerPointerDownPosRef: I } = y;
    l.useEffect(() => {
      if (x) {
        let F = { x: 0, y: 0 };
        const Z = (J) => {
          F = {
            x: Math.abs(Math.round(J.pageX) - (I.current?.x ?? 0)),
            y: Math.abs(Math.round(J.pageY) - (I.current?.y ?? 0))
          };
        }, ue = (J) => {
          F.x <= 10 && F.y <= 10 ? J.preventDefault() : x.contains(J.target) || $(!1), document.removeEventListener("pointermove", Z), I.current = null;
        };
        return I.current !== null && (document.addEventListener("pointermove", Z), document.addEventListener("pointerup", ue, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Z), document.removeEventListener("pointerup", ue, { capture: !0 });
        };
      }
    }, [x, $, I]), l.useEffect(() => {
      const F = () => $(!1);
      return window.addEventListener("blur", F), window.addEventListener("resize", F), () => {
        window.removeEventListener("blur", F), window.removeEventListener("resize", F);
      };
    }, [$]);
    const [j, ce] = Uf((F) => {
      const Z = B().filter((te) => !te.disabled), ue = Z.find((te) => te.ref.current === document.activeElement), J = Yf(Z, F, ue);
      J && setTimeout(() => J.ref.current.focus());
    }), fe = l.useCallback(
      (F, Z, ue) => {
        const J = !G.current && !ue;
        (y.value !== void 0 && y.value === Z || J) && (T(F), J && (G.current = !0));
      },
      [y.value]
    ), pe = l.useCallback(() => x?.focus(), [x]), de = l.useCallback(
      (F, Z, ue) => {
        const J = !G.current && !ue;
        (y.value !== void 0 && y.value === Z || J) && O(F);
      },
      [y.value]
    ), Ee = o === "popper" ? Dr : _f, me = Ee === Dr ? {
      side: s,
      sideOffset: d,
      align: f,
      alignOffset: u,
      arrowPadding: p,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: g,
      hideWhenDetached: v,
      avoidCollisions: b
    } : {};
    return /* @__PURE__ */ c(
      Nf,
      {
        scope: n,
        content: x,
        viewport: S,
        onViewportChange: R,
        itemRefCallback: fe,
        selectedItem: P,
        onItemLeave: pe,
        itemTextRefCallback: de,
        focusSelectedItem: H,
        selectedItemText: D,
        position: o,
        isPositioned: K,
        searchRef: j,
        children: /* @__PURE__ */ c(pn, { as: wR, allowPinchZoom: !0, children: /* @__PURE__ */ c(
          fn,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (F) => {
              F.preventDefault();
            },
            onUnmountAutoFocus: N(r, (F) => {
              y.trigger?.focus({ preventScroll: !0 }), F.preventDefault();
            }),
            children: /* @__PURE__ */ c(
              nt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: i,
                onFocusOutside: (F) => F.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ c(
                  Ee,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (F) => F.preventDefault(),
                    ...w,
                    ...me,
                    onPlaced: () => k(!0),
                    ref: M,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: N(w.onKeyDown, (F) => {
                      const Z = F.ctrlKey || F.altKey || F.metaKey;
                      if (F.key === "Tab" && F.preventDefault(), !Z && F.key.length === 1 && ce(F.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(F.key)) {
                        let J = B().filter((te) => !te.disabled).map((te) => te.ref.current);
                        if (["ArrowUp", "End"].includes(F.key) && (J = J.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(F.key)) {
                          const te = F.target, ie = J.indexOf(te);
                          J = J.slice(ie + 1);
                        }
                        setTimeout(() => L(J)), F.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Pf.displayName = bR;
var yR = "SelectItemAlignedPosition", _f = l.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...r } = e, a = mt(xt, n), i = vt(xt, n), [s, d] = l.useState(null), [f, u] = l.useState(null), p = W(t, (M) => u(M)), m = $o(n), h = l.useRef(!1), g = l.useRef(!0), { viewport: v, selectedItem: b, selectedItemText: w, focusSelectedItem: y } = i, x = l.useCallback(() => {
    if (a.trigger && a.valueNode && s && f && v && b && w) {
      const M = a.trigger.getBoundingClientRect(), P = f.getBoundingClientRect(), T = a.valueNode.getBoundingClientRect(), D = w.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const te = D.left - P.left, ie = T.left - te, we = M.left - ie, Le = M.width + we, Gt = Math.max(Le, P.width), Kt = window.innerWidth - Te, Ut = an(ie, [
          Te,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Te, Kt - Gt)
        ]);
        s.style.minWidth = Le + "px", s.style.left = Ut + "px";
      } else {
        const te = P.right - D.right, ie = window.innerWidth - T.right - te, we = window.innerWidth - M.right - ie, Le = M.width + we, Gt = Math.max(Le, P.width), Kt = window.innerWidth - Te, Ut = an(ie, [
          Te,
          Math.max(Te, Kt - Gt)
        ]);
        s.style.minWidth = Le + "px", s.style.right = Ut + "px";
      }
      const O = m(), B = window.innerHeight - Te * 2, K = v.scrollHeight, k = window.getComputedStyle(f), G = parseInt(k.borderTopWidth, 10), L = parseInt(k.paddingTop, 10), H = parseInt(k.borderBottomWidth, 10), $ = parseInt(k.paddingBottom, 10), I = G + L + K + $ + H, j = Math.min(b.offsetHeight * 5, I), ce = window.getComputedStyle(v), fe = parseInt(ce.paddingTop, 10), pe = parseInt(ce.paddingBottom, 10), de = M.top + M.height / 2 - Te, Ee = B - de, me = b.offsetHeight / 2, F = b.offsetTop + me, Z = G + L + F, ue = I - Z;
      if (Z <= de) {
        const te = O.length > 0 && b === O[O.length - 1].ref.current;
        s.style.bottom = "0px";
        const ie = f.clientHeight - v.offsetTop - v.offsetHeight, we = Math.max(
          Ee,
          me + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (te ? pe : 0) + ie + H
        ), Le = Z + we;
        s.style.height = Le + "px";
      } else {
        const te = O.length > 0 && b === O[0].ref.current;
        s.style.top = "0px";
        const we = Math.max(
          de,
          G + v.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (te ? fe : 0) + me
        ) + ue;
        s.style.height = we + "px", v.scrollTop = Z - de + v.offsetTop;
      }
      s.style.margin = `${Te}px 0`, s.style.minHeight = j + "px", s.style.maxHeight = B + "px", o?.(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    m,
    a.trigger,
    a.valueNode,
    s,
    f,
    v,
    b,
    w,
    a.dir,
    o
  ]);
  oe(() => x(), [x]);
  const [E, S] = l.useState();
  oe(() => {
    f && S(window.getComputedStyle(f).zIndex);
  }, [f]);
  const R = l.useCallback(
    (M) => {
      M && g.current === !0 && (x(), y?.(), g.current = !1);
    },
    [x, y]
  );
  return /* @__PURE__ */ c(
    CR,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: R,
      children: /* @__PURE__ */ c(
        "div",
        {
          ref: d,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: E
          },
          children: /* @__PURE__ */ c(
            A.div,
            {
              ...r,
              ref: p,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
_f.displayName = yR;
var xR = "SelectPopperPosition", Dr = l.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: o = "start",
    collisionPadding: r = Te,
    ...a
  } = e, i = Lo(n);
  return /* @__PURE__ */ c(
    bn,
    {
      ...i,
      ...a,
      ref: t,
      align: o,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Dr.displayName = xR;
var [CR, ls] = Vt(xt, {}), Ir = "SelectViewport", Tf = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: o, ...r } = e, a = vt(Ir, n), i = ls(Ir, n), s = W(t, a.onViewportChange), d = l.useRef(0);
    return /* @__PURE__ */ z(Se, { children: [
      /* @__PURE__ */ c(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ c(ko.Slot, { scope: n, children: /* @__PURE__ */ c(
        A.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: N(r.onScroll, (f) => {
            const u = f.currentTarget, { contentWrapper: p, shouldExpandOnScrollRef: m } = i;
            if (m?.current && p) {
              const h = Math.abs(d.current - u.scrollTop);
              if (h > 0) {
                const g = window.innerHeight - Te * 2, v = parseFloat(p.style.minHeight), b = parseFloat(p.style.height), w = Math.max(v, b);
                if (w < g) {
                  const y = w + h, x = Math.min(g, y), E = y - x;
                  p.style.height = x + "px", p.style.bottom === "0px" && (u.scrollTop = E > 0 ? E : 0, p.style.justifyContent = "flex-end");
                }
              }
            }
            d.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Tf.displayName = Ir;
var Af = "SelectGroup", [SR, ER] = Vt(Af), Df = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = le();
    return /* @__PURE__ */ c(SR, { scope: n, id: r, children: /* @__PURE__ */ c(A.div, { role: "group", "aria-labelledby": r, ...o, ref: t }) });
  }
);
Df.displayName = Af;
var If = "SelectLabel", Of = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = ER(If, n);
    return /* @__PURE__ */ c(A.div, { id: r.id, ...o, ref: t });
  }
);
Of.displayName = If;
var ao = "SelectItem", [MR, kf] = Vt(ao), $f = l.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: o,
      disabled: r = !1,
      textValue: a,
      ...i
    } = e, s = mt(ao, n), d = vt(ao, n), f = s.value === o, [u, p] = l.useState(a ?? ""), [m, h] = l.useState(!1), g = W(
      t,
      (y) => d.itemRefCallback?.(y, o, r)
    ), v = le(), b = l.useRef("touch"), w = () => {
      r || (s.onValueChange(o), s.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ c(
      MR,
      {
        scope: n,
        value: o,
        disabled: r,
        textId: v,
        isSelected: f,
        onItemTextChange: l.useCallback((y) => {
          p((x) => x || (y?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ c(
          ko.ItemSlot,
          {
            scope: n,
            value: o,
            disabled: r,
            textValue: u,
            children: /* @__PURE__ */ c(
              A.div,
              {
                role: "option",
                "aria-labelledby": v,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": f && m,
                "data-state": f ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...i,
                ref: g,
                onFocus: N(i.onFocus, () => h(!0)),
                onBlur: N(i.onBlur, () => h(!1)),
                onClick: N(i.onClick, () => {
                  b.current !== "mouse" && w();
                }),
                onPointerUp: N(i.onPointerUp, () => {
                  b.current === "mouse" && w();
                }),
                onPointerDown: N(i.onPointerDown, (y) => {
                  b.current = y.pointerType;
                }),
                onPointerMove: N(i.onPointerMove, (y) => {
                  b.current = y.pointerType, r ? d.onItemLeave?.() : b.current === "mouse" && y.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: N(i.onPointerLeave, (y) => {
                  y.currentTarget === document.activeElement && d.onItemLeave?.();
                }),
                onKeyDown: N(i.onKeyDown, (y) => {
                  d.searchRef?.current !== "" && y.key === " " || (uR.includes(y.key) && w(), y.key === " " && y.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
$f.displayName = ao;
var Zt = "SelectItemText", Lf = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, ...a } = e, i = mt(Zt, n), s = vt(Zt, n), d = kf(Zt, n), f = vR(Zt, n), [u, p] = l.useState(null), m = W(
      t,
      (w) => p(w),
      d.onItemTextChange,
      (w) => s.itemTextRefCallback?.(w, d.value, d.disabled)
    ), h = u?.textContent, g = l.useMemo(
      () => /* @__PURE__ */ c("option", { value: d.value, disabled: d.disabled, children: h }, d.value),
      [d.disabled, d.value, h]
    ), { onNativeOptionAdd: v, onNativeOptionRemove: b } = f;
    return oe(() => (v(g), () => b(g)), [v, b, g]), /* @__PURE__ */ z(Se, { children: [
      /* @__PURE__ */ c(A.span, { id: d.textId, ...a, ref: m }),
      d.isSelected && i.valueNode && !i.valueNodeHasChildren ? cn.createPortal(a.children, i.valueNode) : null
    ] });
  }
);
Lf.displayName = Zt;
var Ff = "SelectItemIndicator", Wf = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return kf(Ff, n).isSelected ? /* @__PURE__ */ c(A.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
Wf.displayName = Ff;
var Or = "SelectScrollUpButton", zf = l.forwardRef((e, t) => {
  const n = vt(Or, e.__scopeSelect), o = ls(Or, e.__scopeSelect), [r, a] = l.useState(!1), i = W(t, o.onScrollButtonChange);
  return oe(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const f = d.scrollTop > 0;
        a(f);
      };
      const d = n.viewport;
      return s(), d.addEventListener("scroll", s), () => d.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ c(
    Vf,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: d } = n;
        s && d && (s.scrollTop = s.scrollTop - d.offsetHeight);
      }
    }
  ) : null;
});
zf.displayName = Or;
var kr = "SelectScrollDownButton", Bf = l.forwardRef((e, t) => {
  const n = vt(kr, e.__scopeSelect), o = ls(kr, e.__scopeSelect), [r, a] = l.useState(!1), i = W(t, o.onScrollButtonChange);
  return oe(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const f = d.scrollHeight - d.clientHeight, u = Math.ceil(d.scrollTop) < f;
        a(u);
      };
      const d = n.viewport;
      return s(), d.addEventListener("scroll", s), () => d.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ c(
    Vf,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: d } = n;
        s && d && (s.scrollTop = s.scrollTop + d.offsetHeight);
      }
    }
  ) : null;
});
Bf.displayName = kr;
var Vf = l.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...r } = e, a = vt("SelectScrollButton", n), i = l.useRef(null), s = $o(n), d = l.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return l.useEffect(() => () => d(), [d]), oe(() => {
    s().find((u) => u.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ c(
    A.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: t,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: N(r.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerMove: N(r.onPointerMove, () => {
        a.onItemLeave?.(), i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerLeave: N(r.onPointerLeave, () => {
        d();
      })
    }
  );
}), RR = "SelectSeparator", Hf = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return /* @__PURE__ */ c(A.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
Hf.displayName = RR;
var $r = "SelectArrow", NR = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Lo(n), a = mt($r, n), i = vt($r, n);
    return a.open && i.position === "popper" ? /* @__PURE__ */ c(wn, { ...r, ...o, ref: t }) : null;
  }
);
NR.displayName = $r;
var PR = "SelectBubbleInput", Gf = l.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, o) => {
    const r = l.useRef(null), a = W(o, r), i = Lt(t);
    return l.useEffect(() => {
      const s = r.current;
      if (!s) return;
      const d = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        d,
        "value"
      ).set;
      if (i !== t && u) {
        const p = new Event("change", { bubbles: !0 });
        u.call(s, t), s.dispatchEvent(p);
      }
    }, [i, t]), /* @__PURE__ */ c(
      A.select,
      {
        ...n,
        style: { ...fu, ...n.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
Gf.displayName = PR;
function Kf(e) {
  return e === "" || e === void 0;
}
function Uf(e) {
  const t = q(e), n = l.useRef(""), o = l.useRef(0), r = l.useCallback(
    (i) => {
      const s = n.current + i;
      t(s), (function d(f) {
        n.current = f, window.clearTimeout(o.current), f !== "" && (o.current = window.setTimeout(() => d(""), 1e3));
      })(s);
    },
    [t]
  ), a = l.useCallback(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return l.useEffect(() => () => window.clearTimeout(o.current), []), [n, r, a];
}
function Yf(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((f) => f === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = _R(e, Math.max(a, 0));
  r.length === 1 && (i = i.filter((f) => f !== n));
  const d = i.find(
    (f) => f.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return d !== n ? d : void 0;
}
function _R(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var TR = wf, AR = xf, DR = Sf, IR = Ef, OR = Mf, kR = Rf, $R = Tf, LR = Df, FR = Of, WR = $f, zR = Lf, BR = Wf, VR = zf, HR = Bf, GR = Hf;
function j0({
  ...e
}) {
  return /* @__PURE__ */ c(TR, { "data-slot": "select", ...e });
}
function X0({
  ...e
}) {
  return /* @__PURE__ */ c(LR, { "data-slot": "select-group", ...e });
}
function q0({
  ...e
}) {
  return /* @__PURE__ */ c(DR, { "data-slot": "select-value", ...e });
}
function Z0({
  className: e,
  size: t = "default",
  children: n,
  ...o
}) {
  const r = o.icon ?? ln;
  return /* @__PURE__ */ z(
    AR,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: C(
        "border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o,
      children: [
        n,
        /* @__PURE__ */ c(IR, { asChild: !0, children: /* @__PURE__ */ c(r, { className: "size-4 text-black" }) })
      ]
    }
  );
}
function J0({
  className: e,
  children: t,
  position: n = "popper",
  ...o
}) {
  return /* @__PURE__ */ c(OR, { children: /* @__PURE__ */ z(
    kR,
    {
      "data-slot": "select-content",
      className: C(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: n,
      ...o,
      children: [
        /* @__PURE__ */ c(KR, {}),
        /* @__PURE__ */ c(
          $R,
          {
            className: C(
              "p-1",
              n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ c(UR, {})
      ]
    }
  ) });
}
function Q0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    FR,
    {
      "data-slot": "select-label",
      className: C("text-muted-foreground px-2 py-1.5 text-xs", e),
      ...t
    }
  );
}
function eA({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ z(
    WR,
    {
      "data-slot": "select-item",
      className: C(
        "focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ c("span", { className: "absolute right-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ c(BR, { children: /* @__PURE__ */ c(dn, { className: "size-4" }) }) }),
        /* @__PURE__ */ c(zR, { children: t })
      ]
    }
  );
}
function tA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    GR,
    {
      "data-slot": "select-separator",
      className: C("bg-border pointer-events-none -mx-1 my-1 h-px", e),
      ...t
    }
  );
}
function KR({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    VR,
    {
      "data-slot": "select-scroll-up-button",
      className: C(
        "flex cursor-default items-center justify-center py-1",
        e
      ),
      ...t,
      children: /* @__PURE__ */ c(Fm, { className: "size-4" })
    }
  );
}
function UR({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    HR,
    {
      "data-slot": "select-scroll-down-button",
      className: C(
        "flex cursor-default items-center justify-center py-1",
        e
      ),
      ...t,
      children: /* @__PURE__ */ c(ln, { className: "size-4" })
    }
  );
}
var YR = "Separator", ii = "horizontal", jR = ["horizontal", "vertical"], jf = l.forwardRef((e, t) => {
  const { decorative: n, orientation: o = ii, ...r } = e, a = XR(o) ? o : ii, s = n ? { role: "none" } : { "aria-orientation": a === "vertical" ? a : void 0, role: "separator" };
  return /* @__PURE__ */ c(
    A.div,
    {
      "data-orientation": a,
      ...s,
      ...r,
      ref: t
    }
  );
});
jf.displayName = YR;
function XR(e) {
  return jR.includes(e);
}
var qR = jf;
function ZR({
  className: e,
  orientation: t = "horizontal",
  decorative: n = !0,
  ...o
}) {
  return /* @__PURE__ */ c(
    qR,
    {
      "data-slot": "separator-root",
      decorative: n,
      orientation: t,
      className: C(
        "bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        e
      ),
      ...o
    }
  );
}
function JR({ ...e }) {
  return /* @__PURE__ */ c(oa, { "data-slot": "sheet", ...e });
}
function nA({
  ...e
}) {
  return /* @__PURE__ */ c(ra, { "data-slot": "sheet-trigger", ...e });
}
function oA({
  ...e
}) {
  return /* @__PURE__ */ c($t, { "data-slot": "sheet-close", ...e });
}
function QR({
  ...e
}) {
  return /* @__PURE__ */ c(aa, { "data-slot": "sheet-portal", ...e });
}
function eN({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    sa,
    {
      "data-slot": "sheet-overlay",
      className: C(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
        e
      ),
      ...t
    }
  );
}
function tN({
  className: e,
  children: t,
  side: n = "right",
  ...o
}) {
  return /* @__PURE__ */ z(QR, { children: [
    /* @__PURE__ */ c(eN, {}),
    /* @__PURE__ */ z(
      ia,
      {
        "data-slot": "sheet-content",
        className: C(
          "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out fixed z-50 flex flex-col gap-4 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
          n === "right" && "data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right inset-y-0 right-0 h-full w-3/4 border-l sm:max-w-sm",
          n === "left" && "data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left inset-y-0 left-0 h-full w-3/4 border-r sm:max-w-sm",
          n === "top" && "data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top inset-x-0 top-0 h-auto border-b",
          n === "bottom" && "data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom inset-x-0 bottom-0 h-auto border-t",
          e
        ),
        ...o,
        children: [
          t,
          /* @__PURE__ */ z($t, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none", children: [
            /* @__PURE__ */ c(vi, { className: "size-4" }),
            /* @__PURE__ */ c("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
}
function nN({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sheet-header",
      className: C("flex flex-col gap-1.5 p-4", e),
      ...t
    }
  );
}
function rA({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sheet-footer",
      className: C("mt-auto flex flex-col gap-2 p-4", e),
      ...t
    }
  );
}
function oN({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    ca,
    {
      "data-slot": "sheet-title",
      className: C("text-foreground font-semibold", e),
      ...t
    }
  );
}
function rN({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    la,
    {
      "data-slot": "sheet-description",
      className: C("text-muted-foreground text-sm", e),
      ...t
    }
  );
}
function ci({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "skeleton",
      className: C("bg-accent animate-pulse rounded-md", e),
      ...t
    }
  );
}
var [Fo, aA] = Q("Tooltip", [
  Ue
]), Wo = Ue(), Xf = "TooltipProvider", aN = 700, Lr = "tooltip.open", [sN, ds] = Fo(Xf), qf = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = aN,
    skipDelayDuration: o = 300,
    disableHoverableContent: r = !1,
    children: a
  } = e, i = l.useRef(!0), s = l.useRef(!1), d = l.useRef(0);
  return l.useEffect(() => {
    const f = d.current;
    return () => window.clearTimeout(f);
  }, []), /* @__PURE__ */ c(
    sN,
    {
      scope: t,
      isOpenDelayedRef: i,
      delayDuration: n,
      onOpen: l.useCallback(() => {
        window.clearTimeout(d.current), i.current = !1;
      }, []),
      onClose: l.useCallback(() => {
        window.clearTimeout(d.current), d.current = window.setTimeout(
          () => i.current = !0,
          o
        );
      }, [o]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: l.useCallback((f) => {
        s.current = f;
      }, []),
      disableHoverableContent: r,
      children: a
    }
  );
};
qf.displayName = Xf;
var sn = "Tooltip", [iN, _n] = Fo(sn), Zf = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    disableHoverableContent: i,
    delayDuration: s
  } = e, d = ds(sn, e.__scopeTooltip), f = Wo(t), [u, p] = l.useState(null), m = le(), h = l.useRef(0), g = i ?? d.disableHoverableContent, v = s ?? d.delayDuration, b = l.useRef(!1), [w, y] = ne({
    prop: o,
    defaultProp: r ?? !1,
    onChange: (M) => {
      M ? (d.onOpen(), document.dispatchEvent(new CustomEvent(Lr))) : d.onClose(), a?.(M);
    },
    caller: sn
  }), x = l.useMemo(() => w ? b.current ? "delayed-open" : "instant-open" : "closed", [w]), E = l.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, b.current = !1, y(!0);
  }, [y]), S = l.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, y(!1);
  }, [y]), R = l.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      b.current = !0, y(!0), h.current = 0;
    }, v);
  }, [v, y]);
  return l.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ c(zt, { ...f, children: /* @__PURE__ */ c(
    iN,
    {
      scope: t,
      contentId: m,
      open: w,
      stateAttribute: x,
      trigger: u,
      onTriggerChange: p,
      onTriggerEnter: l.useCallback(() => {
        d.isOpenDelayedRef.current ? R() : E();
      }, [d.isOpenDelayedRef, R, E]),
      onTriggerLeave: l.useCallback(() => {
        g ? S() : (window.clearTimeout(h.current), h.current = 0);
      }, [S, g]),
      onOpen: E,
      onClose: S,
      disableHoverableContent: g,
      children: n
    }
  ) });
};
Zf.displayName = sn;
var Fr = "TooltipTrigger", Jf = l.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...o } = e, r = _n(Fr, n), a = ds(Fr, n), i = Wo(n), s = l.useRef(null), d = W(t, s, r.onTriggerChange), f = l.useRef(!1), u = l.useRef(!1), p = l.useCallback(() => f.current = !1, []);
    return l.useEffect(() => () => document.removeEventListener("pointerup", p), [p]), /* @__PURE__ */ c(Bt, { asChild: !0, ...i, children: /* @__PURE__ */ c(
      A.button,
      {
        "aria-describedby": r.open ? r.contentId : void 0,
        "data-state": r.stateAttribute,
        ...o,
        ref: d,
        onPointerMove: N(e.onPointerMove, (m) => {
          m.pointerType !== "touch" && !u.current && !a.isPointerInTransitRef.current && (r.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: N(e.onPointerLeave, () => {
          r.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: N(e.onPointerDown, () => {
          r.open && r.onClose(), f.current = !0, document.addEventListener("pointerup", p, { once: !0 });
        }),
        onFocus: N(e.onFocus, () => {
          f.current || r.onOpen();
        }),
        onBlur: N(e.onBlur, r.onClose),
        onClick: N(e.onClick, r.onClose)
      }
    ) });
  }
);
Jf.displayName = Fr;
var us = "TooltipPortal", [cN, lN] = Fo(us, {
  forceMount: void 0
}), Qf = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: o, container: r } = e, a = _n(us, t);
  return /* @__PURE__ */ c(cN, { scope: t, forceMount: n, children: /* @__PURE__ */ c(ee, { present: n || a.open, children: /* @__PURE__ */ c(ut, { asChild: !0, container: r, children: o }) }) });
};
Qf.displayName = us;
var kt = "TooltipContent", ep = l.forwardRef(
  (e, t) => {
    const n = lN(kt, e.__scopeTooltip), { forceMount: o = n.forceMount, side: r = "top", ...a } = e, i = _n(kt, e.__scopeTooltip);
    return /* @__PURE__ */ c(ee, { present: o || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ c(tp, { side: r, ...a, ref: t }) : /* @__PURE__ */ c(dN, { side: r, ...a, ref: t }) });
  }
), dN = l.forwardRef((e, t) => {
  const n = _n(kt, e.__scopeTooltip), o = ds(kt, e.__scopeTooltip), r = l.useRef(null), a = W(t, r), [i, s] = l.useState(null), { trigger: d, onClose: f } = n, u = r.current, { onPointerInTransitChange: p } = o, m = l.useCallback(() => {
    s(null), p(!1);
  }, [p]), h = l.useCallback(
    (g, v) => {
      const b = g.currentTarget, w = { x: g.clientX, y: g.clientY }, y = mN(w, b.getBoundingClientRect()), x = vN(w, y), E = hN(v.getBoundingClientRect()), S = bN([...x, ...E]);
      s(S), p(!0);
    },
    [p]
  );
  return l.useEffect(() => () => m(), [m]), l.useEffect(() => {
    if (d && u) {
      const g = (b) => h(b, u), v = (b) => h(b, d);
      return d.addEventListener("pointerleave", g), u.addEventListener("pointerleave", v), () => {
        d.removeEventListener("pointerleave", g), u.removeEventListener("pointerleave", v);
      };
    }
  }, [d, u, h, m]), l.useEffect(() => {
    if (i) {
      const g = (v) => {
        const b = v.target, w = { x: v.clientX, y: v.clientY }, y = d?.contains(b) || u?.contains(b), x = !gN(w, i);
        y ? m() : x && (m(), f());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [d, u, i, f, m]), /* @__PURE__ */ c(tp, { ...e, ref: a });
}), [uN, fN] = Fo(sn, { isInside: !1 }), pN = /* @__PURE__ */ gi("TooltipContent"), tp = l.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: o,
      "aria-label": r,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      ...s
    } = e, d = _n(kt, n), f = Wo(n), { onClose: u } = d;
    return l.useEffect(() => (document.addEventListener(Lr, u), () => document.removeEventListener(Lr, u)), [u]), l.useEffect(() => {
      if (d.trigger) {
        const p = (m) => {
          m.target?.contains(d.trigger) && u();
        };
        return window.addEventListener("scroll", p, { capture: !0 }), () => window.removeEventListener("scroll", p, { capture: !0 });
      }
    }, [d.trigger, u]), /* @__PURE__ */ c(
      nt,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: i,
        onFocusOutside: (p) => p.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ z(
          bn,
          {
            "data-state": d.stateAttribute,
            ...f,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ c(pN, { children: o }),
              /* @__PURE__ */ c(uN, { scope: n, isInside: !0, children: /* @__PURE__ */ c(pu, { id: d.contentId, role: "tooltip", children: r || o }) })
            ]
          }
        )
      }
    );
  }
);
ep.displayName = kt;
var np = "TooltipArrow", op = l.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...o } = e, r = Wo(n);
    return fN(
      np,
      n
    ).isInside ? null : /* @__PURE__ */ c(wn, { ...r, ...o, ref: t });
  }
);
op.displayName = np;
function mN(e, t) {
  const n = Math.abs(t.top - e.y), o = Math.abs(t.bottom - e.y), r = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, o, r, a)) {
    case a:
      return "left";
    case r:
      return "right";
    case n:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function vN(e, t, n = 5) {
  const o = [];
  switch (t) {
    case "top":
      o.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      o.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      o.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      o.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return o;
}
function hN(e) {
  const { top: t, right: n, bottom: o, left: r } = e;
  return [
    { x: r, y: t },
    { x: n, y: t },
    { x: n, y: o },
    { x: r, y: o }
  ];
}
function gN(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a], d = t[i], f = s.x, u = s.y, p = d.x, m = d.y;
    u > o != m > o && n < (p - f) * (o - u) / (m - u) + f && (r = !r);
  }
  return r;
}
function bN(e) {
  const t = e.slice();
  return t.sort((n, o) => n.x < o.x ? -1 : n.x > o.x ? 1 : n.y < o.y ? -1 : n.y > o.y ? 1 : 0), wN(t);
}
function wN(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (r.y - i.y) >= (a.y - i.y) * (r.x - i.x)) t.pop();
      else break;
    }
    t.push(r);
  }
  t.pop();
  const n = [];
  for (let o = e.length - 1; o >= 0; o--) {
    const r = e[o];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], i = n[n.length - 2];
      if ((a.x - i.x) * (r.y - i.y) >= (a.y - i.y) * (r.x - i.x)) n.pop();
      else break;
    }
    n.push(r);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var yN = qf, xN = Zf, CN = Jf, SN = Qf, EN = ep, MN = op;
function rp({
  delayDuration: e = 0,
  ...t
}) {
  return /* @__PURE__ */ c(
    yN,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      ...t
    }
  );
}
function RN({
  ...e
}) {
  return /* @__PURE__ */ c(rp, { children: /* @__PURE__ */ c(xN, { "data-slot": "tooltip", ...e }) });
}
function NN({
  ...e
}) {
  return /* @__PURE__ */ c(CN, { "data-slot": "tooltip-trigger", ...e });
}
function PN({
  className: e,
  sideOffset: t = 0,
  children: n,
  ...o
}) {
  return /* @__PURE__ */ c(SN, { children: /* @__PURE__ */ z(
    EN,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: C(
        "bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance",
        e
      ),
      ...o,
      children: [
        n,
        /* @__PURE__ */ c(MN, { className: "bg-primary fill-primary z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" })
      ]
    }
  ) });
}
const _N = "sidebar_state", TN = 3600 * 24 * 7, AN = "16rem", DN = "18rem", IN = "3rem", ON = "b", ap = l.createContext(null);
function zo() {
  const e = l.useContext(ap);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
function sA({
  defaultOpen: e = !0,
  open: t,
  onOpenChange: n,
  className: o,
  style: r,
  children: a,
  ...i
}) {
  const s = Pv(), [d, f] = l.useState(!1), [u, p] = l.useState(e), m = t ?? u, h = l.useCallback(
    (w) => {
      const y = typeof w == "function" ? w(m) : w;
      n ? n(y) : p(y), document.cookie = `${_N}=${y}; path=/; max-age=${TN}`;
    },
    [n, m]
  ), g = l.useCallback(() => s ? f((w) => !w) : h((w) => !w), [s, h, f]);
  l.useEffect(() => {
    const w = (y) => {
      y.key === ON && (y.metaKey || y.ctrlKey) && (y.preventDefault(), g());
    };
    return window.addEventListener("keydown", w), () => window.removeEventListener("keydown", w);
  }, [g]);
  const v = m ? "expanded" : "collapsed", b = l.useMemo(
    () => ({
      state: v,
      open: m,
      setOpen: h,
      isMobile: s,
      openMobile: d,
      setOpenMobile: f,
      toggleSidebar: g
    }),
    [v, m, h, s, d, f, g]
  );
  return /* @__PURE__ */ c(ap.Provider, { value: b, children: /* @__PURE__ */ c(rp, { delayDuration: 0, children: /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sidebar-wrapper",
      style: {
        "--sidebar-width": AN,
        "--sidebar-width-icon": IN,
        ...r
      },
      className: C(
        "group/sidebar-wrapper has-data-[variant=inset]:bg-sidebar flex min-h-svh w-full",
        o
      ),
      ...i,
      children: a
    }
  ) }) });
}
function iA({
  side: e = "left",
  variant: t = "sidebar",
  collapsible: n = "offcanvas",
  className: o,
  children: r,
  ...a
}) {
  const { isMobile: i, state: s, openMobile: d, setOpenMobile: f } = zo();
  return n === "none" ? /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sidebar",
      className: C(
        "bg-sidebar text-sidebar-foreground flex h-full w-(--sidebar-width) flex-col",
        o
      ),
      ...a,
      children: r
    }
  ) : i ? /* @__PURE__ */ c(JR, { open: d, onOpenChange: f, ...a, children: /* @__PURE__ */ z(
    tN,
    {
      "data-sidebar": "sidebar",
      "data-slot": "sidebar",
      "data-mobile": "true",
      className: "bg-sidebar text-sidebar-foreground w-(--sidebar-width) p-0 [&>button]:hidden",
      style: {
        "--sidebar-width": DN
      },
      side: e,
      children: [
        /* @__PURE__ */ z(nN, { className: "sr-only", children: [
          /* @__PURE__ */ c(oN, { children: "Sidebar" }),
          /* @__PURE__ */ c(rN, { children: "Displays the mobile sidebar." })
        ] }),
        /* @__PURE__ */ c("div", { className: "flex h-full w-full flex-col", children: r })
      ]
    }
  ) }) : /* @__PURE__ */ z(
    "div",
    {
      className: "group peer text-sidebar-foreground hidden md:block",
      "data-state": s,
      "data-collapsible": s === "collapsed" ? n : "",
      "data-variant": t,
      "data-side": e,
      "data-slot": "sidebar",
      children: [
        /* @__PURE__ */ c(
          "div",
          {
            "data-slot": "sidebar-gap",
            className: C(
              "relative w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear",
              "group-data-[collapsible=offcanvas]:w-0",
              "group-data-[side=right]:rotate-180",
              t === "floating" || t === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
            )
          }
        ),
        /* @__PURE__ */ c(
          "div",
          {
            "data-slot": "sidebar-container",
            className: C(
              "fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex",
              e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
              // Adjust the padding for floating and inset variants.
              t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l",
              o
            ),
            ...a,
            children: /* @__PURE__ */ c(
              "div",
              {
                "data-sidebar": "sidebar",
                "data-slot": "sidebar-inner",
                className: "bg-sidebar group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:shadow-sm",
                children: r
              }
            )
          }
        )
      ]
    }
  );
}
function cA({
  className: e,
  onClick: t,
  ...n
}) {
  const { toggleSidebar: o } = zo();
  return /* @__PURE__ */ z(
    Ze,
    {
      "data-sidebar": "trigger",
      "data-slot": "sidebar-trigger",
      variant: "ghost",
      size: "icon",
      className: C("size-7", e),
      onClick: (r) => {
        t?.(r), o();
      },
      ...n,
      children: [
        /* @__PURE__ */ c(Wm, {}),
        /* @__PURE__ */ c("span", { className: "sr-only", children: "Toggle Sidebar" })
      ]
    }
  );
}
function lA({ className: e, ...t }) {
  const { toggleSidebar: n } = zo();
  return /* @__PURE__ */ c(
    "button",
    {
      "data-sidebar": "rail",
      "data-slot": "sidebar-rail",
      "aria-label": "Toggle Sidebar",
      tabIndex: -1,
      onClick: n,
      title: "Toggle Sidebar",
      className: C(
        "hover:after:bg-sidebar-border absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear group-data-[side=left]:-right-4 group-data-[side=right]:left-0 after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] sm:flex",
        "in-data-[side=left]:cursor-w-resize in-data-[side=right]:cursor-e-resize",
        "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize",
        "hover:group-data-[collapsible=offcanvas]:bg-sidebar group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full",
        "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2",
        "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2",
        e
      ),
      ...t
    }
  );
}
function dA({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "main",
    {
      "data-slot": "sidebar-inset",
      className: C(
        "bg-background relative flex w-full flex-1 flex-col",
        "md:peer-data-[variant=inset]:m-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow-sm md:peer-data-[variant=inset]:peer-data-[state=collapsed]:ml-2",
        e
      ),
      ...t
    }
  );
}
function uA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Gd,
    {
      "data-slot": "sidebar-input",
      "data-sidebar": "input",
      className: C("bg-background h-8 w-full shadow-none", e),
      ...t
    }
  );
}
function fA({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sidebar-header",
      "data-sidebar": "header",
      className: C("flex flex-col gap-2 p-2", e),
      ...t
    }
  );
}
function pA({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sidebar-footer",
      "data-sidebar": "footer",
      className: C("flex flex-col gap-2 p-2", e),
      ...t
    }
  );
}
function mA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    ZR,
    {
      "data-slot": "sidebar-separator",
      "data-sidebar": "separator",
      className: C("bg-sidebar-border mx-2 w-auto", e),
      ...t
    }
  );
}
function vA({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sidebar-content",
      "data-sidebar": "content",
      className: C(
        "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
        e
      ),
      ...t
    }
  );
}
function hA({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sidebar-group",
      "data-sidebar": "group",
      className: C("relative flex w-full min-w-0 flex-col p-2", e),
      ...t
    }
  );
}
function gA({
  className: e,
  asChild: t = !1,
  ...n
}) {
  return /* @__PURE__ */ c(
    t ? dt : "div",
    {
      "data-slot": "sidebar-group-label",
      "data-sidebar": "group-label",
      className: C(
        "text-sidebar-foreground/70 ring-sidebar-ring flex h-8 shrink-0 items-center rounded-md px-2 text-xs font-medium outline-hidden transition-[margin,opacity] duration-200 ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
        "group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0",
        e
      ),
      ...n
    }
  );
}
function bA({
  className: e,
  asChild: t = !1,
  ...n
}) {
  return /* @__PURE__ */ c(
    t ? dt : "button",
    {
      "data-slot": "sidebar-group-action",
      "data-sidebar": "group-action",
      className: C(
        "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground absolute top-3.5 right-3 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-hidden transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
        // Increases the hit area of the button on mobile.
        "after:absolute after:-inset-2 md:after:hidden",
        "group-data-[collapsible=icon]:hidden",
        e
      ),
      ...n
    }
  );
}
function wA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sidebar-group-content",
      "data-sidebar": "group-content",
      className: C("w-full text-sm", e),
      ...t
    }
  );
}
function yA({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "ul",
    {
      "data-slot": "sidebar-menu",
      "data-sidebar": "menu",
      className: C("flex w-full min-w-0 flex-col gap-1", e),
      ...t
    }
  );
}
function xA({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "li",
    {
      "data-slot": "sidebar-menu-item",
      "data-sidebar": "menu-item",
      className: C("group/menu-item relative", e),
      ...t
    }
  );
}
const kN = et(
  "peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-hidden ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-data-[sidebar=menu-action]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-2! [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
        outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
      },
      size: {
        default: "h-8 text-sm",
        sm: "h-7 text-xs",
        lg: "h-12 text-sm group-data-[collapsible=icon]:p-0!"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function CA({
  asChild: e = !1,
  isActive: t = !1,
  variant: n = "default",
  size: o = "default",
  tooltip: r,
  className: a,
  ...i
}) {
  const s = e ? dt : "button", { isMobile: d, state: f } = zo(), u = /* @__PURE__ */ c(
    s,
    {
      "data-slot": "sidebar-menu-button",
      "data-sidebar": "menu-button",
      "data-size": o,
      "data-active": t,
      className: C(kN({ variant: n, size: o }), a),
      ...i
    }
  );
  return r ? (typeof r == "string" && (r = {
    children: r
  }), /* @__PURE__ */ z(RN, { children: [
    /* @__PURE__ */ c(NN, { asChild: !0, children: u }),
    /* @__PURE__ */ c(
      PN,
      {
        side: "right",
        align: "center",
        hidden: f !== "collapsed" || d,
        ...r
      }
    )
  ] })) : u;
}
function SA({
  className: e,
  asChild: t = !1,
  showOnHover: n = !1,
  ...o
}) {
  return /* @__PURE__ */ c(
    t ? dt : "button",
    {
      "data-slot": "sidebar-menu-action",
      "data-sidebar": "menu-action",
      className: C(
        "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground peer-hover/menu-button:text-sidebar-accent-foreground absolute top-1.5 right-1 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-hidden transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
        // Increases the hit area of the button on mobile.
        "after:absolute after:-inset-2 md:after:hidden",
        "peer-data-[size=sm]/menu-button:top-1",
        "peer-data-[size=default]/menu-button:top-1.5",
        "peer-data-[size=lg]/menu-button:top-2.5",
        "group-data-[collapsible=icon]:hidden",
        n && "peer-data-[active=true]/menu-button:text-sidebar-accent-foreground group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 data-[state=open]:opacity-100 md:opacity-0",
        e
      ),
      ...o
    }
  );
}
function EA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sidebar-menu-badge",
      "data-sidebar": "menu-badge",
      className: C(
        "text-sidebar-foreground pointer-events-none absolute right-1 flex h-5 min-w-5 items-center justify-center rounded-md px-1 text-xs font-medium tabular-nums select-none",
        "peer-hover/menu-button:text-sidebar-accent-foreground peer-data-[active=true]/menu-button:text-sidebar-accent-foreground",
        "peer-data-[size=sm]/menu-button:top-1",
        "peer-data-[size=default]/menu-button:top-1.5",
        "peer-data-[size=lg]/menu-button:top-2.5",
        "group-data-[collapsible=icon]:hidden",
        e
      ),
      ...t
    }
  );
}
function MA({
  className: e,
  showIcon: t = !1,
  ...n
}) {
  const o = l.useMemo(() => `${Math.floor(Math.random() * 40) + 50}%`, []);
  return /* @__PURE__ */ z(
    "div",
    {
      "data-slot": "sidebar-menu-skeleton",
      "data-sidebar": "menu-skeleton",
      className: C("flex h-8 items-center gap-2 rounded-md px-2", e),
      ...n,
      children: [
        t && /* @__PURE__ */ c(
          ci,
          {
            className: "size-4 rounded-md",
            "data-sidebar": "menu-skeleton-icon"
          }
        ),
        /* @__PURE__ */ c(
          ci,
          {
            className: "h-4 max-w-(--skeleton-width) flex-1",
            "data-sidebar": "menu-skeleton-text",
            style: {
              "--skeleton-width": o
            }
          }
        )
      ]
    }
  );
}
function RA({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "ul",
    {
      "data-slot": "sidebar-menu-sub",
      "data-sidebar": "menu-sub",
      className: C(
        "border-sidebar-border mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l px-2.5 py-0.5",
        "group-data-[collapsible=icon]:hidden",
        e
      ),
      ...t
    }
  );
}
function NA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "li",
    {
      "data-slot": "sidebar-menu-sub-item",
      "data-sidebar": "menu-sub-item",
      className: C("group/menu-sub-item relative", e),
      ...t
    }
  );
}
function PA({
  asChild: e = !1,
  size: t = "md",
  isActive: n = !1,
  className: o,
  ...r
}) {
  return /* @__PURE__ */ c(
    e ? dt : "a",
    {
      "data-slot": "sidebar-menu-sub-button",
      "data-sidebar": "menu-sub-button",
      "data-size": t,
      "data-active": n,
      className: C(
        "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground active:bg-sidebar-accent active:text-sidebar-accent-foreground [&>svg]:text-sidebar-accent-foreground flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 outline-hidden focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
        "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground",
        t === "sm" && "text-xs",
        t === "md" && "text-sm",
        "group-data-[collapsible=icon]:hidden",
        o
      ),
      ...r
    }
  );
}
var sp = ["PageUp", "PageDown"], ip = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], cp = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Ht = "Slider", [Wr, $N, LN] = tt(Ht), [lp, _A] = Q(Ht, [
  LN
]), [FN, Bo] = lp(Ht), dp = l.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: o = 0,
      max: r = 100,
      step: a = 1,
      orientation: i = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: d = 0,
      defaultValue: f = [o],
      value: u,
      onValueChange: p = () => {
      },
      onValueCommit: m = () => {
      },
      inverted: h = !1,
      form: g,
      ...v
    } = e, b = l.useRef(/* @__PURE__ */ new Set()), w = l.useRef(0), x = i === "horizontal" ? WN : zN, [E = [], S] = ne({
      prop: u,
      defaultProp: f,
      onChange: (O) => {
        [...b.current][w.current]?.focus(), p(O);
      }
    }), R = l.useRef(E);
    function M(O) {
      const B = KN(E, O);
      D(O, B);
    }
    function P(O) {
      D(O, w.current);
    }
    function T() {
      const O = R.current[w.current];
      E[w.current] !== O && m(E);
    }
    function D(O, B, { commit: K } = { commit: !1 }) {
      const k = XN(a), G = qN(Math.round((O - o) / a) * a + o, k), L = an(G, [o, r]);
      S((H = []) => {
        const $ = HN(H, L, B);
        if (jN($, d * a)) {
          w.current = $.indexOf(L);
          const I = String($) !== String(H);
          return I && K && m($), I ? $ : H;
        } else
          return H;
      });
    }
    return /* @__PURE__ */ c(
      FN,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: s,
        min: o,
        max: r,
        valueIndexToChangeRef: w,
        thumbs: b.current,
        values: E,
        orientation: i,
        form: g,
        children: /* @__PURE__ */ c(Wr.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ c(Wr.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ c(
          x,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...v,
            ref: t,
            onPointerDown: N(v.onPointerDown, () => {
              s || (R.current = E);
            }),
            min: o,
            max: r,
            inverted: h,
            onSlideStart: s ? void 0 : M,
            onSlideMove: s ? void 0 : P,
            onSlideEnd: s ? void 0 : T,
            onHomeKeyDown: () => !s && D(o, 0, { commit: !0 }),
            onEndKeyDown: () => !s && D(r, E.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: O, direction: B }) => {
              if (!s) {
                const G = sp.includes(O.key) || O.shiftKey && ip.includes(O.key) ? 10 : 1, L = w.current, H = E[L], $ = a * G * B;
                D(H + $, L, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
dp.displayName = Ht;
var [up, fp] = lp(Ht, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), WN = l.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: o,
      dir: r,
      inverted: a,
      onSlideStart: i,
      onSlideMove: s,
      onSlideEnd: d,
      onStepKeyDown: f,
      ...u
    } = e, [p, m] = l.useState(null), h = W(t, (x) => m(x)), g = l.useRef(void 0), v = Oe(r), b = v === "ltr", w = b && !a || !b && a;
    function y(x) {
      const E = g.current || p.getBoundingClientRect(), S = [0, E.width], M = fs(S, w ? [n, o] : [o, n]);
      return g.current = E, M(x - E.left);
    }
    return /* @__PURE__ */ c(
      up,
      {
        scope: e.__scopeSlider,
        startEdge: w ? "left" : "right",
        endEdge: w ? "right" : "left",
        direction: w ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ c(
          pp,
          {
            dir: v,
            "data-orientation": "horizontal",
            ...u,
            ref: h,
            style: {
              ...u.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (x) => {
              const E = y(x.clientX);
              i?.(E);
            },
            onSlideMove: (x) => {
              const E = y(x.clientX);
              s?.(E);
            },
            onSlideEnd: () => {
              g.current = void 0, d?.();
            },
            onStepKeyDown: (x) => {
              const S = cp[w ? "from-left" : "from-right"].includes(x.key);
              f?.({ event: x, direction: S ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), zN = l.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: o,
      inverted: r,
      onSlideStart: a,
      onSlideMove: i,
      onSlideEnd: s,
      onStepKeyDown: d,
      ...f
    } = e, u = l.useRef(null), p = W(t, u), m = l.useRef(void 0), h = !r;
    function g(v) {
      const b = m.current || u.current.getBoundingClientRect(), w = [0, b.height], x = fs(w, h ? [o, n] : [n, o]);
      return m.current = b, x(v - b.top);
    }
    return /* @__PURE__ */ c(
      up,
      {
        scope: e.__scopeSlider,
        startEdge: h ? "bottom" : "top",
        endEdge: h ? "top" : "bottom",
        size: "height",
        direction: h ? 1 : -1,
        children: /* @__PURE__ */ c(
          pp,
          {
            "data-orientation": "vertical",
            ...f,
            ref: p,
            style: {
              ...f.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (v) => {
              const b = g(v.clientY);
              a?.(b);
            },
            onSlideMove: (v) => {
              const b = g(v.clientY);
              i?.(b);
            },
            onSlideEnd: () => {
              m.current = void 0, s?.();
            },
            onStepKeyDown: (v) => {
              const w = cp[h ? "from-bottom" : "from-top"].includes(v.key);
              d?.({ event: v, direction: w ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), pp = l.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: o,
      onSlideMove: r,
      onSlideEnd: a,
      onHomeKeyDown: i,
      onEndKeyDown: s,
      onStepKeyDown: d,
      ...f
    } = e, u = Bo(Ht, n);
    return /* @__PURE__ */ c(
      A.span,
      {
        ...f,
        ref: t,
        onKeyDown: N(e.onKeyDown, (p) => {
          p.key === "Home" ? (i(p), p.preventDefault()) : p.key === "End" ? (s(p), p.preventDefault()) : sp.concat(ip).includes(p.key) && (d(p), p.preventDefault());
        }),
        onPointerDown: N(e.onPointerDown, (p) => {
          const m = p.target;
          m.setPointerCapture(p.pointerId), p.preventDefault(), u.thumbs.has(m) ? m.focus() : o(p);
        }),
        onPointerMove: N(e.onPointerMove, (p) => {
          p.target.hasPointerCapture(p.pointerId) && r(p);
        }),
        onPointerUp: N(e.onPointerUp, (p) => {
          const m = p.target;
          m.hasPointerCapture(p.pointerId) && (m.releasePointerCapture(p.pointerId), a(p));
        })
      }
    );
  }
), mp = "SliderTrack", vp = l.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...o } = e, r = Bo(mp, n);
    return /* @__PURE__ */ c(
      A.span,
      {
        "data-disabled": r.disabled ? "" : void 0,
        "data-orientation": r.orientation,
        ...o,
        ref: t
      }
    );
  }
);
vp.displayName = mp;
var zr = "SliderRange", hp = l.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...o } = e, r = Bo(zr, n), a = fp(zr, n), i = l.useRef(null), s = W(t, i), d = r.values.length, f = r.values.map(
      (m) => wp(m, r.min, r.max)
    ), u = d > 1 ? Math.min(...f) : 0, p = 100 - Math.max(...f);
    return /* @__PURE__ */ c(
      A.span,
      {
        "data-orientation": r.orientation,
        "data-disabled": r.disabled ? "" : void 0,
        ...o,
        ref: s,
        style: {
          ...e.style,
          [a.startEdge]: u + "%",
          [a.endEdge]: p + "%"
        }
      }
    );
  }
);
hp.displayName = zr;
var Br = "SliderThumb", gp = l.forwardRef(
  (e, t) => {
    const n = $N(e.__scopeSlider), [o, r] = l.useState(null), a = W(t, (s) => r(s)), i = l.useMemo(
      () => o ? n().findIndex((s) => s.ref.current === o) : -1,
      [n, o]
    );
    return /* @__PURE__ */ c(BN, { ...e, ref: a, index: i });
  }
), BN = l.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: o, name: r, ...a } = e, i = Bo(Br, n), s = fp(Br, n), [d, f] = l.useState(null), u = W(t, (y) => f(y)), p = d ? i.form || !!d.closest("form") : !0, m = hn(d), h = i.values[o], g = h === void 0 ? 0 : wp(h, i.min, i.max), v = GN(o, i.values.length), b = m?.[s.size], w = b ? UN(b, g, s.direction) : 0;
    return l.useEffect(() => {
      if (d)
        return i.thumbs.add(d), () => {
          i.thumbs.delete(d);
        };
    }, [d, i.thumbs]), /* @__PURE__ */ z(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${g}% + ${w}px)`
        },
        children: [
          /* @__PURE__ */ c(Wr.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ c(
            A.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || v,
              "aria-valuemin": i.min,
              "aria-valuenow": h,
              "aria-valuemax": i.max,
              "aria-orientation": i.orientation,
              "data-orientation": i.orientation,
              "data-disabled": i.disabled ? "" : void 0,
              tabIndex: i.disabled ? void 0 : 0,
              ...a,
              ref: u,
              style: h === void 0 ? { display: "none" } : e.style,
              onFocus: N(e.onFocus, () => {
                i.valueIndexToChangeRef.current = o;
              })
            }
          ) }),
          p && /* @__PURE__ */ c(
            bp,
            {
              name: r ?? (i.name ? i.name + (i.values.length > 1 ? "[]" : "") : void 0),
              form: i.form,
              value: h
            },
            o
          )
        ]
      }
    );
  }
);
gp.displayName = Br;
var VN = "RadioBubbleInput", bp = l.forwardRef(
  ({ __scopeSlider: e, value: t, ...n }, o) => {
    const r = l.useRef(null), a = W(r, o), i = Lt(t);
    return l.useEffect(() => {
      const s = r.current;
      if (!s) return;
      const d = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(d, "value").set;
      if (i !== t && u) {
        const p = new Event("input", { bubbles: !0 });
        u.call(s, t), s.dispatchEvent(p);
      }
    }, [i, t]), /* @__PURE__ */ c(
      A.input,
      {
        style: { display: "none" },
        ...n,
        ref: a,
        defaultValue: t
      }
    );
  }
);
bp.displayName = VN;
function HN(e = [], t, n) {
  const o = [...e];
  return o[n] = t, o.sort((r, a) => r - a);
}
function wp(e, t, n) {
  const a = 100 / (n - t) * (e - t);
  return an(a, [0, 100]);
}
function GN(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function KN(e, t) {
  if (e.length === 1) return 0;
  const n = e.map((r) => Math.abs(r - t)), o = Math.min(...n);
  return n.indexOf(o);
}
function UN(e, t, n) {
  const o = e / 2, a = fs([0, 50], [0, o]);
  return (o - a(t) * n) * n;
}
function YN(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function jN(e, t) {
  if (t > 0) {
    const n = YN(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function fs(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function XN(e) {
  return (String(e).split(".")[1] || "").length;
}
function qN(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var ZN = dp, JN = vp, QN = hp, eP = gp;
function TA({
  className: e,
  defaultValue: t,
  value: n,
  min: o = 0,
  max: r = 100,
  ...a
}) {
  const i = l.useMemo(
    () => Array.isArray(n) ? n : Array.isArray(t) ? t : [o, r],
    [n, t, o, r]
  );
  return /* @__PURE__ */ z(
    ZN,
    {
      "data-slot": "slider",
      defaultValue: t,
      value: n,
      min: o,
      max: r,
      className: C(
        "relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
        e
      ),
      ...a,
      children: [
        /* @__PURE__ */ c(
          JN,
          {
            "data-slot": "slider-track",
            className: C(
              "bg-muted relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"
            ),
            children: /* @__PURE__ */ c(
              QN,
              {
                "data-slot": "slider-range",
                className: C(
                  "bg-primary absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full"
                )
              }
            )
          }
        ),
        Array.from({ length: i.length }, (s, d) => /* @__PURE__ */ c(
          eP,
          {
            "data-slot": "slider-thumb",
            className: "border-primary bg-background ring-ring/50 block size-4 shrink-0 rounded-full border shadow-sm transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50"
          },
          d
        ))
      ]
    }
  );
}
const AA = ({ ...e }) => {
  const { theme: t = "system" } = Rv();
  return /* @__PURE__ */ c(
    Nv,
    {
      theme: t,
      className: "toaster group",
      toastOptions: {
        classNames: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
        }
      },
      ...e
    }
  );
};
var Vo = "Switch", [tP, DA] = Q(Vo), [nP, oP] = tP(Vo), yp = l.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: o,
      checked: r,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: d = "on",
      onCheckedChange: f,
      form: u,
      ...p
    } = e, [m, h] = l.useState(null), g = W(t, (x) => h(x)), v = l.useRef(!1), b = m ? u || !!m.closest("form") : !0, [w, y] = ne({
      prop: r,
      defaultProp: a ?? !1,
      onChange: f,
      caller: Vo
    });
    return /* @__PURE__ */ z(nP, { scope: n, checked: w, disabled: s, children: [
      /* @__PURE__ */ c(
        A.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": w,
          "aria-required": i,
          "data-state": Ep(w),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: d,
          ...p,
          ref: g,
          onClick: N(e.onClick, (x) => {
            y((E) => !E), b && (v.current = x.isPropagationStopped(), v.current || x.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ c(
        Sp,
        {
          control: m,
          bubbles: !v.current,
          name: o,
          value: d,
          checked: w,
          required: i,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
yp.displayName = Vo;
var xp = "SwitchThumb", Cp = l.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...o } = e, r = oP(xp, n);
    return /* @__PURE__ */ c(
      A.span,
      {
        "data-state": Ep(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
Cp.displayName = xp;
var rP = "SwitchBubbleInput", Sp = l.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: o = !0,
    ...r
  }, a) => {
    const i = l.useRef(null), s = W(i, a), d = Lt(n), f = hn(t);
    return l.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const p = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        p,
        "checked"
      ).set;
      if (d !== n && h) {
        const g = new Event("click", { bubbles: o });
        h.call(u, n), u.dispatchEvent(g);
      }
    }, [d, n, o]), /* @__PURE__ */ c(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...r,
        tabIndex: -1,
        ref: s,
        style: {
          ...r.style,
          ...f,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Sp.displayName = rP;
function Ep(e) {
  return e ? "checked" : "unchecked";
}
var aP = yp, sP = Cp;
function IA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    aP,
    {
      "data-slot": "switch",
      className: C(
        "peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t,
      children: /* @__PURE__ */ c(
        sP,
        {
          "data-slot": "switch-thumb",
          className: C(
            "bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0"
          )
        }
      )
    }
  );
}
const iP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ c(
  "table",
  {
    ref: n,
    className: C("w-full caption-bottom text-sm", e),
    ...t
  }
) }));
iP.displayName = "Table";
const cP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c("thead", { ref: n, className: C("[&_tr]:border-b", e), ...t }));
cP.displayName = "TableHeader";
const lP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  "tbody",
  {
    ref: n,
    className: C("[&_tr:last-child]:border-0", e),
    ...t
  }
));
lP.displayName = "TableBody";
const dP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  "tfoot",
  {
    ref: n,
    className: C(
      "bg-muted/50 border-t font-medium [&>tr]:last:border-b-0",
      e
    ),
    ...t
  }
));
dP.displayName = "TableFooter";
const uP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  "tr",
  {
    ref: n,
    className: C(
      "hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors",
      e
    ),
    ...t
  }
));
uP.displayName = "TableRow";
const fP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  "th",
  {
    ref: n,
    className: C(
      "text-muted-foreground h-10 px-2 text-left align-middle font-medium [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
      e
    ),
    ...t
  }
));
fP.displayName = "TableHead";
const pP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  "td",
  {
    ref: n,
    className: C(
      "p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
      e
    ),
    ...t
  }
));
pP.displayName = "TableCell";
const mP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  "caption",
  {
    ref: n,
    className: C("text-muted-foreground mt-4 text-sm", e),
    ...t
  }
));
mP.displayName = "TableCaption";
var ps = "ToastProvider", [ms, vP, hP] = tt("Toast"), [Mp, OA] = Q("Toast", [hP]), [gP, Ho] = Mp(ps), Rp = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: o = 5e3,
    swipeDirection: r = "right",
    swipeThreshold: a = 50,
    children: i
  } = e, [s, d] = l.useState(null), [f, u] = l.useState(0), p = l.useRef(!1), m = l.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${ps}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ c(ms.Provider, { scope: t, children: /* @__PURE__ */ c(
    gP,
    {
      scope: t,
      label: n,
      duration: o,
      swipeDirection: r,
      swipeThreshold: a,
      toastCount: f,
      viewport: s,
      onViewportChange: d,
      onToastAdd: l.useCallback(() => u((h) => h + 1), []),
      onToastRemove: l.useCallback(() => u((h) => h - 1), []),
      isFocusedToastEscapeKeyDownRef: p,
      isClosePausedRef: m,
      children: i
    }
  ) });
};
Rp.displayName = ps;
var Np = "ToastViewport", bP = ["F8"], Vr = "toast.viewportPause", Hr = "toast.viewportResume", Pp = l.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: o = bP,
      label: r = "Notifications ({hotkey})",
      ...a
    } = e, i = Ho(Np, n), s = vP(n), d = l.useRef(null), f = l.useRef(null), u = l.useRef(null), p = l.useRef(null), m = W(t, p, i.onViewportChange), h = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), g = i.toastCount > 0;
    l.useEffect(() => {
      const b = (w) => {
        o.length !== 0 && o.every((x) => w[x] || w.code === x) && p.current?.focus();
      };
      return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
    }, [o]), l.useEffect(() => {
      const b = d.current, w = p.current;
      if (g && b && w) {
        const y = () => {
          if (!i.isClosePausedRef.current) {
            const R = new CustomEvent(Vr);
            w.dispatchEvent(R), i.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (i.isClosePausedRef.current) {
            const R = new CustomEvent(Hr);
            w.dispatchEvent(R), i.isClosePausedRef.current = !1;
          }
        }, E = (R) => {
          !b.contains(R.relatedTarget) && x();
        }, S = () => {
          b.contains(document.activeElement) || x();
        };
        return b.addEventListener("focusin", y), b.addEventListener("focusout", E), b.addEventListener("pointermove", y), b.addEventListener("pointerleave", S), window.addEventListener("blur", y), window.addEventListener("focus", x), () => {
          b.removeEventListener("focusin", y), b.removeEventListener("focusout", E), b.removeEventListener("pointermove", y), b.removeEventListener("pointerleave", S), window.removeEventListener("blur", y), window.removeEventListener("focus", x);
        };
      }
    }, [g, i.isClosePausedRef]);
    const v = l.useCallback(
      ({ tabbingDirection: b }) => {
        const y = s().map((x) => {
          const E = x.ref.current, S = [E, ...AP(E)];
          return b === "forwards" ? S : S.reverse();
        });
        return (b === "forwards" ? y.reverse() : y).flat();
      },
      [s]
    );
    return l.useEffect(() => {
      const b = p.current;
      if (b) {
        const w = (y) => {
          const x = y.altKey || y.ctrlKey || y.metaKey;
          if (y.key === "Tab" && !x) {
            const S = document.activeElement, R = y.shiftKey;
            if (y.target === b && R) {
              f.current?.focus();
              return;
            }
            const T = v({ tabbingDirection: R ? "backwards" : "forwards" }), D = T.findIndex((O) => O === S);
            mr(T.slice(D + 1)) ? y.preventDefault() : R ? f.current?.focus() : u.current?.focus();
          }
        };
        return b.addEventListener("keydown", w), () => b.removeEventListener("keydown", w);
      }
    }, [s, v]), /* @__PURE__ */ z(
      yh,
      {
        ref: d,
        role: "region",
        "aria-label": r.replace("{hotkey}", h),
        tabIndex: -1,
        style: { pointerEvents: g ? void 0 : "none" },
        children: [
          g && /* @__PURE__ */ c(
            Gr,
            {
              ref: f,
              onFocusFromOutsideViewport: () => {
                const b = v({
                  tabbingDirection: "forwards"
                });
                mr(b);
              }
            }
          ),
          /* @__PURE__ */ c(ms.Slot, { scope: n, children: /* @__PURE__ */ c(A.ol, { tabIndex: -1, ...a, ref: m }) }),
          g && /* @__PURE__ */ c(
            Gr,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const b = v({
                  tabbingDirection: "backwards"
                });
                mr(b);
              }
            }
          )
        ]
      }
    );
  }
);
Pp.displayName = Np;
var _p = "ToastFocusProxy", Gr = l.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: o, ...r } = e, a = Ho(_p, n);
    return /* @__PURE__ */ c(
      To,
      {
        tabIndex: 0,
        ...r,
        ref: t,
        style: { position: "fixed" },
        onFocus: (i) => {
          const s = i.relatedTarget;
          !a.viewport?.contains(s) && o();
        }
      }
    );
  }
);
Gr.displayName = _p;
var Tn = "Toast", wP = "toast.swipeStart", yP = "toast.swipeMove", xP = "toast.swipeCancel", CP = "toast.swipeEnd", Tp = l.forwardRef(
  (e, t) => {
    const { forceMount: n, open: o, defaultOpen: r, onOpenChange: a, ...i } = e, [s, d] = ne({
      prop: o,
      defaultProp: r ?? !0,
      onChange: a,
      caller: Tn
    });
    return /* @__PURE__ */ c(ee, { present: n || s, children: /* @__PURE__ */ c(
      MP,
      {
        open: s,
        ...i,
        ref: t,
        onClose: () => d(!1),
        onPause: q(e.onPause),
        onResume: q(e.onResume),
        onSwipeStart: N(e.onSwipeStart, (f) => {
          f.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: N(e.onSwipeMove, (f) => {
          const { x: u, y: p } = f.detail.delta;
          f.currentTarget.setAttribute("data-swipe", "move"), f.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), f.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${p}px`);
        }),
        onSwipeCancel: N(e.onSwipeCancel, (f) => {
          f.currentTarget.setAttribute("data-swipe", "cancel"), f.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), f.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), f.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), f.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: N(e.onSwipeEnd, (f) => {
          const { x: u, y: p } = f.detail.delta;
          f.currentTarget.setAttribute("data-swipe", "end"), f.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), f.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), f.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), f.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${p}px`), d(!1);
        })
      }
    ) });
  }
);
Tp.displayName = Tn;
var [SP, EP] = Mp(Tn, {
  onClose() {
  }
}), MP = l.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: o = "foreground",
      duration: r,
      open: a,
      onClose: i,
      onEscapeKeyDown: s,
      onPause: d,
      onResume: f,
      onSwipeStart: u,
      onSwipeMove: p,
      onSwipeCancel: m,
      onSwipeEnd: h,
      ...g
    } = e, v = Ho(Tn, n), [b, w] = l.useState(null), y = W(t, (k) => w(k)), x = l.useRef(null), E = l.useRef(null), S = r || v.duration, R = l.useRef(0), M = l.useRef(S), P = l.useRef(0), { onToastAdd: T, onToastRemove: D } = v, O = q(() => {
      b?.contains(document.activeElement) && v.viewport?.focus(), i();
    }), B = l.useCallback(
      (k) => {
        !k || k === 1 / 0 || (window.clearTimeout(P.current), R.current = (/* @__PURE__ */ new Date()).getTime(), P.current = window.setTimeout(O, k));
      },
      [O]
    );
    l.useEffect(() => {
      const k = v.viewport;
      if (k) {
        const G = () => {
          B(M.current), f?.();
        }, L = () => {
          const H = (/* @__PURE__ */ new Date()).getTime() - R.current;
          M.current = M.current - H, window.clearTimeout(P.current), d?.();
        };
        return k.addEventListener(Vr, L), k.addEventListener(Hr, G), () => {
          k.removeEventListener(Vr, L), k.removeEventListener(Hr, G);
        };
      }
    }, [v.viewport, S, d, f, B]), l.useEffect(() => {
      a && !v.isClosePausedRef.current && B(S);
    }, [a, S, v.isClosePausedRef, B]), l.useEffect(() => (T(), () => D()), [T, D]);
    const K = l.useMemo(() => b ? Lp(b) : null, [b]);
    return v.viewport ? /* @__PURE__ */ z(Se, { children: [
      K && /* @__PURE__ */ c(
        RP,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": o === "foreground" ? "assertive" : "polite",
          children: K
        }
      ),
      /* @__PURE__ */ c(SP, { scope: n, onClose: O, children: cn.createPortal(
        /* @__PURE__ */ c(ms.ItemSlot, { scope: n, children: /* @__PURE__ */ c(
          wh,
          {
            asChild: !0,
            onEscapeKeyDown: N(s, () => {
              v.isFocusedToastEscapeKeyDownRef.current || O(), v.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ c(
              A.li,
              {
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": v.swipeDirection,
                ...g,
                ref: y,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: N(e.onKeyDown, (k) => {
                  k.key === "Escape" && (s?.(k.nativeEvent), k.nativeEvent.defaultPrevented || (v.isFocusedToastEscapeKeyDownRef.current = !0, O()));
                }),
                onPointerDown: N(e.onPointerDown, (k) => {
                  k.button === 0 && (x.current = { x: k.clientX, y: k.clientY });
                }),
                onPointerMove: N(e.onPointerMove, (k) => {
                  if (!x.current) return;
                  const G = k.clientX - x.current.x, L = k.clientY - x.current.y, H = !!E.current, $ = ["left", "right"].includes(v.swipeDirection), I = ["left", "up"].includes(v.swipeDirection) ? Math.min : Math.max, j = $ ? I(0, G) : 0, ce = $ ? 0 : I(0, L), fe = k.pointerType === "touch" ? 10 : 2, pe = { x: j, y: ce }, de = { originalEvent: k, delta: pe };
                  H ? (E.current = pe, Wn(yP, p, de, {
                    discrete: !1
                  })) : li(pe, v.swipeDirection, fe) ? (E.current = pe, Wn(wP, u, de, {
                    discrete: !1
                  }), k.target.setPointerCapture(k.pointerId)) : (Math.abs(G) > fe || Math.abs(L) > fe) && (x.current = null);
                }),
                onPointerUp: N(e.onPointerUp, (k) => {
                  const G = E.current, L = k.target;
                  if (L.hasPointerCapture(k.pointerId) && L.releasePointerCapture(k.pointerId), E.current = null, x.current = null, G) {
                    const H = k.currentTarget, $ = { originalEvent: k, delta: G };
                    li(G, v.swipeDirection, v.swipeThreshold) ? Wn(CP, h, $, {
                      discrete: !0
                    }) : Wn(
                      xP,
                      m,
                      $,
                      {
                        discrete: !0
                      }
                    ), H.addEventListener("click", (I) => I.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        v.viewport
      ) })
    ] }) : null;
  }
), RP = (e) => {
  const { __scopeToast: t, children: n, ...o } = e, r = Ho(Tn, t), [a, i] = l.useState(!1), [s, d] = l.useState(!1);
  return _P(() => i(!0)), l.useEffect(() => {
    const f = window.setTimeout(() => d(!0), 1e3);
    return () => window.clearTimeout(f);
  }, []), s ? null : /* @__PURE__ */ c(ut, { asChild: !0, children: /* @__PURE__ */ c(To, { ...o, children: a && /* @__PURE__ */ z(Se, { children: [
    r.label,
    " ",
    n
  ] }) }) });
}, NP = "ToastTitle", Ap = l.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...o } = e;
    return /* @__PURE__ */ c(A.div, { ...o, ref: t });
  }
);
Ap.displayName = NP;
var PP = "ToastDescription", Dp = l.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...o } = e;
    return /* @__PURE__ */ c(A.div, { ...o, ref: t });
  }
);
Dp.displayName = PP;
var Ip = "ToastAction", Op = l.forwardRef(
  (e, t) => {
    const { altText: n, ...o } = e;
    return n.trim() ? /* @__PURE__ */ c($p, { altText: n, asChild: !0, children: /* @__PURE__ */ c(vs, { ...o, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${Ip}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
Op.displayName = Ip;
var kp = "ToastClose", vs = l.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...o } = e, r = EP(kp, n);
    return /* @__PURE__ */ c($p, { asChild: !0, children: /* @__PURE__ */ c(
      A.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: N(e.onClick, r.onClose)
      }
    ) });
  }
);
vs.displayName = kp;
var $p = l.forwardRef((e, t) => {
  const { __scopeToast: n, altText: o, ...r } = e;
  return /* @__PURE__ */ c(
    A.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": o || void 0,
      ...r,
      ref: t
    }
  );
});
function Lp(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((o) => {
    if (o.nodeType === o.TEXT_NODE && o.textContent && t.push(o.textContent), TP(o)) {
      const r = o.ariaHidden || o.hidden || o.style.display === "none", a = o.dataset.radixToastAnnounceExclude === "";
      if (!r)
        if (a) {
          const i = o.dataset.radixToastAnnounceAlt;
          i && t.push(i);
        } else
          t.push(...Lp(o));
    }
  }), t;
}
function Wn(e, t, n, { discrete: o }) {
  const r = n.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), o ? Qt(r, a) : r.dispatchEvent(a);
}
var li = (e, t, n = 0) => {
  const o = Math.abs(e.x), r = Math.abs(e.y), a = o > r;
  return t === "left" || t === "right" ? a && o > n : !a && r > n;
};
function _P(e = () => {
}) {
  const t = q(e);
  oe(() => {
    let n = 0, o = 0;
    return n = window.requestAnimationFrame(() => o = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(o);
    };
  }, [t]);
}
function TP(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function AP(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function mr(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var DP = Rp, Fp = Pp, Wp = Tp, zp = Ap, Bp = Dp, Vp = Op, Hp = vs;
const kA = DP, IP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  Fp,
  {
    ref: n,
    className: C(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:top-auto sm:right-0 sm:bottom-0 sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
IP.displayName = Fp.displayName;
const OP = et(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-2 overflow-hidden rounded-md border p-4 pr-6 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), kP = l.forwardRef(({ className: e, variant: t, ...n }, o) => /* @__PURE__ */ c(
  Wp,
  {
    ref: o,
    className: C(OP({ variant: t }), e),
    ...n
  }
));
kP.displayName = Wp.displayName;
const $P = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  Vp,
  {
    ref: n,
    className: C(
      "hover:bg-secondary focus:ring-ring group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors focus:ring-1 focus:outline-none disabled:pointer-events-none disabled:opacity-50",
      e
    ),
    ...t
  }
));
$P.displayName = Vp.displayName;
const LP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  Hp,
  {
    ref: n,
    className: C(
      "text-foreground/50 hover:text-foreground absolute top-1 right-1 rounded-md p-1 opacity-0 transition-opacity group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 focus:opacity-100 focus:ring-1 focus:outline-none group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ c(zm, { className: "h-4 w-4" })
  }
));
LP.displayName = Hp.displayName;
const FP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  zp,
  {
    ref: n,
    className: C("text-sm font-semibold [&+div]:text-xs", e),
    ...t
  }
));
FP.displayName = zp.displayName;
const WP = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ c(
  Bp,
  {
    ref: n,
    className: C("text-sm opacity-90", e),
    ...t
  }
));
WP.displayName = Bp.displayName;
var Gp = "Toggle", hs = l.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: o, onPressedChange: r, ...a } = e, [i, s] = ne({
    prop: n,
    onChange: r,
    defaultProp: o ?? !1,
    caller: Gp
  });
  return /* @__PURE__ */ c(
    A.button,
    {
      type: "button",
      "aria-pressed": i,
      "data-state": i ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: t,
      onClick: N(e.onClick, () => {
        e.disabled || s(!i);
      })
    }
  );
});
hs.displayName = Gp;
var zP = hs, ht = "ToggleGroup", [Kp, $A] = Q(ht, [
  Ye
]), Up = Ye(), gs = _.forwardRef((e, t) => {
  const { type: n, ...o } = e;
  if (n === "single")
    return /* @__PURE__ */ c(BP, { ...o, ref: t });
  if (n === "multiple")
    return /* @__PURE__ */ c(VP, { ...o, ref: t });
  throw new Error(`Missing prop \`type\` expected on \`${ht}\``);
});
gs.displayName = ht;
var [Yp, jp] = Kp(ht), BP = _.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, s] = ne({
    prop: n,
    defaultProp: o ?? "",
    onChange: r,
    caller: ht
  });
  return /* @__PURE__ */ c(
    Yp,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: _.useMemo(() => i ? [i] : [], [i]),
      onItemActivate: s,
      onItemDeactivate: _.useCallback(() => s(""), [s]),
      children: /* @__PURE__ */ c(Xp, { ...a, ref: t })
    }
  );
}), VP = _.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, s] = ne({
    prop: n,
    defaultProp: o ?? [],
    onChange: r,
    caller: ht
  }), d = _.useCallback(
    (u) => s((p = []) => [...p, u]),
    [s]
  ), f = _.useCallback(
    (u) => s((p = []) => p.filter((m) => m !== u)),
    [s]
  );
  return /* @__PURE__ */ c(
    Yp,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: i,
      onItemActivate: d,
      onItemDeactivate: f,
      children: /* @__PURE__ */ c(Xp, { ...a, ref: t })
    }
  );
});
gs.displayName = ht;
var [HP, GP] = Kp(ht), Xp = _.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: n,
      disabled: o = !1,
      rovingFocus: r = !0,
      orientation: a,
      dir: i,
      loop: s = !0,
      ...d
    } = e, f = Up(n), u = Oe(i), p = { role: "group", dir: u, ...d };
    return /* @__PURE__ */ c(HP, { scope: n, rovingFocus: r, disabled: o, children: r ? /* @__PURE__ */ c(
      xn,
      {
        asChild: !0,
        ...f,
        orientation: a,
        dir: u,
        loop: s,
        children: /* @__PURE__ */ c(A.div, { ...p, ref: t })
      }
    ) : /* @__PURE__ */ c(A.div, { ...p, ref: t }) });
  }
), so = "ToggleGroupItem", qp = _.forwardRef(
  (e, t) => {
    const n = jp(so, e.__scopeToggleGroup), o = GP(so, e.__scopeToggleGroup), r = Up(e.__scopeToggleGroup), a = n.value.includes(e.value), i = o.disabled || e.disabled, s = { ...e, pressed: a, disabled: i }, d = _.useRef(null);
    return o.rovingFocus ? /* @__PURE__ */ c(
      Cn,
      {
        asChild: !0,
        ...r,
        focusable: !i,
        active: a,
        ref: d,
        children: /* @__PURE__ */ c(di, { ...s, ref: t })
      }
    ) : /* @__PURE__ */ c(di, { ...s, ref: t });
  }
);
qp.displayName = so;
var di = _.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: n, value: o, ...r } = e, a = jp(so, n), i = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, s = a.type === "single" ? i : void 0;
    return /* @__PURE__ */ c(
      hs,
      {
        ...s,
        ...r,
        ref: t,
        onPressedChange: (d) => {
          d ? a.onItemActivate(o) : a.onItemDeactivate(o);
        }
      }
    );
  }
), KP = gs, UP = qp;
const Zp = et(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium hover:bg-muted hover:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-9 px-2 min-w-9",
        sm: "h-8 px-1.5 min-w-8",
        lg: "h-11 px-2.5 min-w-11"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function LA({
  className: e,
  variant: t,
  size: n,
  ...o
}) {
  return /* @__PURE__ */ c(
    zP,
    {
      "data-slot": "toggle",
      className: C(Zp({ variant: t, size: n, className: e })),
      ...o
    }
  );
}
const Jp = l.createContext({
  size: "default",
  variant: "default"
});
function FA({
  className: e,
  variant: t,
  size: n,
  children: o,
  ...r
}) {
  return /* @__PURE__ */ c(
    KP,
    {
      "data-slot": "toggle-group",
      "data-variant": t,
      "data-size": n,
      className: C(
        "group/toggle-group flex w-fit items-center rounded-md data-[variant=outline]:shadow-xs",
        e
      ),
      ...r,
      children: /* @__PURE__ */ c(Jp.Provider, { value: { variant: t, size: n }, children: o })
    }
  );
}
function WA({
  className: e,
  children: t,
  variant: n,
  size: o,
  ...r
}) {
  const a = l.useContext(Jp);
  return /* @__PURE__ */ c(
    UP,
    {
      "data-slot": "toggle-group-item",
      "data-variant": a.variant || n,
      "data-size": a.size || o,
      className: C(
        Zp({
          variant: a.variant || n,
          size: a.size || o
        }),
        "min-w-0 flex-1 shrink-0 rounded-none shadow-none first:rounded-l-md last:rounded-r-md focus:z-10 focus-visible:z-10 data-[variant=outline]:border-l-0 data-[variant=outline]:first:border-l",
        e
      ),
      ...r,
      children: t
    }
  );
}
var Go = "Tabs", [YP, zA] = Q(Go, [
  Ye
]), Qp = Ye(), [jP, bs] = YP(Go), em = l.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: o,
      onValueChange: r,
      defaultValue: a,
      orientation: i = "horizontal",
      dir: s,
      activationMode: d = "automatic",
      ...f
    } = e, u = Oe(s), [p, m] = ne({
      prop: o,
      onChange: r,
      defaultProp: a ?? "",
      caller: Go
    });
    return /* @__PURE__ */ c(
      jP,
      {
        scope: n,
        baseId: le(),
        value: p,
        onValueChange: m,
        orientation: i,
        dir: u,
        activationMode: d,
        children: /* @__PURE__ */ c(
          A.div,
          {
            dir: u,
            "data-orientation": i,
            ...f,
            ref: t
          }
        )
      }
    );
  }
);
em.displayName = Go;
var tm = "TabsList", nm = l.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: o = !0, ...r } = e, a = bs(tm, n), i = Qp(n);
    return /* @__PURE__ */ c(
      xn,
      {
        asChild: !0,
        ...i,
        orientation: a.orientation,
        dir: a.dir,
        loop: o,
        children: /* @__PURE__ */ c(
          A.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...r,
            ref: t
          }
        )
      }
    );
  }
);
nm.displayName = tm;
var om = "TabsTrigger", rm = l.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, disabled: r = !1, ...a } = e, i = bs(om, n), s = Qp(n), d = im(i.baseId, o), f = cm(i.baseId, o), u = o === i.value;
    return /* @__PURE__ */ c(
      Cn,
      {
        asChild: !0,
        ...s,
        focusable: !r,
        active: u,
        children: /* @__PURE__ */ c(
          A.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": f,
            "data-state": u ? "active" : "inactive",
            "data-disabled": r ? "" : void 0,
            disabled: r,
            id: d,
            ...a,
            ref: t,
            onMouseDown: N(e.onMouseDown, (p) => {
              !r && p.button === 0 && p.ctrlKey === !1 ? i.onValueChange(o) : p.preventDefault();
            }),
            onKeyDown: N(e.onKeyDown, (p) => {
              [" ", "Enter"].includes(p.key) && i.onValueChange(o);
            }),
            onFocus: N(e.onFocus, () => {
              const p = i.activationMode !== "manual";
              !u && !r && p && i.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
rm.displayName = om;
var am = "TabsContent", sm = l.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, forceMount: r, children: a, ...i } = e, s = bs(am, n), d = im(s.baseId, o), f = cm(s.baseId, o), u = o === s.value, p = l.useRef(u);
    return l.useEffect(() => {
      const m = requestAnimationFrame(() => p.current = !1);
      return () => cancelAnimationFrame(m);
    }, []), /* @__PURE__ */ c(ee, { present: r || u, children: ({ present: m }) => /* @__PURE__ */ c(
      A.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": d,
        hidden: !m,
        id: f,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: p.current ? "0s" : void 0
        },
        children: m && a
      }
    ) });
  }
);
sm.displayName = am;
function im(e, t) {
  return `${e}-trigger-${t}`;
}
function cm(e, t) {
  return `${e}-content-${t}`;
}
var XP = em, qP = nm, ZP = rm, JP = sm;
function BA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    XP,
    {
      "data-slot": "tabs",
      className: C("flex flex-col gap-2", e),
      ...t
    }
  );
}
function VA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    qP,
    {
      "data-slot": "tabs-list",
      className: C(
        "bg-muted text-muted-foreground inline-flex h-9 w-fit items-center justify-center rounded-lg p-[3px]",
        e
      ),
      ...t
    }
  );
}
function HA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    ZP,
    {
      "data-slot": "tabs-trigger",
      className: C(
        "data-[state=active]:bg-background dark:data-[state=active]:text-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring dark:data-[state=active]:border-input dark:data-[state=active]:bg-input/30 text-foreground dark:text-muted-foreground inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-2 py-1 text-sm font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-sm [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function GA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    JP,
    {
      "data-slot": "tabs-content",
      className: C("flex-1 outline-none", e),
      ...t
    }
  );
}
export {
  m_ as Accordion,
  g_ as AccordionContent,
  v_ as AccordionItem,
  h_ as AccordionTrigger,
  b_ as Alert,
  y_ as AlertDescription,
  C_ as AlertDialog,
  __ as AlertDialogAction,
  T_ as AlertDialogCancel,
  E_ as AlertDialogContent,
  P_ as AlertDialogDescription,
  R_ as AlertDialogFooter,
  M_ as AlertDialogHeader,
  Hg as AlertDialogOverlay,
  Vg as AlertDialogPortal,
  N_ as AlertDialogTitle,
  S_ as AlertDialogTrigger,
  w_ as AlertTitle,
  A_ as AspectRatio,
  I_ as Avatar,
  k_ as AvatarFallback,
  O_ as AvatarImage,
  $_ as Badge,
  ab as Breadcrumb,
  ub as BreadcrumbEllipsis,
  ib as BreadcrumbItem,
  cb as BreadcrumbLink,
  sb as BreadcrumbList,
  lb as BreadcrumbPage,
  db as BreadcrumbSeparator,
  Ze as Button,
  L_ as Calendar,
  My as CalendarDayButton,
  F_ as Card,
  V_ as CardAction,
  H_ as CardContent,
  B_ as CardDescription,
  G_ as CardFooter,
  W_ as CardHeader,
  z_ as CardTitle,
  K_ as Carousel,
  U_ as CarouselContent,
  Y_ as CarouselItem,
  X_ as CarouselNext,
  j_ as CarouselPrevious,
  Z_ as Checkbox,
  J_ as Collapsible,
  eT as CollapsibleContent,
  Q_ as CollapsibleTrigger,
  Ly as Command,
  rT as CommandDialog,
  iT as CommandEmpty,
  cT as CommandGroup,
  aT as CommandInput,
  dT as CommandItem,
  sT as CommandList,
  lT as CommandSeparator,
  uT as CommandShortcut,
  pT as ContextMenu,
  ST as ContextMenuCheckboxItem,
  xT as ContextMenuContent,
  vT as ContextMenuGroup,
  CT as ContextMenuItem,
  MT as ContextMenuLabel,
  hT as ContextMenuPortal,
  bT as ContextMenuRadioGroup,
  ET as ContextMenuRadioItem,
  RT as ContextMenuSeparator,
  NT as ContextMenuShortcut,
  gT as ContextMenuSub,
  yT as ContextMenuSubContent,
  wT as ContextMenuSubTrigger,
  mT as ContextMenuTrigger,
  Ty as Dialog,
  nT as DialogClose,
  Iy as DialogContent,
  $y as DialogDescription,
  oT as DialogFooter,
  Oy as DialogHeader,
  Dy as DialogOverlay,
  Ay as DialogPortal,
  ky as DialogTitle,
  tT as DialogTrigger,
  _T as DropdownMenu,
  kT as DropdownMenuCheckboxItem,
  DT as DropdownMenuContent,
  IT as DropdownMenuGroup,
  OT as DropdownMenuItem,
  FT as DropdownMenuLabel,
  TT as DropdownMenuPortal,
  $T as DropdownMenuRadioGroup,
  LT as DropdownMenuRadioItem,
  WT as DropdownMenuSeparator,
  zT as DropdownMenuShortcut,
  BT as DropdownMenuSub,
  HT as DropdownMenuSubContent,
  VT as DropdownMenuSubTrigger,
  AT as DropdownMenuTrigger,
  GT as Form,
  jT as FormControl,
  XT as FormDescription,
  KT as FormField,
  UT as FormItem,
  YT as FormLabel,
  qT as FormMessage,
  JT as HoverCard,
  e0 as HoverCardContent,
  QT as HoverCardTrigger,
  Gd as Input,
  t0 as InputGroup,
  n0 as InputGroupAddon,
  o0 as InputGroupButton,
  a0 as InputGroupInput,
  r0 as InputGroupText,
  s0 as InputGroupTextarea,
  aE as InputOTP,
  sE as InputOTPGroup,
  cE as InputOTPSeparator,
  iE as InputOTPSlot,
  GS as Label,
  c0 as Menubar,
  v0 as MenubarCheckboxItem,
  p0 as MenubarContent,
  d0 as MenubarGroup,
  m0 as MenubarItem,
  g0 as MenubarLabel,
  l0 as MenubarMenu,
  VE as MenubarPortal,
  u0 as MenubarRadioGroup,
  h0 as MenubarRadioItem,
  b0 as MenubarSeparator,
  w0 as MenubarShortcut,
  y0 as MenubarSub,
  C0 as MenubarSubContent,
  x0 as MenubarSubTrigger,
  f0 as MenubarTrigger,
  E0 as NavigationMenu,
  P0 as NavigationMenuContent,
  T0 as NavigationMenuIndicator,
  R0 as NavigationMenuItem,
  _0 as NavigationMenuLink,
  M0 as NavigationMenuList,
  N0 as NavigationMenuTrigger,
  mM as NavigationMenuViewport,
  A0 as Pagination,
  I0 as Popover,
  $0 as PopoverAnchor,
  k0 as PopoverContent,
  O0 as PopoverTrigger,
  F0 as Progress,
  z0 as RadioGroup,
  B0 as RadioGroupItem,
  G0 as ResizableHandle,
  H0 as ResizablePanel,
  V0 as ResizablePanelGroup,
  U0 as ScrollArea,
  lR as ScrollBar,
  j0 as Select,
  J0 as SelectContent,
  X0 as SelectGroup,
  eA as SelectItem,
  Q0 as SelectLabel,
  UR as SelectScrollDownButton,
  KR as SelectScrollUpButton,
  tA as SelectSeparator,
  Z0 as SelectTrigger,
  q0 as SelectValue,
  ZR as Separator,
  JR as Sheet,
  oA as SheetClose,
  tN as SheetContent,
  rN as SheetDescription,
  rA as SheetFooter,
  nN as SheetHeader,
  oN as SheetTitle,
  nA as SheetTrigger,
  iA as Sidebar,
  vA as SidebarContent,
  pA as SidebarFooter,
  hA as SidebarGroup,
  bA as SidebarGroupAction,
  wA as SidebarGroupContent,
  gA as SidebarGroupLabel,
  fA as SidebarHeader,
  uA as SidebarInput,
  dA as SidebarInset,
  yA as SidebarMenu,
  SA as SidebarMenuAction,
  EA as SidebarMenuBadge,
  CA as SidebarMenuButton,
  xA as SidebarMenuItem,
  MA as SidebarMenuSkeleton,
  RA as SidebarMenuSub,
  PA as SidebarMenuSubButton,
  NA as SidebarMenuSubItem,
  sA as SidebarProvider,
  lA as SidebarRail,
  mA as SidebarSeparator,
  cA as SidebarTrigger,
  ci as Skeleton,
  TA as Slider,
  IA as Switch,
  iP as Table,
  lP as TableBody,
  mP as TableCaption,
  pP as TableCell,
  dP as TableFooter,
  fP as TableHead,
  cP as TableHeader,
  uP as TableRow,
  BA as Tabs,
  GA as TabsContent,
  VA as TabsList,
  HA as TabsTrigger,
  nE as Textarea,
  kP as Toast,
  $P as ToastAction,
  LP as ToastClose,
  WP as ToastDescription,
  kA as ToastProvider,
  FP as ToastTitle,
  IP as ToastViewport,
  AA as Toaster,
  LA as Toggle,
  FA as ToggleGroup,
  WA as ToggleGroupItem,
  RN as Tooltip,
  PN as TooltipContent,
  rp as TooltipProvider,
  NN as TooltipTrigger,
  rb as badgeVariants,
  en as buttonVariants,
  C as cn,
  pM as navigationMenuTriggerStyle,
  Zp as toggleVariants,
  Ro as useFormField,
  Pv as useIsMobile,
  f_ as useShortHeight,
  zo as useSidebar
};
//# sourceMappingURL=index.js.map
